import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import moment from 'moment-timezone';
import humps from 'humps';
import { STATUS } from '../../../../../redux/constants';
import LastSeenDatePickerFilter from './LastSeenDatePickerFilter';
import FirstSeenDatePickerFilter from './FirstSeenDatePickerFilter';
import TypeFilter from './TypeFilter';
import QueryFilter from './QueryFilter';
import AnswerFilter from './AnswerFilter';
import {
  Menu,
  Dropdown,
  Spin,
  Table,
  Tabs,
  Button,
  Input,
  InputNumber,
  Modal,
  Select,
  Tooltip,
  Cascader,
  Space,
  DatePicker,
  Divider,
  Timeline,
  Row,
  Col,
  Form,
  Radio,
  Popover,
  Alert,
  Typography,
} from 'antd';
import Icon, {
  DownOutlined,
  SearchOutlined,
  LoadingOutlined,
  InfoCircleFilled,
  RotateLeftOutlined,
  QuestionCircleOutlined,
  InfoCircleOutlined,
  FolderOpenFilled,
} from '@ant-design/icons';
import cx from 'classnames';
import styles from './exploreResult.module.sass';
import enrichStyles from './enrich-result.module.sass';
import { saveAs } from 'file-saver';
import TagSelect from '../../../../../shared-components/TagSelect';
import { ReactComponent as no_results } from '../../../../../assets/icons/no_results.svg';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ReactComponent as download_icon } from '../../../../../assets/icons/Download.svg';
import { ReactComponent as TwitterLogoSVG } from '../../../../../assets/threat-ranking/threat-detail/twitter_logo.svg';
import live_icon from '../../../../../assets/icons/live.svg';
import {
  ReactComponent as CopySVG,
  ReactComponent as copy_icon,
} from '../../../../../assets/icons/Copy.svg';

import ProgressBar from '../../../../../shared-components/ProgressBar';
import {
  infoNotification,
  showNotification,
} from '../../../../../shared-components/Notifications';
import {
  BadgesSection,
  ValueIndicator,
  ValueIndicatorWithScore,
} from '../../../../HomeContainer/components/Home/IOCDetail';
import { ReactComponent as ExploreSVG } from '../../../../../assets/icons/Compass.svg';
import mixpanel from 'mixpanel-browser';
import { ReactComponent as ClockSVG } from '../../../../../assets/threat-ranking/threat-detail/clock.svg';
import { ReactComponent as RedDot } from '../../../../../assets/icons/Red_dot.svg';
import { ReactComponent as OrangeDot } from '../../../../../assets/icons/Orange_dot.svg';
import { ReactComponent as GreenDot } from '../../../../../assets/icons/Green_dot.svg';
import { ReactComponent as GrayDot } from '../../../../../assets/icons/Gray_dot.svg';
//import { ReactComponent as FilterFunnelSVG } from '../../../../assets/icons/FilterFunnelIcon.svg';
import { ReactComponent as FilterFunnelSVG } from '../../../../../assets/icons/FilterFunnelIcon.svg';
import { ReactComponent as LeftArrow } from '../../../../../assets/icons/LeftArrow.svg';
import { ReactComponent as RightArrow } from '../../../../../assets/icons/RightArrow.svg';
import { ReactComponent as TooltipSVG } from '../../../../../assets/icons/help.svg';
import Cookies from 'cookies-js';
import _, { indexOf } from 'lodash';
import { ReactComponent as SilentPushIOCLogoSVG } from '../../../../../assets/threat-ranking/threat-detail/sp_ioc_logo.svg';
import { extractDomainIoCsFromExploreData } from './utils';
import { extractIPIoCsFromExploreData } from './utils';
import { authClient } from '../../../../../redux/api/Client';
import { ColumnTitle } from '../../../../../shared-components/ColumnTitle';
import Tag from '../../../../../shared-components/Tag';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../../redux/actions/app';
import { m } from 'mappersmith/test';
import VersionCheck from '../../../../../shared-components/VersionCheck';
import { BackButton } from '../../../../../shared-components/BackButton';
import Monitor from '../../../../../shared-components/Monitor';
import { Link } from 'react-router-dom';
// import ExploreResultsDiversityTimetable from '../ExploreResultsDiversityTimetable';
import PermissionDeniedPage from '../../../../../shared-components/PermissionDeniedPage';
import LoadingSilentPush from '../../../../../shared-components/LoadingSilentPush';
import Panel from '../../../../../shared-components/Panel';
import PivotMatrix from '../../../../../shared-components/PivotOptions/PivotMatrix';
import { JSONViewer } from '../../../../../shared-components/JSONViewer';
import { incrementUIRequestsCounter } from '../../../../../redux/utils/websocket/incrementUIRequestsCounter';

function HostingInfrastructureASNsResult(props) {
  const {
    status,
    mergeAPIEnrichment: mergeAPIEnrichmentData,
    exploreAPIscoreDetails: exploreData,
    mergeAPIData: mergeData,
    exploreAPIANYIPscoreDetails: exploreAnyIPData,
    exploreAPIANYIPJobID: exploreAnyIPJobID,
    exploreAPIDensityDetails: densityData,
    exploreAPIDensityStatus: densityStatus,
    exploreAPIwhoisDetails: whoisData,
    whoisStatus,
    infraTagStatus,
    domainInfraTags,
    feeds,
    sources,
    IPEditableFeeds,
    IPEditableFeedsStatus,
    DomainEditableFeeds,
    DomainEditableFeedsStatus,
    URLEditableFeeds,
    URLEditableFeedsStatus,
    exploreFilters,
    exploreSorting,
    mySubscriptionPlan: mySubscriptionPlan,
    mySubscriptionPlanStatus: mySubscriptionPlanStatus,
    breadcrumbs,
    searchQuery,
  } = props;

  const { Text, Title } = Typography;
  const [pageTitle, setPageTitle] = useState('');

  const FilterFunnelIcon = ({ filtered, ...props }) => {
    const iconStyle = {
      width: 24,
      height: 24,
    };
    return (
      <Icon
        {...props}
        component={() => (
          <FilterFunnelSVG
            style={iconStyle}
            fill={filtered ? '#2B7FEE' : 'white'}
          />
        )}
      />
    );
  };

  const TooltipIcon = (props) => (
    <Icon component={TooltipSVG} fill={'white'} {...props} />
  );
  const CopyIcon = (props) => <Icon component={copy_icon} {...props} />;

  const DownloadIcon = (props) => <Icon component={download_icon} {...props} />;

  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const RiskScoreRedDot = (props) => (
    <Icon style={{ marginRight: '4px' }} component={RedDot} {...props} />
  );
  const RiskScoreOrangeDot = (props) => (
    <Icon style={{ marginRight: '4px' }} component={OrangeDot} {...props} />
  );
  const RiskScoreGreenDot = (props) => (
    <Icon style={{ marginRight: '4px' }} component={GreenDot} {...props} />
  );
  const RiskScoreGrayDot = (props) => (
    <Icon style={{ marginRight: '4px' }} component={GrayDot} {...props} />
  );

  const LeftArrowIcon = (props) => <Icon component={LeftArrow} {...props} />;
  const RightArrowIcon = (props) => <Icon component={RightArrow} {...props} />;

  const ExploreIcon = (props) => (
    <Icon
      component={() => (
        <ExploreSVG fill={'#3C9AE8'} style={{ width: 12, height: 12 }} />
      )}
    />
  );

  function useQuery() {
    let pathURL = new URL(searchQuery, 'https://silentpush.com');
    let URLParams = new URLSearchParams(pathURL.search);
    return URLParams;
    //return new URLSearchParams(useLocation().search);
  }

  const location = useLocation();
  const q = useQuery();

  const [form] = Form.useForm();
  const [name, setName] = useState(q.get('name'));
  const [type, setType] = useState(q.get('type'));
  const [queryType, setQueryType] = useState(q.get('queryType'));
  const [exportLimit, setExportLimit] = useState(100);
  const [exportFilter, setExportFilter] = useState('');
  const [columnStructure, setColumnStructure] = useState('default');
  //const [breadcrumbs, props.saveBreadCrumbs] = useState([{}]);
  // const [breadcrumbs, props.saveBreadCrumbs] = useState(
  //   breadcrumbs
  //     ? breadcrumbs
  //     : [],
  // );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [
    isEnrichCollectionSaveModalVisible,
    setIsEnrichCollectionSaveModalVisible,
  ] = useState(false);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [selectedDomainFeed, setSelectedDomainFeed] = useState(null);
  const [selectedIPFeed, setSelectedIPFeed] = useState(null);
  const [selectedDomainCollection, setSelectedDomainCollection] = useState(
    null,
  );
  const [selectedIPCollection, setSelectedIPCollection] = useState(null);
  const [nameOfNewFeed, setNameOfNewFeed] = useState('');
  const [nameOfNewExploreDomainFeed, setNameOfNewExploreDomainFeed] = useState(
    '',
  );
  const [nameOfNewExploreIPFeed, setNameOfNewExploreIPFeed] = useState('');
  const [
    nameOfNewExploreDomainCollection,
    setNameOfNewExploreDomainCollection,
  ] = useState('');
  const [
    nameOfNewExploreIPCollection,
    setNameOfNewExploreIPCollection,
  ] = useState('');

  const [customScoreOfNewFeed, setCustomScoreOfNewFeed] = useState(0);
  const [tagOfNewFeed, setTagOfNewFeed] = useState([]);
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [monitorModalVisible, setMonitorModalVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState();
  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [indexOfCurrentBreadCrumb, setIndexOfCurrentBreadcrumb] = useState(0);
  const [hasClickedOnBreadcrumb, setHasClickedOnBreadcrumb] = useState(false);
  const [previousLookup, setPreviousLookup] = useState('');
  const [showExploreSaveFeedModal, setShowExploreSaveFeedModal] = useState(
    false,
  );
  const [
    showExploreSaveCollectionModal,
    setShowExploreSaveCollectionModal,
  ] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [domainFeedSave, setDomainFeedSave] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [ipFeedSave, setIPFeedSave] = useState(true);
  const [currentQuery, setCurrentQuery] = useState('');
  const [currentSkipAmount, setCurrentSkipAmount] = useState(0);
  const [monitorName, setMonitorName] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [selectedAdvancedQuery, setSelectedAdvancedQuery] = useState(null);
  const [selectedAdvancedAnswer, setSelectedAdvancedAnswer] = useState(null);
  const [timeUnitInPixels, setTimeUnitInPixels] = useState(0);
  const [lowestFirstSeenEpoch, setLowestFirstSeenEpoch] = useState(0);
  const [highestLastSeenEpoch, setHighestLastSeenEpoch] = useState(0);
  const [sorting, setSorting] = useState({
    last_seen: '',
    first_seen: '',
    query: '',
    answer: '',
  });

  const [hasSorted, setHasSorted] = useState(false);
  const [hasFiltered, setHasFiltered] = useState(false);

  let fromFilterNumber = null;
  let toFilterNumber = null;

  const [toFilterDate, setToFilterDate] = useState('');
  const [fromFilterDate, setFromFilterDate] = useState('');
  const [isNewFeedModalVisible, setIsNewFeedModalVisible] = useState(false);
  const [vendorOfNewFeed, setVendorOfNewFeed] = useState(null);
  const [
    isNewCollectionModalVisible,
    setIsNewCollectionModalVisible,
  ] = useState(false);
  const [nameOfNewCollection, setNameOfNewCollection] = useState('');
  const [vendorOfNewCollection, setVendorOfNewCollection] = useState(null);
  const [customScoreOfCollection, setCustomScoreOfCollection] = useState(0);
  const [ipDiversityWindow, setIpDiversityWindow] = useState(
    q.get('window') ?? '30',
  );
  const isJobIDPollingRunning = useRef(false);
  const interval = useRef(null);

  const [
    isNewExploreSaveFeedModalVisible,
    setIsNewExploreSaveFeedModalVisible,
  ] = useState(false);
  const [
    isNewExploreSaveCollectionModalVisible,
    setIsNewExploreSaveCollectionModalVisible,
  ] = useState(false);
  const [jobID, setJobID] = useState(null);
  const resultFileUUID = useRef(null);
  const monitorQueryName = useRef(null);
  const resultFileCreatedAt = useRef(null);
  const resultFileIocsCount = useRef(null);
  const [resultsTotal, setResultsTotal] = useState(0);
  const [pageResultsTotal, setPageResultsTotal] = useState(0);
  const dispatch = useDispatch();
  const historyQueryUUID = useRef(null);
  const hasSubscriptionDataloaded = useRef(false);
  // const queryOrigin = useRef(null);

  const handleSaveToNewFeed = ({
    containerState,
    containerName,
    iocType,
    customScore,
    containerVendor,
    setModalVisibility,
  }) => {
    let data = {
      state: containerState, // FEED or COLLECTION,
      name: containerName,
      threat_type: iocType,
      custom_score: customScore,
    };
    if (containerVendor) {
      data = {
        ...data,
        vendor: containerVendor,
      };
    }
    const res = props.createEmptySource(data);
    setModalVisibility(false);
  };

  useEffect(() => {
    document.title = 'Explore Indicator DNS Data - Silent Push';
    // props.clearExploreDetails();
    // props.loadMySubscriptionPlan();

    // dispatch(changeTitle('Explore'));
  }, []);

  useEffect(() => {
    // if (!sources || sources.length === 0) {
    //   return () => {};
    // }
    // const newFeed = sources[0];
    // if (
    //   newFeed.name !== nameOfNewFeed &&
    //   newFeed.name !== nameOfNewCollection
    // ) {
    //   return () => {};
    // }
    // const iocToAdd = {
    //   ...mergeAPIEnrichmentData,
    //   feed_uuid: newFeed.uuid,
    // };
    // props.addIOCJson(iocToAdd);
    // if (['domain', 'url', 'ip'].indexOf(type) > -1) {
    //   mixpanel.track('Saved to Feed', {
    //     location: 'enrich',
    //     'ioc name': selectedFeed?.name,
    //     'ioc uuid': selectedFeed?.uuid,
    //   });
    // } else {
    //   mixpanel.track('Saved to Feed', {
    //     location: 'explore results',
    //     'ioc name': selectedFeed?.name,
    //     'ioc uuid': selectedFeed?.uuid,
    //   });
    // }
    // setIsNewFeedModalVisible(false);
  }, [sources]);

  useEffect(() => {
    if (
      mergeAPIEnrichmentData?.type === 'url' &&
      mergeAPIEnrichmentData?.ioc_template === 'domain' &&
      mergeAPIEnrichmentData?.ioc_name
    ) {
      const urlToQuery =
        mergeAPIEnrichmentData?.ioc_name.startsWith('http://') ||
        mergeAPIEnrichmentData?.ioc_name.startsWith('https://') ||
        mergeAPIEnrichmentData?.ioc_name.includes('/')
          ? new URL(mergeAPIEnrichmentData?.ioc_name)?.host
          : mergeAPIEnrichmentData?.ioc_name;

      props.loadMergeAPIDomainInfraTags(urlToQuery, 0);
    }
  }, [mergeAPIEnrichmentData]);

  const saveToDropdownOptions = [
    {
      value: 'collection',
      label: 'Collection',
      children: [
        {
          value: 'new_collection',
          label: 'New',
        },
        {
          value: 'existing_collection',
          label: 'Existing Collection',
        },
      ],
    },
    {
      value: 'feed',
      label: 'Feed',
      children: [
        {
          value: 'new_feed',
          label: 'New',
        },
        {
          value: 'existing_feed',
          label: 'Existing Feed',
        },
      ],
    },
  ];

  const handleSaveFromExploreToFeedOrCollection = (data) => {
    const [_, action] = data;
    if (action === 'existing_feed') {
      setShowExploreSaveFeedModal(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'existing_collection') {
      setShowExploreSaveCollectionModal(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_feed') {
      setIsNewExploreSaveFeedModalVisible(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_collection') {
      setIsNewExploreSaveCollectionModalVisible(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    }
  };

  const handleSaveToFeedOrCollection = (data) => {
    const [_, action] = data;
    if (action === 'existing_feed') {
      setIsModalVisible(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'existing_collection') {
      setIsEnrichCollectionSaveModalVisible(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_feed') {
      setIsNewFeedModalVisible(true);
      mixpanel.track('Save to Feed Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else if (action === 'new_collection') {
      setIsNewCollectionModalVisible(true);
      mixpanel.track('Save to Collection Attempt', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    }
  };

  const handleQueryFilterSubmit = (queryFilter) => {
    if (!queryFilter) return;
    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
      props.loadHostingInfrastructureASNsRecipeResults({
        path: currentQuery?.replace(
          'explore-recipes/hosting-infra-asns-recipes/query/',
          '',
        ),
        exploreFilters: { ...exploreFilters, query: queryFilter },
        exploreSorting,
      });
    } else {
      props.loadMergeAPIExploreDetails({
        path: currentQuery,
        exploreFilters: { ...exploreFilters, query: queryFilter },
        exploreSorting,
      });
    }
  };

  const handleQueryFilter = (queryFilter) => {
    if (!queryFilter) return;

    const filteredData =
      type === 'anyIP'
        ? exploreAnyIPData?.filter((entry) =>
            entry?.query
              .toString()
              .toLowerCase()
              .includes(queryFilter.toLowerCase()),
          )
        : exploreData?.response?.records?.filter((entry) =>
            entry?.query
              ?.toString()
              ?.toLowerCase()
              ?.includes(queryFilter?.toLowerCase()),
          );

    setDataSource(filteredData);
  };

  const handleAnswerFilterSubmit = (answerFilter) => {
    if (!answerFilter) return;
    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
      props.loadHostingInfrastructureASNsRecipeResults({
        path: currentQuery?.replace(
          'explore-recipes/hosting-infra-asns-recipes/query/',
          '',
        ),
        exploreFilters: { ...exploreFilters, answer: answerFilter },
        exploreSorting,
      });
    } else {
      props.loadMergeAPIExploreDetails({
        path: currentQuery,
        exploreFilters: { ...exploreFilters, answer: answerFilter },
        exploreSorting,
      });
    }
  };

  const handleAnswerFilter = (answerFilter) => {
    if (!answerFilter) return;

    const filteredData =
      type === 'anyIP'
        ? exploreAnyIPData?.filter((entry) =>
            entry?.answer
              .toString()
              .toLowerCase()
              .includes(answerFilter.toLowerCase()),
          )
        : exploreData?.response?.records?.filter((entry) =>
            entry?.answer
              ?.toString()
              ?.toLowerCase()
              ?.includes(answerFilter?.toLowerCase()),
          );

    setDataSource(filteredData);
  };

  const handleFirstSeenDateFilterSubmit = (dates) => {
    if (!dates || !dates.length) return;
    if (type !== 'anyIP') {
      if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
        props.loadHostingInfrastructureASNsRecipeResults({
          path: currentQuery?.replace(
            'explore-recipes/hosting-infra-asns-recipes/query/',
            '',
          ),
          exploreFilters: {
            ...exploreFilters,
            first_seen_from: dates[0]
              .utcOffset(0)
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .toISOString(),
            first_seen_to: dates[1]
              .utcOffset(0)
              .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
              .toISOString(),
          },
          exploreSorting,
        });
      } else {
        props.loadMergeAPIExploreDetails({
          path: currentQuery,
          exploreFilters: {
            ...exploreFilters,
            first_seen_from: dates[0]
              .utcOffset(0)
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .toISOString(),
            first_seen_to: dates[1]
              .utcOffset(0)
              .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
              .toISOString(),
          },
          exploreSorting,
        });
      }
    } else {
      props.loadMergeAPIExploreAnyIPDetails({
        path1: 'padns/lookup/query/PTR4/' + currentQuery?.split('/')?.pop(),
        path2: 'padns/lookup/answer/A/' + currentQuery?.split('/')?.pop(),
        exploreFilters: {
          ...exploreFilters,
          first_seen_from: dates[0]
            .utcOffset(0)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toISOString(),
          first_seen_to: dates[1]
            .utcOffset(0)
            .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
            .toISOString(),
        },
        exploreSorting,
      });
    }
  };

  const handleLastSeenDateFilterSubmit = (dates) => {
    if (!dates || !dates.length) return;
    if (type !== 'anyIP') {
      if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
        props.loadHostingInfrastructureASNsRecipeResults({
          path: currentQuery?.replace(
            'explore-recipes/hosting-infra-asns-recipes/query/',
            '',
          ),
          exploreFilters: {
            ...exploreFilters,
            last_seen_from: dates[0]
              .utcOffset(0)
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .toISOString(),
            last_seen_to: dates[1]
              .utcOffset(0)
              .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
              .toISOString(),
          },
          exploreSorting,
        });
      } else {
        props.loadMergeAPIExploreDetails({
          path: currentQuery,
          exploreFilters: {
            ...exploreFilters,
            last_seen_from: dates[0]
              .utcOffset(0)
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .toISOString(),
            last_seen_to: dates[1]
              .utcOffset(0)
              .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
              .toISOString(),
          },
          exploreSorting,
        });
      }
    } else {
      props.loadMergeAPIExploreAnyIPDetails({
        path1: 'padns/lookup/query/PTR4/' + currentQuery?.split('/')?.pop(),
        path2: 'padns/lookup/answer/A/' + currentQuery?.split('/')?.pop(),
        exploreFilters: {
          ...exploreFilters,
          last_seen_from: dates[0]
            .utcOffset(0)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toISOString(),
          last_seen_to: dates[1]
            .utcOffset(0)
            .set({ hour: 23, minute: 59, second: 59, millisecond: 99 })
            .toISOString(),
        },
        exploreSorting,
      });
    }
  };

  const handleCountFilterSubmit = (countFrom, countTo) => {
    if (!countFrom && !countTo) return;

    props.loadMergeAPIExploreDetails({
      path: currentQuery,
      exploreFilters: {
        ...exploreFilters,
        count_from: countFrom,
        count_to: countTo,
      },
      exploreSorting,
    });
  };

  const handleCountFilter = (countFrom, countTo) => {
    if (!countFrom && !countTo) return;

    const filteredData =
      type === 'anyIP'
        ? exploreAnyIPData?.filter(
            (record) => record?.count >= countFrom && record?.count <= countTo,
          )
        : exploreData?.response?.records?.filter(
            (record) => record?.count >= countFrom && record?.count <= countTo,
          );

    setDataSource(filteredData);
  };

  const handleTypeFilter = (typeToFilter) => {
    if (!typeToFilter) return;

    const filteredData =
      type === 'anyIP'
        ? exploreAnyIPData?.filter((record) => record?.type === typeToFilter)
        : exploreData?.response?.records?.filter(
            (record) => record?.type === typeToFilter,
          );

    setDataSource(filteredData);
  };

  const handleTypeFilterSubmit = (typeToFilter) => {
    if (!typeToFilter) return;

    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
      props.loadHostingInfrastructureASNsRecipeResults({
        path: currentQuery?.replace(
          'explore-recipes/hosting-infra-asns-recipes/query/',
          '',
        ),
        exploreFilters: { ...exploreFilters, type: typeToFilter },
        exploreSorting,
      });
    } else {
      props.loadMergeAPIExploreDetails({
        path: currentQuery,
        exploreFilters: { ...exploreFilters, type: typeToFilter },
        exploreSorting,
      });
    }
  };

  const handleQueryFilterReset = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, query: null },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: { ...exploreFilters, query: null },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, query: null },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, query: null },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '?skip=' + skipAmount,
            exploreFilters: { ...exploreFilters, query: null },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, query: null },
          exploreSorting,
        });
      }
    }
  };

  const handleAnswerFilterReset = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, answer: null },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: { ...exploreFilters, answer: null },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, answer: null },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, answer: null },
            exploreSorting,
          });
        }
        props.loadMergeAPIExploreDetails({
          path: currentQuery + '?skip=' + skipAmount,
          exploreFilters: { ...exploreFilters, answer: null },
          exploreSorting,
        });
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, answer: null },
          exploreSorting,
        });
      }
    }
  };

  const handleFirstSeenDateFilterReset = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: {
              ...exploreFilters,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: {
              ...exploreFilters,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: {
            ...exploreFilters,
            first_seen_from: null,
            first_seen_to: null,
          },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: {
              ...exploreFilters,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting,
          });
        }
        props.loadMergeAPIExploreDetails({
          path: currentQuery + '?skip=' + skipAmount,
          exploreFilters: {
            ...exploreFilters,
            first_seen_from: null,
            first_seen_to: null,
          },
          exploreSorting,
        });
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: {
            ...exploreFilters,
            first_seen_from: null,
            first_seen_to: null,
          },
          exploreSorting,
        });
      }
    }
  };

  const handleLastSeenDateFilterReset = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostinInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: {
              ...exploreFilters,
              last_seen_from: null,
              last_seen_to: null,
            },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: {
              ...exploreFilters,
              last_seen_from: null,
              last_seen_to: null,
            },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: {
            ...exploreFilters,
            last_seen_from: null,
            last_seen_to: null,
          },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: {
              ...exploreFilters,
              last_seen_from: null,
              last_seen_to: null,
            },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '?skip=' + skipAmount,
            exploreFilters: {
              ...exploreFilters,
              last_seen_from: null,
              last_seen_to: null,
            },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: {
            ...exploreFilters,
            last_seen_from: null,
            last_seen_to: null,
          },
          exploreSorting,
        });
      }
    }
  };

  const handleCountFilterReset = () => {
    props.loadMergeAPIExploreDetails({
      path: currentQuery,
      exploreFilters: { ...exploreFilters, count_from: null, count_to: null },
      exploreSorting,
    });
  };

  const handleTypeFilterReset = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, type: null },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: { ...exploreFilters, type: null },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, type: null },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters, type: null },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '?skip=' + skipAmount,
            exploreFilters: { ...exploreFilters, type: null },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters, type: null },
          exploreSorting,
        });
      }
    }
  };

  const handleResetFilters = () => {
    const skipAmount = currentSkipAmount;
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path: currentQuery?.replace(
              'explore-recipes/hosting-infra-asns-recipes/query/',
              '',
            ),
            exploreFilters: {
              ...exploreFilters,
              query: null,
              answer: null,
              count_from: null,
              count_to: null,
              feed: null,
              type: null,
              last_seen_from: null,
              last_seen_to: null,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting: null,
          });
          setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery,
            exploreFilters: {
              ...exploreFilters,
              query: null,
              answer: null,
              count_from: null,
              count_to: null,
              feed: null,
              type: null,
              last_seen_from: null,
              last_seen_to: null,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting: null,
          });

          setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1: 'padns/lookup/query/PTR4/' + currentQuery?.split('/')?.pop(),
          path2: 'padns/lookup/answer/A/' + currentQuery?.split('/')?.pop(),
          exploreFilters: {
            ...exploreFilters,
            query: null,
            answer: null,
            count_from: null,
            count_to: null,
            feed: null,
            type: null,
            last_seen_from: null,
            last_seen_to: null,
            first_seen_from: null,
            first_seen_to: null,
          },
          exploreSorting: null,
        });
        setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path: currentQuery?.replace(
              'explore-recipes/hosting-infra-asns-recipes/query/',
              '',
            ),
            exploreFilters: {
              ...exploreFilters,
              query: null,
              answer: null,
              count_from: null,
              count_to: null,
              feed: null,
              type: null,
              last_seen_from: null,
              last_seen_to: null,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting: null,
          });
          setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery,
            exploreFilters: {
              ...exploreFilters,
              query: null,
              answer: null,
              count_from: null,
              count_to: null,
              feed: null,
              type: null,
              last_seen_from: null,
              last_seen_to: null,
              first_seen_from: null,
              first_seen_to: null,
            },
            exploreSorting: null,
          });
          setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1: 'padns/lookup/query/PTR4/' + currentQuery?.split('/')?.pop(),
          path2: 'padns/lookup/answer/A/' + currentQuery?.split('/')?.pop(),
          exploreFilters: {
            ...exploreFilters,
            query: null,
            answer: null,
            count_from: null,
            count_to: null,
            feed: null,
            type: null,
            last_seen_from: null,
            last_seen_to: null,
            first_seen_from: null,
            first_seen_to: null,
          },
          exploreSorting: null,
        });
        setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
      }
    }
    setExportFilter('');
  };

  const searchInput = useRef(null);

  const showExportModal = () => {
    if (!mySubscriptionPlan?.has_access_to_explore) {
      return;
    }
    setExportModalVisible(true);
  };

  const handleModalCancel = () => {
    setExportModalVisible(false);
    setMonitorModalVisible(false);
    setMonitorName('');
  };

  function handleNameFilterReset() {
    type === 'anyIP'
      ? setDataSource(exploreAnyIPData)
      : setDataSource(exploreData?.response?.records);
    setExportFilter('');
  }

  useEffect(() => {
    // sessionStorage.setItem('breadcrumbs', JSON.stringifybreadcrumbs);
  }, [breadcrumbs]);

  useEffect(() => {
    if (exploreData?.response?.records?.[0]?.timeline) {
      const diff =
        Math?.max(
          ...exploreData?.response?.records?.[0]?.timeline?.map((o) =>
            parseInt(new Date(o?.last_seen)?.getTime() / 1000),
          ),
        ) -
        Math?.min(
          ...exploreData?.response?.records?.[0]?.timeline?.map((o) =>
            parseInt(new Date(o?.first_seen)?.getTime() / 1000),
          ),
        );

      setTimeUnitInPixels(diff / 580);
      setLowestFirstSeenEpoch(
        Math.min(
          ...exploreData?.response?.records?.[0]?.timeline?.map((o) =>
            parseInt(new Date(o?.first_seen).getTime() / 1000),
          ),
        ),
      );
      setHighestLastSeenEpoch(
        Math.max(
          ...exploreData?.response?.records?.[0]?.timeline?.map((o) =>
            parseInt(new Date(o?.last_seen).getTime() / 1000),
          ),
        ),
      );
    }
  }, [exploreData]);

  useEffect(() => {
    // console.log('searchquery', searchQuery);
    // console.log('loaded', hasSubscriptionDataloaded.current);
    // if (hasSubscriptionDataloaded.current === false) {
    //hasSubscriptionDataloaded.current = true;
    props.clearExploreDetails();
    // props.saveBreadCrumbs(breadcrumbs);
    setSelectedAdvancedAnswer(null);
    setSelectedAdvancedQuery(null);
    props.loadUser();
    if (mySubscriptionPlan?.has_access_to_sources) {
      props.loadSources();
    }
    setType(q.get('type'));
    setName(q.get('name'));
    let qanswer = q.get('qanswer');
    let netmask = q.get('netmask');
    let subdomains = q.get('subdomains');
    let first_seen_before = q.get('first_seen_before');
    let first_seen_after = q.get('first_seen_after');
    let last_seen_before = q.get('last_seen_before');
    let last_seen_after = q.get('last_seen_after');
    let limit = q.get('limit');
    let sort = q.get('sort');
    let sort_by = q.get('sort_by');
    let order_by = q.get('order_by');
    let recipe = q.get('recipe');
    let nsname = q.get('nsname');
    if (nsname) {
      nsname = nsname?.split(',');
    }
    let asname = q.get('asname_contains');
    if (asname) {
      asname = asname.split(';');
    }
    let asnum = q.get('asnum');
    if (asnum) {
      asnum = asnum.split(',');
    }
    let asn = q.get('asn');
    let match = q.get('match');
    let net = q.get('net');
    let window = q?.get('window') ?? '30';
    if (window) {
      setIpDiversityWindow(window);
    }
    let additional_networks = q.get('additional_networks');
    if (additional_networks) {
      additional_networks = additional_networks?.split(',');
    }
    resultFileUUID.current = q?.get('resultFileUUID');
    historyQueryUUID.current = q?.get('historyQueryUUID');
    resultFileCreatedAt.current = q?.get('resultFileCreatedAt');
    resultFileIocsCount.current = q?.get('resultFileIocsCount');
    let queryBuilderURL = decodeURIComponent(q.get('queryBuilderURL'));
    let queryBuilderVisualization = decodeURIComponent(
      q.get('queryBuilderVisualization'),
    );
    let originalQueryURL = decodeURIComponent(q.get('originalQueryURL') ?? '');
    let visualizationType = q.get('visualizationType');
    let baseURLType = q.get('baseURLType');
    let keepExistingBreadcrumbs = q.get('keepExistingBreadcrumbs');
    let autospoof = q.get('autospoof');
    let regex = q.get('regex');
    let obj = {
      label: q.get('name'),
      value: {
        lookupObject: name,
        queryType: q.get('queryType'),
        //type: type,
        type: q.get('type'),
        netmask: netmask,
        resultFileUUID: resultFileUUID.current,
        originalQueryURL: originalQueryURL,
        //visualizationType: visualizationType,
        visualizationType: 'Brand Impersonation',
        baseURLType: baseURLType,
        historyQueryUUID: historyQueryUUID.current,
        recipe: recipe,
      },
    };
    setQueryType(q.get('queryType'));
    setColumnStructure(q.get('type'));

    if (q.get('queryType') === 'hosting_infrastructure_asn') {
      //setColumnStructure('dangling_dns_detection');

      const uldQuery =
        '?limit=' +
        (limit ? limit : '100') +
        '&domain=' +
        q?.get('name') +
        (type ? '&type=' + type : '') +
        (queryType ? '&queryType=' + queryType : '');

      let breadCrumbs = Object.assign([], breadcrumbs);
      const index = breadCrumbs.findIndex(
        (o) => o?.obj?.label === previousLookup,
      );
      if (index > 0) {
        breadCrumbs = breadCrumbs.slice(0, index + 1);
      }
      if (!breadCrumbs.find((o) => o?.obj?.label === obj.label)) {
        props.saveBreadCrumbs([...breadCrumbs, { obj, uldQuery }]);
      } else {
        props.saveBreadCrumbs([...breadCrumbs]);
      }

      // let breadCrumbs = Object.assign([], breadcrumbs);

      // const index = breadCrumbs.findIndex(
      //   (o) => o?.obj?.label === previousLookup,
      // );

      // if (index > 0) {
      //   breadCrumbs = breadCrumbs.slice(0, index + 1);
      // }

      // if (!breadCrumbs.find((o) => o?.obj?.label === obj.label)) {
      //   props.saveBreadCrumbs([...breadCrumbs, { obj }]);
      //   // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
      // } else {
      //   props.saveBreadCrumbs([...breadCrumbs]);
      //   // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
      // }

      props.loadHostingInfrastructureASNsRecipeResults({
        path:
          '?limit=' +
          (limit ? limit : '100') +
          '&domain=' +
          q?.get('name') +
          (type ? '&type=' + type : '') +
          (queryType ? '&queryType=' + queryType : ''),
        // +
        // '&foreign_targets_only=0' +
        // '&validate_danglers=1' +
        // '&qtype=' +
        // (q?.get('serverType') ? q?.get('serverType') : 'CNAME'),

        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      // setCurrentQuery(originalQueryURL);
      setCurrentQuery(
        'explore-recipes/hosting-infra-asns-recipes/query/' +
          '?limit=' +
          (limit ? limit : '100') +
          '&domain=' +
          q?.get('name') +
          (type ? '&type=' + type : '') +
          (queryType ? '&queryType=' + queryType : ''),

        // +
        // '&foreign_targets_only=0' +
        // '&validate_danglers=1' +
        // '&qtype=' +
        // (q?.get('serverType') ? q?.get('serverType') : 'CNAME')
      );
      setCurrentSkipAmount(0);
      incrementUIRequestsCounter();
    }
  }, [searchQuery, mySubscriptionPlanStatus]); // eslint-disable-line react-hooks/exhaustive-deps

  function constructSortingOptions(sortItem, sorted) {
    let order = null;
    if (sortItem.order === 'ascend') {
      order = '+';
      setSorting({ [sortItem.field]: sortItem.field + '/+' });
    } else if (sortItem.order === 'descend') {
      order = '-';
      setSorting({ [sortItem.field]: sortItem.field + '/-' });
    } else if (sortItem.order === null) {
      order = '';
      setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
    }
    const field =
      sortItem.field === 'total'
        ? sortItem.field
        : humps.decamelize(sortItem.field);
    sorted = `${field}/${order}`;

    return sorted;
  }

  const updateFilterAndSorting = (pagination, updatedFilters, sorting) => {
    let isFiltersUsed = Object.values(updatedFilters).some((el) => el !== null);
    let countFilter = updatedFilters['count'];
    let lastSeenFilter = updatedFilters['last_seen'];
    let firstSeenFilter = updatedFilters['first_seen'];

    let sorted = '';

    if (sorting.order) {
      sorted = constructSortingOptions(sorting, sorted);
      mixpanel.track('Column Sort', {
        location: 'threat ranking',
        column: sorting?.field + ' ' + sorting?.order,
      });
    } else if (sorting.length && sorting.length > 1) {
      for (var index in sorting) {
        let sort = sorting[index];
        sorted = constructSortingOptions(sort, sorted);
      }
    } else {
      setSorting({ last_seen: '', first_seen: '', query: '', answer: '' });
    }

    if (type !== 'anyIP') {
      if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
        props.loadHostingInfrastructureASNsRecipeResults({
          path: currentQuery?.replace(
            'explore-recipes/hosting-infra-asns-recipes/query/',
            '',
          ),
          exploreFilters: { ...exploreFilters },
          exploreSorting: sorted,
        });
      } else {
        props.loadMergeAPIExploreDetails({
          path: currentQuery,
          exploreFilters: { ...exploreFilters },
          exploreSorting: sorted,
        });
      }
    } else if (type === 'anyIP') {
      props.loadMergeAPIExploreAnyIPDetails({
        path1: 'padns/lookup/query/PTR4/' + currentQuery?.split('/')?.pop(),

        path2: 'padns/lookup/answer/A/' + currentQuery?.split('/')?.pop(),

        exploreFilters: { ...exploreFilters },
        exploreSorting: sorted,
      });
    }
    incrementUIRequestsCounter();
  };

  const defaultSortOrderCount = (sorting) => {
    switch (sorting.count) {
      case 'count/-':
        return 'descend';
      case 'count/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const defaultSortOrderType = (sorting) => {
    switch (sorting.type) {
      case 'type/-':
        return 'descend';
      case 'type/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const defaultSortOrderLastSeen = (sorting) => {
    switch (sorting.last_seen || exploreSorting) {
      case 'last_seen/-':
        return 'descend';
      case 'last_seen/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const defaultSortOrderFirstSeen = (sorting) => {
    switch (sorting.first_seen || exploreSorting) {
      case 'first_seen/-':
        return 'descend';
      case 'first_seen/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const defaultSortOrderQuery = (sorting) => {
    switch (sorting.query || exploreSorting) {
      case 'query/-':
        return 'descend';
      case 'query/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const defaultSortOrderAnswer = (sorting) => {
    switch (sorting.answer || exploreSorting) {
      case 'answer/-':
        return 'descend';
      case 'answer/+':
        return 'ascend';
      default:
        return null;
    }
  };

  const calculateTotalResults = () => {
    if (type === 'monitoringResults') {
      return resultFileIocsCount.current;
    }
    if (type === 'ssdeep') {
      return 'n/a';
    }
    if (type === 'historyQueryResults') {
      if (
        exploreData?.response?.metadata?.query_name ===
        'padns/search/ipdiversity'
      ) {
        return dataSource?.length;
      } else {
        return exploreData?.response?.metadata?.results_total_at_least;
      }
    }
    if (
      exploreData?.response?.metadata?.query_name === 'padns/search/ipdiversity'
    ) {
      return dataSource?.length;
    } else return exploreData?.response?.metadata?.results_total_at_least;
  };

  const calculateCurrentPageResults = () => {
    if (type === 'monitoringResults') {
      return resultFileIocsCount.current;
    }
    if (queryType == 'dangling_dns_detection') return dataSource?.length;
    if (type === 'historyQueryResults') {
      if (
        exploreData?.response?.metadata?.query_name ===
        'padns/search/ipdiversity'
      ) {
        return dataSource?.length;
      } else {
        return exploreData?.response?.metadata?.results_returned;
      }
    }
    if (type === 'ssdeep') {
      return exploreData?.response?.ssdeep?.length;
    }
    if (
      exploreData?.response?.metadata?.query_name === 'padns/search/ipdiversity'
    ) {
      return dataSource?.length;
    } else return exploreData?.response?.metadata?.results_returned;
  };

  useEffect(() => {
    if (
      exploreData?.response?.records &&
      !exploreData?.response?.records?.[0]?.dangling &&
      !exploreData?.response?.records?.[0]?.domain_hosts_in_asn &&
      status === STATUS.LOADED
      // &&
    ) {
      if (
        exploreData?.response?.records &&
        exploreData?.response?.records[0]?.hasOwnProperty('timeline') &&
        exploreData?.response?.records[0]?.hasOwnProperty('host') &&
        queryType
      ) {
        let visualizationData = [];
        const temp = exploreData?.response?.records?.map((element, index) => {
          const temp2 = element?.timeline?.map((timelineElement, index) => {
            visualizationData.push({
              query: element?.host,
              answer: timelineElement?.ip,
              first_seen: timelineElement?.first_seen,
              last_seen: timelineElement?.last_seen,
              type: 'A',
            });
          });
        });

        setDataSource(visualizationData);

        handleQueryFilter(exploreFilters?.query);

        handleAnswerFilter(exploreFilters?.answer);

        handleTypeFilter(exploreFilters?.type);

        handleCountFilter(exploreFilters?.count_from, exploreFilters?.count_to);

        if (
          exploreData !== undefined &&
          exploreData?.response?.records !== undefined &&
          exploreData?.response?.records &&
          queryType !== 'nschanges' &&
          queryType !== 'ipdiversity' &&
          type !== 'ip' &&
          type !== 'domain' &&
          type !== 'url' &&
          props.riskScoreStatus !== STATUS.LOADED &&
          props.exploreASNStatus !== STATUS.LOADED
        ) {
          props.loadMergeAPIRiskScores({
            observables: visualizationData
              ? visualizationData
              : exploreData?.response?.records,
          });
          props.loadMergeAPIASNDetails({
            observables: visualizationData
              ? visualizationData
              : exploreData?.response?.records,
          });
        }
      } else if (exploreData?.response?.records && queryType) {
        setDataSource(exploreData?.response?.records);

        handleQueryFilter(exploreFilters?.query);

        handleAnswerFilter(exploreFilters?.answer);

        handleTypeFilter(exploreFilters?.type);

        handleCountFilter(exploreFilters?.count_from, exploreFilters?.count_to);

        if (
          exploreData !== undefined &&
          exploreData?.response?.records !== undefined &&
          exploreData?.response?.records &&
          queryType !== 'nschanges' &&
          queryType !== 'ipdiversity' &&
          type !== 'ip' &&
          type !== 'domain' &&
          type !== 'url' &&
          props.riskScoreStatus !== STATUS.LOADED &&
          props.exploreASNStatus !== STATUS.LOADED
        ) {
          props.loadMergeAPIRiskScores({
            observables: exploreData?.response?.records,
          });
          props.loadMergeAPIASNDetails({
            observables: exploreData?.response?.records,
          });
        }
      }
    }

    if (exploreData?.response?.ssdeep && status === STATUS.LOADED) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.ssdeep !== undefined &&
        exploreData?.response?.ssdeep &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        props.loadMergeAPIRiskScores({
          observables: exploreData?.response?.ssdeep,
        });
        props.loadMergeAPIASNDetails({
          observables: exploreData?.response?.ssdeep,
        });
      }

      setDataSource(exploreData?.response?.ssdeep);
    }

    if (
      exploreData?.response?.favicon &&
      exploreData?.response?.favicon?.length > 0 &&
      status === STATUS.LOADED
    ) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.favicon !== undefined &&
        exploreData?.response?.favicon &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        let visualizationData = [];
        const temp = Object.entries(exploreData?.response?.favicon?.[0])?.map(
          (element, index) => {
            const temp2 = element?.[1]?.map((secondLevelElement, index) => {
              visualizationData.push({
                ip: element?.[0],
                domain: secondLevelElement?.domain,
                favicon_md5: secondLevelElement?.favicon_md5,
                favicon_mmh3: secondLevelElement?.favicon_mmh3,
                favicon2_md5: secondLevelElement?.favicon2_md5,
                favicon2_mmh3: secondLevelElement?.favicon2_mmh3,
                scan_date: secondLevelElement?.scan_date,
              });
            });
          },
        );

        setDataSource(visualizationData);

        props.loadMergeAPIRiskScores({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.favicon,
        });
        props.loadMergeAPIASNDetails({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.favicon,
        });
      }
    }

    if (
      exploreData?.response?.jarm &&
      exploreData?.response?.jarm?.length > 0 &&
      status === STATUS.LOADED
    ) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.jarm !== undefined &&
        exploreData?.response?.jarm &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        let visualizationData = [];
        const temp = Object.entries(exploreData?.response?.jarm?.[0])?.map(
          (element, index) => {
            const temp2 = element?.[1]?.map((secondLevelElement, index) => {
              visualizationData.push({
                ip: element?.[0],
                domain: secondLevelElement?.domain,
                jarm_hash: secondLevelElement?.jarm_hash,
                port: secondLevelElement?.port,
                last_seen: secondLevelElement?.last_seen,
                redirect_to_https: secondLevelElement?.redirect_to_https?.toString(),
                server_banner: secondLevelElement?.server_banner,

                //     answer: timelineElement?.ip,
                //     first_seen: timelineElement?.first_seen,
                //     last_seen: timelineElement?.last_seen,
                //     type: 'A',
              });
            });
          },
        );

        setDataSource(visualizationData);

        props.loadMergeAPIRiskScores({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.jarm,
        });
        props.loadMergeAPIASNDetails({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.jarm,
        });
      }
    }

    if (
      exploreData?.response?.certificates &&
      exploreData?.response?.certificates?.length > 0 &&
      status === STATUS.LOADED
    ) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.certificates !== undefined &&
        exploreData?.response?.certificates &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        let visualizationData = [];
        const temp = Object.entries(
          exploreData?.response?.certificates?.[0],
        )?.map((element, index) => {
          const temp2 = element?.[1]?.map((secondLevelElement, index) => {
            visualizationData.push({
              ip: element?.[0],
              domain: secondLevelElement?.domain,
              scan_date: secondLevelElement?.scan_date,
              fingerprint_sha1: secondLevelElement?.fingerprint_sha1,
              issuer: secondLevelElement?.issuer,
              not_after: secondLevelElement?.not_after,
              not_before: secondLevelElement?.not_before,
            });
          });
        });

        setDataSource(visualizationData);

        props.loadMergeAPIRiskScores({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.certificates,
        });
        props.loadMergeAPIASNDetails({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.certificates,
        });
      }
    }

    if (
      exploreData?.response?.records?.[0]?.dangling &&
      exploreData?.response?.records?.[0]?.dangling?.length > 0 &&
      status === STATUS.LOADED
    ) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.records?.[0]?.dangling !== undefined &&
        exploreData?.response?.records?.[0]?.dangling &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        let visualizationData = [];
        const temp = exploreData?.response?.records?.map((element, index) => {
          const temp2 = element?.dangling?.map((secondLevelElement, index) => {
            //console.log(secondLevelElement)

            visualizationData.push({
              answer: secondLevelElement?.answer,
              query: secondLevelElement?.query,
              target: secondLevelElement?.target,
              target_domain_is_nxdomain: secondLevelElement?.target_domain_is_nxdomain?.toString(),
              type: secondLevelElement?.type,
              // domain: element?.domain,
              // asn: secondLevelElement?.[0],
              // asname: secondLevelElement?.[1],
              //     answer: timelineElement?.ip,
              //     first_seen: timelineElement?.first_seen,
              //     last_seen: timelineElement?.last_seen,
              //     type: 'A',
            });
          });
        });

        setDataSource(visualizationData);

        props.loadMergeAPIRiskScores({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.records?.[0]?.dangling,
        });
        props.loadMergeAPIASNDetails({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.records?.[0]?.dangling,
        });
      }
    }

    if (
      exploreData?.response?.records?.[0]?.domain_hosts_in_asn &&
      exploreData?.response?.records?.[0]?.domain_hosts_in_asn?.toString()
        ?.length > 0 &&
      status === STATUS.LOADED
    ) {
      if (
        exploreData !== undefined &&
        exploreData?.response?.records?.[0]?.domain_hosts_in_asn !==
          undefined &&
        exploreData?.response?.records?.[0]?.domain_hosts_in_asn &&
        queryType !== 'nschanges' &&
        queryType !== 'ipdiversity' &&
        type !== 'ip' &&
        type !== 'domain' &&
        type !== 'url' &&
        props.riskScoreStatus !== STATUS.LOADED &&
        props.exploreASNStatus !== STATUS.LOADED
      ) {
        let visualizationData = [];
        const temp = exploreData?.response?.records?.map((element, index) => {
          // const temp2 = Object.entries(element?.domain_asns)?.map(
          //   (secondLevelElement, index) => {
          // console.log(element);

          visualizationData.push({
            // answer: secondLevelElement?.answer,
            // query: secondLevelElement?.query,
            // target: secondLevelElement?.target,
            // target_domain_is_nxdomain: secondLevelElement?.target_domain_is_nxdomain?.toString(),
            // type: secondLevelElement?.type,
            // domain: element?.domain,
            asn: element?.asn,
            asn_size: element?.asn_size,
            asname: element?.asname,
            domain_hosts_in_asn: element?.domain_hosts_in_asn,
            //     answer: timelineElement?.ip,
            //     first_seen: timelineElement?.first_seen,
            //     last_seen: timelineElement?.last_seen,
            //     type: 'A',
          });
          // },
          // );
        });

        setDataSource(visualizationData);

        props.loadMergeAPIRiskScores({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.records?.[0]?.dangling,
        });
        props.loadMergeAPIASNDetails({
          observables: visualizationData
            ? visualizationData
            : exploreData?.response?.records?.[0]?.dangling,
        });
      }
    }

    if (
      type === 'NS' &&
      exploreData?.response?.metadata?.query_name?.includes('answer')
    ) {
      props.loadMergeAPIExploreDensity(
        'padns/lookup/density/nssrv/' + name + '?is_voluntary=0',
      );
    }

    if (exploreData?.response?.job_status?.job_id) {
      setJobID(exploreData?.response?.job_status?.job_id);
    }

    if (
      !exploreData?.response?.records?.[0]?.domain_hosts_in_asn?.toString()
        ?.length &&
      exploreData?.response?.records?.[0]?.dangling &&
      !exploreData?.response?.records?.[0]?.dangling?.length &&
      !exploreData?.response?.certificates?.length &&
      !exploreData?.response?.jarm?.length &&
      !exploreData?.response?.favicon?.length &&
      !exploreData?.response?.ssdeep?.length &&
      (!exploreData?.response?.records[0]?.hasOwnProperty('dangling')
        ? !exploreData?.response?.records?.length
        : true) &&
      //   // !exploreData?.response?.job_status?.job_id &&
      status === STATUS.LOADED
    ) {
      setDataSource([]);
    }

    setResultsTotal(calculateTotalResults());

    setPageResultsTotal(calculateCurrentPageResults());

    return () => clearInterval(interval.current);
  }, [status, exploreData, exploreFilters, exploreSorting]);

  useEffect(() => {
    if (exploreAnyIPData) {
      setDataSource(exploreAnyIPData);

      handleQueryFilter(exploreFilters?.query);

      handleAnswerFilter(exploreFilters?.answer);

      handleTypeFilter(exploreFilters?.type);

      handleCountFilter(exploreFilters?.count_from, exploreFilters?.count_to);
    }

    if (
      exploreAnyIPData !== undefined &&
      exploreAnyIPData?.response?.records !== undefined &&
      exploreAnyIPData?.response?.records &&
      queryType !== 'nschanges' &&
      queryType !== 'ipdiversity' &&
      type !== 'ip' &&
      type !== 'domain' &&
      type !== 'url'
    ) {
      props.loadMergeAPIRiskScores({ observables: exploreAnyIPData });
      props.loadMergeAPIASNDetails({ observables: exploreAnyIPData });
    }

    if (exploreAnyIPJobID) {
      setJobID(exploreAnyIPJobID);
    }
  }, [exploreAnyIPData]);

  function requestPrevResults() {
    window.scrollTo(0, 0);
    let skipAmount = currentSkipAmount - 100;
    if (skipAmount < 0) {
      skipAmount = 0;
    }
    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '?skip=' + skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
      }
    }
    setCurrentSkipAmount(skipAmount);
    mixpanel.track('Previous Page', {
      location: 'explore results',
      page: skipAmount / 100 + 1,
    });
    incrementUIRequestsCounter();
  }

  function requestNextResults() {
    window.scrollTo(0, 0);
    const skipAmount = currentSkipAmount + 100;

    if (currentQuery.includes('?')) {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        } else {
          props.loadMergeAPIExploreDetails({
            path: currentQuery + '&skip=' + skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        }
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '&skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
      }
    } else {
      if (type !== 'anyIP') {
        if (
          currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')
        ) {
          props.loadHostingInfrastructureASNsRecipeResults({
            path:
              currentQuery?.replace(
                'explore-recipes/hosting-infra-asns-recipes/query/',
                '',
              ) +
              '&skip=' +
              skipAmount,
            exploreFilters: { ...exploreFilters },
            exploreSorting,
          });
        }
        props.loadMergeAPIExploreDetails({
          path: currentQuery + '?skip=' + skipAmount,
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
      } else {
        props.loadMergeAPIExploreAnyIPDetails({
          path1:
            'padns/lookup/query/PTR4/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          path2:
            'padns/lookup/answer/A/' +
            currentQuery?.split('/')?.pop() +
            '?skip=' +
            skipAmount,
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
      }
    }
    setCurrentSkipAmount(skipAmount);
    mixpanel.track('Next Page', {
      location: 'explore results',
      page: skipAmount / 100 + 1,
    });
    incrementUIRequestsCounter();
  }

  function handleBackClick() {
    gotoLastBreadCrumb();
  }

  function retryURL() {
    const queryURL = new URL(name);
    let truncatedQuery = queryURL.hostname;

    props.history.push(
      '/explore-result?name=' +
        truncatedQuery +
        '&queryType=' +
        queryType +
        '&type=' +
        type,
    );
  }

  const enrichSaveDropdownMenu = (
    <Menu>
      <Menu.Item
        aria-label="colMenu"
        key="1"
        onClick={() => {
          setIsEnrichCollectionSaveModalVisible(true);
          mixpanel.track('Save to Collection Attempt', {
            location: 'enrich',
            'ioc name': props?.mergeAPIEnrichment?.ioc_name,
            'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
          });
        }}
      >
        Collection
      </Menu.Item>
      <Menu.Item
        aria-label="feedMenu"
        key="2"
        onClick={() => {
          setIsModalVisible(true);
          mixpanel.track('Save to Feed Attempt', {
            location: 'enrich',
            'ioc name': props?.mergeAPIEnrichment?.ioc_name,
            'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
          });
        }}
      >
        Feed
      </Menu.Item>
    </Menu>
  );

  const saveDropdownMenu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => {
          setShowExploreSaveCollectionModal(true);
          mixpanel.track('Save to Collection Attempt', {
            location: 'explore results',
            'ioc name': props?.mergeAPIEnrichment?.ioc_name,
            'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
          });
        }}
      >
        Collection
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={() => {
          setShowExploreSaveFeedModal(true);
          mixpanel.track('Save to Feed Attempt', {
            location: 'explore results',
            'ioc name': props?.mergeAPIEnrichment?.ioc_name,
            'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
          });
        }}
      >
        Feed
      </Menu.Item>
    </Menu>
  );

  function copyAPIURL(data) {
    navigator.clipboard.writeText(data);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
    mixpanel.track('Copy API URL', {
      location: 'explore results',
      query: name,
    });
  }

  function copyRawData(data) {
    navigator.clipboard.writeText(JSON.stringify(data));
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
    mixpanel.track('Copy Raw Data', {
      location: 'explore results',
      query: name,
    });
  }

  function copyExploreTableClipboard(rows) {
    if (!mySubscriptionPlan?.has_access_to_explore) {
      return;
    }
    let items = prepare_rows(selectedRowData ? selectedRowData : rows);
    navigator.clipboard.writeText(JSON.stringify(items));
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
    mixpanel.track('Copy Endpoint', {
      location: 'explore results',
      query: name,
    });
  }

  function exploreCopyToClipboard(IOCName) {
    navigator.clipboard.writeText(IOCName);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  const onChangeAdvancedQuery = (e) => {
    setSelectedAdvancedQuery(e.target.value);
    setSelectedAdvancedAnswer(null);
  };

  const onChangeAdvancedAnswer = (e) => {
    setSelectedAdvancedAnswer(e.target.value);
    setSelectedAdvancedQuery(null);
  };

  function colorBreadCrumb(breadcrumb) {
    // console.log('currentQuery', currentQuery);
    let trimmedURL = '';
    if (currentQuery?.includes('/typosquat')) {
      trimmedURL = currentQuery?.split('/')?.reverse()[1];
    } else if (currentQuery?.includes('/hosting-infra-asns-recipes/')) {
      trimmedURL = currentQuery?.split('&domain=')?.[1]?.split('&')?.[0];
      // if (currentQuery?.includes('&domain')) {
      //   trimmedURL = currentQuery?.split('&domain=')?.[1]?.split('&')?.[0];
      // }
      // if (currentQuery?.includes('&regex')) {
      //   trimmedURL = currentQuery?.split('&regex=')?.[1]?.split('&')?.[0];
      // }
      // trimmedURL = 'Recipe Result';
    } else if (currentQuery?.includes('/domain/asns')) {
      // const paramString
      trimmedURL = decodeURIComponent(currentQuery)
        ?.split('asnum=')?.[1]
        ?.split('&')?.[0];
      // const params = new URLSearchParams(paramString);
      // trimmedURL = params.get('domain');
      // console.log('trimmedurl', typeof trimmedURL);
    } else if (currentQuery?.includes('/domain/search')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = params.get('domain');
    } else if (currentQuery?.includes('?autospoof')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = params.get('autospoof');
    } else if (currentQuery?.includes('search/danglers')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = params.get('source');
    } else if (currentQuery?.includes('scandata/ipv4/jarm')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = params.get('jarm_hash');
    } else if (currentQuery?.includes('scandata/ipv4/certificates')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = currentQuery?.includes('&domain')
        ? params.get('domain')
        : params.get('ipv4');
    } else if (currentQuery?.includes('scandata/ipv4/favicon')) {
      const paramString = decodeURIComponent(currentQuery)?.split('?')[1];
      const params = new URLSearchParams(paramString);
      trimmedURL = currentQuery?.includes('&md5')
        ? params.get('md5')
        : params.get('mmh3');
    } else {
      trimmedURL = currentQuery
        ?.split('?')[0]
        ?.split('/')
        ?.pop()
        ?.split('?')[0];
    }

    let trimmedType = '';
    if (currentQuery?.includes('/typosquat')) {
      trimmedType = currentQuery?.split('?')[0]?.split('/')?.reverse()[2];
    } else if (currentQuery?.includes('dangling-dns-record-recipes')) {
      trimmedType = 'dangling_dns_detection';
    } else if (currentQuery?.includes('/domain/asns')) {
      trimmedType = 'asn';
    } else {
      trimmedType = currentQuery?.split('?')[0]?.split('/')?.reverse()[1];
    }

    var valueArr = breadcrumbs.map(function (item) {
      return item?.obj?.label;
    });
    var isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx;
    });
    // console.log('1', breadcrumb?.obj?.label);
    // console.log('1', typeof breadcrumb?.obj?.label);
    // console.log('2', trimmedURL);
    // console.log('2', typeof trimmedURL);

    // console.log('11', breadcrumb?.obj?.value?.type?.toLowerCase());
    // console.log('22', trimmedType);

    if (
      isDuplicate
        ? breadcrumb?.obj?.label?.toString() === trimmedURL?.toString() &&
          breadcrumb?.obj?.value?.type?.toLowerCase() ===
            trimmedType?.toLowerCase()
        : breadcrumb?.obj?.label?.toString() === trimmedURL?.toString()
    ) {
      return 'rgba(60, 154, 232, 1)';
    } else {
      return 'rgba(255, 255, 255, 0.95)';
    }
  }

  function breadCrumbs() {
    if (breadcrumbs?.length > 0) {
      return (
        <div
          data-cy="hostingInfrastructureASNsRecipeResultsBreadcrumb"
          className={styles.explore_result_breadcrumb_container}
        >
          <span separator=">">
            {breadcrumbs
              .filter((breadcrumb) => breadcrumb?.obj)
              .map((breadcrumb, index) => (
                <span
                  key={index}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setIndexOfCurrentBreadcrumb(index);
                    if (breadcrumb?.uldQuery) {
                      exploreLookup(
                        breadcrumb?.obj?.value?.lookupObject,
                        breadcrumb?.obj?.value?.queryType,
                        breadcrumb?.obj?.value?.type,
                        breadcrumb?.obj?.value?.resultFileUUID,
                        breadcrumb?.uldQuery,
                        breadcrumb?.obj?.value?.historyQueryUUID,
                      );
                    } else {
                      exploreLookup(
                        breadcrumb?.obj?.value?.lookupObject,
                        breadcrumb?.obj?.value?.queryType,
                        breadcrumb?.obj?.value?.type,
                        breadcrumb?.obj?.value?.resultFileUUID,
                        breadcrumb?.obj?.value?.originalQueryURL,
                        breadcrumb?.obj?.value?.baseURLType,
                        breadcrumb?.obj?.value?.historyQueryUUID,
                      );
                    }
                    setType(breadcrumb?.obj?.value?.type);
                    setHasClickedOnBreadcrumb(true);
                    setSelectedRowKeys([]);
                  }}
                >
                  <span>
                    <div
                      className={styles.breadcrumbLabel}
                      style={{
                        marginRight: '5px',
                        fontSize: '14px',
                        lineHeight: '16px',
                        color: colorBreadCrumb(breadcrumb),
                        display: 'inline-block',
                      }}
                    >
                      {breadcrumb.obj.value?.netmask &&
                      breadcrumb?.obj?.value?.queryType !== 'typosquat'
                        ? breadcrumb?.obj?.label +
                          '/' +
                          `${breadcrumb?.obj?.value?.netmask}`
                        : breadcrumb?.obj?.label}

                      {breadcrumbs?.length > 1 &&
                      index !== breadcrumbs?.length - 1
                        ? ' > '
                        : ''}
                      <p
                        style={{
                          fontSize: '12px',
                          color: colorBreadCrumb(breadcrumb),
                        }}
                      >
                        {determineBreadcrumbLabel(breadcrumb?.obj?.value?.type)}
                      </p>
                    </div>
                  </span>
                </span>
              ))}
          </span>
        </div>
      );
    }
  }

  function determineBreadcrumbLabel(breadcrumbType) {
    switch (breadcrumbType) {
      case 'typosquat':
        return 'Typosquatting';
      case 'nameintxt':
        return 'Name in TXT Record';
      case 'monitoringResults':
        return 'Monitoring';
      case 'historyQueryResults':
        return 'Query History';
      case 'queryBuilderVisualization':
        return 'Query Builder Result';
      default:
        return breadcrumbType;
    }
  }

  function gotoLastBreadCrumb() {
    props.saveBreadCrumbs(breadcrumbs);

    let tempBreadCrumbIndex = null;

    if (currentQuery) {
      if (currentQuery?.includes('/typosquat')) {
        tempBreadCrumbIndex = breadcrumbs?.findIndex(
          (o) => o?.obj?.value?.queryType === 'typosquat',
        );
      } else {
        let currentQueryTrimmed = currentQuery?.split('/')?.pop().split('?')[0];
        tempBreadCrumbIndex = breadcrumbs?.findIndex(
          (o) => o?.obj?.label === currentQueryTrimmed,
        );
      }
    }

    if (
      breadcrumbs?.length > 1 &&
      tempBreadCrumbIndex >= 1 &&
      //!(type === 'ip' || type === 'domain' || type === 'url') &&
      !q?.get('row') &&
      !q?.get('enrichQuery') &&
      !q?.get('nsChangeQuery') &&
      !q?.get('exploreQuery') &&
      !q?.get('recipe') &&
      !q?.get('fromMonitoring') &&
      !q?.get('fromQueryBuilder')
    ) {
      exploreLookup(
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.lookupObject,
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.queryType,
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.type,
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.resultFileUUID,
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.uldQuery
          ? breadcrumbs[
              tempBreadCrumbIndex
                ? tempBreadCrumbIndex - 1
                : breadcrumbs?.length - 2
            ]?.uldQuery
          : breadcrumbs[
              tempBreadCrumbIndex
                ? tempBreadCrumbIndex - 1
                : breadcrumbs?.length - 2
            ]?.obj?.value?.originalQueryURL,
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.historyQueryUUID,
      );

      setType(
        breadcrumbs[
          tempBreadCrumbIndex
            ? tempBreadCrumbIndex - 1
            : breadcrumbs?.length - 2
        ]?.obj?.value?.type,
      );

      setHasClickedOnBreadcrumb(true);
      setSelectedRowKeys([]);
    } else {
      setSelectedRowKeys([]);

      if (q?.get('row')) {
        props.history.push(`/?row=${q?.get('row')}`);
      } else if (q?.get('backLink')) {
        props.history.push(`${q?.get('backLink')}`);
      } else if (q?.get('enrichQuery')) {
        props.history.push(`${q?.get('enrichQuery')}`);
      } else if (q?.get('nsChangeQuery')) {
        props.history.push(`${q?.get('nsChangeQuery')}`);
      } else if (q?.get('exploreQuery')) {
        props.history.push(`${q?.get('exploreQuery')}`);
        // } else if (q?.get('headerSearchQuery')) {
        //   props.history.push(`${q?.get('headerSearchQuery')}`);
        //} else if (q?.get('recipe')) {
        //  props.history.push(`${q?.get('recipe')}`);
      } else if (q?.get('fromMonitoring')) {
        props.history.push('/monitoring');
      } else {
        props.history.push('/explore');
      }
    }
  }

  const options = [
    {
      value: 'query',
      label: 'Query',
      children: [
        {
          value: 'any',
          label: 'ANY',
        },
        {
          value: 'ANYIPV4',
          label: 'ANY (IPv4)',
        },
        {
          value: 'ANYIPV6',
          label: 'ANY (IPv6)',
        },
        {
          value: 'A',
          label: 'A',
        },
        {
          value: 'AAAA',
          label: 'AAAA',
        },
        {
          value: 'CNAME',
          label: 'CNAME',
        },
        {
          value: 'MX',
          label: 'MX',
        },
        {
          value: 'NS',
          label: 'NS',
        },
        {
          value: 'PTR4',
          label: 'PTR4',
        },
      ],
    },
    {
      value: 'answer',
      label: 'Answer',
      children: [
        {
          value: 'A',
          label: 'Reverse A',
        },
        {
          value: 'AAAA',
          label: 'Reverse AAAA',
        },
        {
          value: 'PTR4',
          label: 'Reverse PTR4',
        },
        {
          value: 'PTR6',
          label: 'Reverse PTR6',
        },
        {
          value: 'CNAME',
          label: 'Reverse CNAME',
        },
        {
          value: 'MX',
          label: 'Reverse MX',
        },
        {
          value: 'NS',
          label: 'Reverse NS',
        },
      ],
    },
  ];

  // to normalize local export columns structure with backend one
  const correct_order = [
    'query',
    'query_risk_score',
    'query_risk_score_decider',
    'query_asn',
    'query_as_name',
    'answer',
    'answer_risk_score',
    'answer_risk_score_decider',
    'answer_asn',
    'answer_as_name',
    'scan_date',
    'fingerprint_sha1',
    'issuer',
    'not_after',
    'not_before',
    'count',
    'first_seen',
    'last_seen',
    'mxhash',
    'nshash',
    'txthash',
    'ttl',
    'target',
    'target_domain_is_nxdomain',
    'type',
    'asn',
    'asn_size',
    'asname',
    'domain_hosts_in_asn',
  ];

  function prepare_rows_timelined(rows) {
    let timelined = false;
    if (rows[0]?.timeline) {
      timelined = true;
      rows = rows?.reduce((previous, current) => {
        return previous.concat(
          current?.timeline?.map((timelineElement, index) => {
            return {
              query: current?.host,
              answer: timelineElement?.ip,
              answer_asn: timelineElement.asn,
              answer_as_name: timelineElement.asname,
              first_seen: timelineElement?.first_seen,
              last_seen: timelineElement?.last_seen,
              type: 'A',
            };
          }),
        );
      }, []);
    }
    return [timelined, rows];
  }

  function prepare_rows(rows) {
    if (queryType === 'dangling_dns_detection') rows = rows[0]['dangling'];
    let [timelined, items] = prepare_rows_timelined(rows);
    if (selectedRowKeys?.length > 0) {
      items = [...selectedRowData];
      if (type === 'certificates')
        items = normalizeSelectedCertificateRows(items);
    } else {
      if (exportLimit > 0 && exportLimit <= getTotalResults()) {
        items = items?.slice(0, exportLimit);
      }
    }
    if (queryType === 'hosting_infrastructure_asn') return items;
    items.forEach((v, i) => {
      v = Object.entries(v);
      let answer_index = v.findIndex((e, i) => e[0] === 'answer');
      let answer_value = v[answer_index][1];
      v.splice(answer_index + 1, 0, [
        //inserts at index 1 (0 = no delete)...
        'answer_risk_score', //...the new element, ex: ['answer_risk_score', 9]
        props?.exploreRiskScores?.[answer_value]?.sp_risk_score ?? '-',
      ]);
      v.splice(answer_index + 2, 0, [
        'answer_risk_score_decider',
        props?.exploreRiskScores?.[answer_value]?.sp_risk_score_explain
          ?.sp_risk_score_decider ?? '-',
      ]);
      v.splice(answer_index + 3, 0, [
        'answer_asn',
        props?.exploreASNDetails?.[answer_value]?.asn ?? '-',
      ]);
      v.splice(answer_index + 4, 0, [
        'answer_as_name',
        props?.exploreASNDetails?.[answer_value]?.asname ?? 'not applicable',
      ]);
      let query_index = v.findIndex((e, i) => e[0] === 'query');
      let query_value = v[query_index][1];
      if (!v[query_index + 1]) return;
      v.splice(query_index + 1, 0, [
        'query_risk_score',
        props?.exploreRiskScores?.[query_value]?.sp_risk_score ??
          props?.exploreRiskScores?.[v[9] || [][1]]?.sp_risk_score ??
          '-',
      ]);
      if (!v[query_index + 2]) return;
      v.splice(query_index + 1, 0, [
        'query_risk_score_decider',
        // @TODO: this is too messed up :(
        props?.exploreRiskScores?.[query_value]?.sp_risk_score_explain
          ?.sp_risk_score_decider ??
          props?.exploreRiskScores?.[v[9] || [][1]]?.sp_risk_score_explain
            ?.sp_risk_score_decider ??
          props?.exploreRiskScores?.[v[10] || [][1]]?.sp_risk_score_explain
            ?.sp_risk_score_decider ??
          '-',
      ]);
      v.splice(query_index + 3, 0, [
        'query_asn',
        props?.exploreASNDetails?.[query_value]?.asn ??
          props?.exploreASNDetails?.[v[9][1]]?.asn ??
          props?.exploreASNDetails?.[v[10][1]]?.asn ??
          '-',
      ]);
      v.splice(query_index + 4, 0, [
        'query_as_name',
        props?.exploreASNDetails?.[query_value]?.asname ??
          props?.exploreASNDetails?.[v[9][1]]?.asname ??
          props?.exploreASNDetails?.[v[10][1]]?.asname ??
          'not applicable',
      ]);
      v = Object.fromEntries(v);
      //reordering
      v = Object.keys(v)
        .sort(function (a, b) {
          return correct_order.indexOf(a) - correct_order.indexOf(b);
        })
        .reduce((obj, key) => {
          obj[key] = v[key];
          return obj;
        }, {});
      items[i] = v;
    });
    return items;
  }

  function saveToFile(data) {
    let items = prepare_rows(data);
    const fileData = JSON.stringify(items);
    const blob = new Blob([fileData], { type: 'text/plain' });

    saveAs(
      blob,
      'export_' + moment().format('YYYY-MM-DD_HHmmss').toString() + '.json',
    );
    mixpanel.track('Export', {
      location: 'explore results',
      query: name,
    });
    handleModalCancel();
  }

  function saveToCSVFile(data) {
    let items = prepare_rows(data);
    const replacer = (key, value) => (value === null ? '' : value);
    //reordering
    const header = Object.keys(items[0]).filter((k) =>
      correct_order.includes(k),
    );
    header.sort(function (a, b) {
      return correct_order.indexOf(a) - correct_order.indexOf(b);
    });
    const csv = [
      header?.join(','),
      ...items?.map((row) =>
        header
          ?.map((fieldName) => JSON?.stringify(row[fieldName], replacer))
          ?.join(','),
      ),
    ]?.join('\r\n');

    const csvBlob = new Blob([csv], {
      type: 'text/csv',
    });

    saveAs(
      csvBlob,
      'export_' + moment().format('YYYY-MM-DD_HHmmss').toString() + '.csv',
    );
    handleModalCancel();
  }

  function URLBuilderForBackendExport(exportLimit) {
    let currentURLParams = new URLSearchParams(window.location.search);
    let type = currentURLParams.get('type');

    let currentQueryTemp = currentQuery;
    if (type === 'anyIP') {
      currentQueryTemp = currentQuery.replace('/PTR4/', '/anyIP/');
    }

    let exportURL = new URL(currentQueryTemp, window.location.origin);
    let params = new URLSearchParams(exportURL?.search);
    params.set('limit', exportLimit !== '' ? exportLimit : 100);

    let exportURLToUse =
      exportURL?.pathname + (Array.from(params).length > 0 ? '?' + params : '');
    let finalURL = '';
    exportURLToUse?.startsWith('/')
      ? (finalURL = exportURLToUse?.substring(1))
      : (finalURL = exportURLToUse);

    //if (q.get('originalQueryURL')) {
    //  return q.get('originalQueryURL');
    //} else {
    return finalURL;
    //}
  }

  function JsonBackendExport() {
    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
      props.exportHostingInfrasctructureASNsToJSON(
        'full',
        q?.get('name'),
        exportLimit,
      );
    } else {
      let exportURL = URLBuilderForBackendExport(exportLimit);
      props.exportExploreResultToJSON(
        exportURL,
        exportLimit,
        typeof exploreSorting == 'object' ? '' : exploreSorting,
        exploreFilters,
      );
    }
    mixpanel.track('Export JSON', {
      location: 'explore results',
      query: name,
      type: q?.get('type'),
    });
    handleModalCancel();
    incrementUIRequestsCounter();
  }

  function CSVBackendExport() {
    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes')) {
      props.exportHostingInfrasctructureASNsToCSV(
        'full',
        q?.get('name'),
        exportLimit,
      );
    } else {
      let exportURL = URLBuilderForBackendExport(exportLimit);
      props.exportExploreResultToCSV(
        exportURL,
        exportLimit,
        typeof exploreSorting == 'object' ? '' : exploreSorting,
        exploreFilters,
      );
    }
    mixpanel.track('Export CSV', {
      location: 'explore results',
      query: name,
      type: q?.get('type'),
    });
    handleModalCancel();
    incrementUIRequestsCounter();
  }

  function getBase64(file, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () =>
      callback({ resource_base64: reader.result.replace(/^.+?;base64,/, '') }),
    );
    reader.readAsDataURL(file);
  }

  const fileUpload = ({
    typeOfFeedToBeCreated, // domain, ip
    createOrSelected, // CREATE or SELECTED
    containerState, // FEED or COLLECTION
    nameOfContainer, // if createOrSelected === 'CREATE' name of Feed or Collection,
    uuidOfContainer, // if createOrSelected === 'SELECTED'
  }) => (fileObject) => {
    const uploadObject = {
      state: containerState,
      column_mapping: {
        [typeOfFeedToBeCreated.toLowerCase()]: { name: '', order: 0 },
      },
      feed_base64: fileObject?.resource_base64,
      ...(createOrSelected === 'CREATE' && { name: nameOfContainer }),
      ...(createOrSelected === 'SELECTED' && { uuid: uuidOfContainer }),
      threat_type: typeOfFeedToBeCreated.toLowerCase(),
      threat_duration: 0,
      resource_type: 'JSON',
    };
    if (createOrSelected === 'SELECTED') {
      props.updateFileSource(uploadObject);
    } else {
      props.createFileSource(uploadObject);
    }
    setShowExploreSaveFeedModal(false);
    setShowExploreSaveCollectionModal(false);
  };

  function saveToFeed({
    allExploreData,
    createOrSelected,
    containerState,
    uuidOfDomainContainer,
    uuidOfIPContainer,
  }) {
    setShowExploreSaveFeedModal(false);
    let items = allExploreData;
    if (selectedRowKeys?.length > 0) {
      items = selectedRowData;
    }

    // eslint-disable-next-line array-callback-return
    const domains = extractDomainIoCsFromExploreData({
      exploreData: items,
      typeOfIoC: 'domain',
      queryType: type,
    });

    const IPs = extractIPIoCsFromExploreData({
      exploreData: items,
      typeOfIoC: 'IP',
    });

    if (uuidOfDomainContainer) {
      const fileData = JSON.stringify(domains);
      const blob = new Blob([fileData], { type: 'text/plain' });
      getBase64(
        blob,
        fileUpload({
          typeOfFeedToBeCreated: 'domain',
          uuidOfContainer: uuidOfDomainContainer,
          createOrSelected,
          containerState,
        }),
      );
    }
    if (uuidOfIPContainer) {
      setTimeout(() => {
        const fileData = JSON.stringify(IPs);
        const blob = new Blob([fileData], { type: 'text/plain' });
        getBase64(
          blob,
          fileUpload({
            typeOfFeedToBeCreated: 'IP',
            uuidOfContainer: uuidOfIPContainer,
            createOrSelected,
            containerState,
          }),
        );
      }, 500);
    }

    if (['domain', 'url', 'ip'].indexOf(type) > -1) {
      mixpanel.track('Saved to Feed', {
        location: 'enrich',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    } else {
      mixpanel.track('Saved to Feed', {
        location: 'explore results',
        'ioc name': props?.mergeAPIEnrichment?.ioc_name,
        'ioc uuid': props?.mergeAPIEnrichment?.ioc_uuid,
      });
    }
  }

  function createFeed({
    allExploreData,
    createOrSelected,
    containerState,
    nameOfDomainContainer,
    nameOfIPContainer,
  }) {
    let items = allExploreData;
    if (selectedRowKeys?.length > 0) {
      items = selectedRowData;
    }

    // eslint-disable-next-line array-callback-return
    const domains = extractDomainIoCsFromExploreData({
      exploreData: items,
      typeOfIoC: 'domain',
      queryType: type,
    });

    const IPs = extractIPIoCsFromExploreData({
      exploreData: items,
      typeOfIoC: 'IP',
      queryType: type,
    });

    const fileData = JSON.stringify(domains);
    const blob = new Blob([fileData], { type: 'text/plain' });
    if (nameOfDomainContainer && nameOfDomainContainer.trim()) {
      getBase64(
        blob,
        fileUpload({
          typeOfFeedToBeCreated: 'domain',
          nameOfContainer: nameOfDomainContainer,
          createOrSelected,
          containerState,
        }),
      );
    }

    if (nameOfIPContainer && nameOfIPContainer.trim()) {
      setTimeout(() => {
        const fileData = JSON.stringify(IPs);
        const blob = new Blob([fileData], { type: 'text/plain' });
        getBase64(
          blob,
          fileUpload({
            typeOfFeedToBeCreated: 'IP',
            nameOfContainer: nameOfIPContainer,
            createOrSelected,
            containerState,
          }),
        );
      }, 500);
    }
  }

  function assembleNameStringForMonitorModal() {
    return 'Monitor results';
  }

  const renderAdvancedOptions = (lookupObject) => {
    const defaultOptions = [
      //query:
      {
        any: true,
        anyipv4: true,
        a: true,
        aaaa: true,
        cname: true,
        mx: true,
        ns: true,
        ptr4: true,
        ptr6: true,
        txt: true,
        soa: true,
        anyipv6: true,
      },
      //answer:
      {
        a: true,
        aaaa: true,
        ptr4: true,
        ptr6: true,
        cname: true,
        mx: true,
        ns: true,
        txt: true,
        soa: true,
        mxhash: true,
        nshash: true,
        soahash: true,
        txthash: true,
      },
    ];

    const options = PivotMatrix(
      lookupObject?.objectType,
      lookupObject?.queryType,
      defaultOptions,
    );

    return (
      <div className={styles.pivotOptions}>
        <Text>
          Choose Query or Answer to lookup more in depth for your entered data.
        </Text>
        <Title level={4} className={styles.subTitle}>
          Query
        </Title>
        <Radio.Group
          style={{ color: 'rgba(255, 255, 255, 0.85)' }}
          onChange={(e) => onChangeAdvancedQuery(e)}
          value={selectedAdvancedQuery}
        >
          <Radio
            className={{ [styles.hidden]: options[0].any }}
            role="radio"
            aria-label={'anyRadio'}
            value="any"
          >
            Any
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[0].anyipv4 }}
            value="ANYIPV4"
          >
            Any (IPv4)
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].a }} value="A">
            A
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].aaaa }} value="AAAA">
            AAAA
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[0].cname }}
            value="CNAME"
          >
            CNAME
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].mx }} value="MX">
            MX
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].ns }} value="NS">
            NS
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].ptr4 }} value="PTR4">
            PTR4
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].ptr6 }} value="PTR6">
            PTR6
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].txt }} value="TXT">
            TXT
          </Radio>
          <Radio className={{ [styles.hidden]: options[0].soa }} value="SOA">
            SOA
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[0].anyipv6 }}
            value="ANYIPV6"
          >
            Any (IPv6)
          </Radio>
        </Radio.Group>

        <Title level={4} className={styles.subTitle}>
          Answer (Reverse)
        </Title>
        <Radio.Group
          onChange={(e) => onChangeAdvancedAnswer(e)}
          value={selectedAdvancedAnswer}
        >
          <Radio
            className={{ [styles.hidden]: options[1].a }}
            role="radio1"
            value="A"
          >
            A
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].aaaa }} value="AAAA">
            AAAA
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].ptr4 }} value="PTR4">
            PTR4
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].ptr6 }} value="PTR6">
            PTR6
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[1].cname }}
            value="CNAME"
          >
            CNAME
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].mx }} value="MX">
            MX
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].ns }} value="NS">
            NS
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].txt }} value="TXT">
            TXT
          </Radio>
          <Radio className={{ [styles.hidden]: options[1].soa }} value="SOA">
            SOA
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[1].mxhash }}
            value="MXHASH"
          >
            MXHASH
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[1].nshash }}
            value="NSHASH"
          >
            NSHASH
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[1].soahash }}
            value="SOAHASH"
          >
            SOAHASH
          </Radio>
          <Radio
            className={{ [styles.hidden]: options[1].txthash }}
            value="TXTHASH"
          >
            TXTHASH
          </Radio>
        </Radio.Group>

        <Button
          className={styles.clearSelection}
          onClick={() => {
            setSelectedAdvancedQuery(null);
            setSelectedAdvancedAnswer(null);
          }}
          disabled={!(selectedAdvancedQuery || selectedAdvancedAnswer)}
        >
          Clear Selection
        </Button>
      </div>
    );
  };

  function scoreColor(score) {
    let scoreColor = '#1f9110';
    if (score > 40) {
      return (scoreColor = '#E84749');
    } else if (score >= 25) {
      return (scoreColor = '#f3be00');
    }
  }

  function convertDateString(text, format) {
    let datetime = 'n/a';

    if (!!text && text !== 'UNKNOWN') {
      datetime = moment.utc(text, format).format('YYYY-MM-DD').toString();
    }
    return datetime;
  }

  const changeExportLimit = (e) => {
    let exportLimit = e;

    if (exportLimit < 1) {
      exportLimit = '';
    } else if (exportLimit > 9999) {
      exportLimit = 10000;
    }

    exportLimit = exportLimit?.toString()?.replace(/\D/g, '');

    setExportLimit(exportLimit);
  };

  function renderColumns() {
    switch (columnStructure) {
      case 'any':
        return anyColumns;
      case 'anyIP':
        return anyColumns;
      case 'ANYIPV4':
        return anyColumns;
      case 'ANYIPV6':
        return anyColumns;
      case 'monitoringResults':
        return anyColumns;
      case 'historyQueryResults':
        return anyColumns;
      case 'lookup':
        return lookupColumns;
      case 'NS':
        return NSColumns;
      case 'nshash':
        return NSHashColumns;
      case 'NSHASH':
        return NSHashColumns;
      case 'CNAME':
        return CNAMEColumns;
      case 'MX':
        return mxColumns;
      case 'MXHASH':
        return mxColumns;
      case 'PTR4':
        return PTR4Columns;
      case 'PTR':
        return PTR4Columns;
      case 'PTR6':
        return PTR6Columns;
      case 'density':
        return densityColumns;
      case 'avgttl':
        return avgTTLColumns;
      case 'translate':
        return translateColumns;
      case 'A':
        return AColumns;
      case 'AAAA':
        return AAAAColumns;
      case 'TXT':
        return TXTColumns;
      case 'TXTHASH':
        return TXTColumns;
      case 'SOA':
        return SOAColumns;
      case 'SOAHASH':
        return SOAColumns;
      case 'ipdiversity':
        return ipDiversityColumns;
      case 'ssdeep':
        return ssdeepColumns;
      case 'certificates':
        return certificatesColumns;
      case 'jarm':
        return jarmColumns;
      case 'favicon':
        return faviconColumns;
      case 'hosting_infrastructure_asn':
        return hostingInfrastructureASNColumns;
      case 'asn':
        return AColumns;
      case 'dangling_dns_detection':
        return danglingDNSProtectionColumns;
      default:
        return defaultColumns;
    }
  }

  const AAAARecordDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {lookupObject?.queryType === 'query' ? (
              props?.mySubscriptionPlan?.has_access_to_enrich ? (
                <Link to={`/enrichment?name=${editableName}&type=domain`}>
                  <Button
                    disabled={
                      !editableName ||
                      selectedAdvancedQuery ||
                      selectedAdvancedAnswer ||
                      !props?.mySubscriptionPlan?.has_access_to_enrich ||
                      editableName?.includes('*')
                    }
                    style={{ marginRight: '8px' }}
                    type="primary"
                    onClick={() => {
                      props.resetEnrichment();
                      // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }}
                  >
                    Enrich
                  </Button>
                </Link>
              ) : (
                <Tooltip
                  title={
                    props?.mySubscriptionPlan?.has_access_to_enrich ? (
                      ''
                    ) : (
                      <>
                        This option is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    )
                  }
                >
                  <Button
                    disabled={!props?.mySubscriptionPlan?.has_access_to_enrich}
                    style={{ marginRight: '8px' }}
                    type="primary"
                  >
                    Enrich
                  </Button>
                </Tooltip>
              )
            ) : (
              <></>
            )}
            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'ANYIPV6' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'answer') {
                  setType('ANYIPV6');
                  exploreLookup(editableName, objectType, 'ANYIPV6');
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                }
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const ARecordDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link
                to={
                  lookupObject?.queryType === 'answer'
                    ? `/enrichment?name=${editableName}&type=ip`
                    : `/enrichment?name=${editableName}&type=domain`
                }
              >
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    setName(editableName);
                    if (lookupObject?.queryType === 'answer') {
                      //setType('ip');

                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    setName(editableName);
                    if (lookupObject?.queryType === 'answer') {
                      //setType('ip');

                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}
            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'ANYIPV4' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'answer') {
                  setType('ANYIPV4');
                  exploreLookup(editableName, objectType, 'ANYIPV4');
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                }
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const NSDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link to={`/enrichment?name=${editableName}&type=domain`}>
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    // setName(editableName);
                    // setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    // setName(editableName);
                    // setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}
            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'NS' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'answer') {
                  setType('NS');
                  exploreLookup(editableName, objectType, 'NS');
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                }
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const NSHashDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Menu
        style={{ backgroundColor: '#192F3B' }}
        className="ant-dropdown-menu"
      >
        <Menu.Item className="ant-dropdown-menu-item">
          <div>
            <Input
              className={styles.explore_dropdown_inputfield}
              value={editableName}
              onChange={(e) => {
                handleChange(e);
              }}
              allowClear={true}
            />
            {/* <Link
              to={`/explore-result?name=${editableName}&queryType=answer&type=nshash&origin_uid=Explore`}
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                setType('nshash');
                exploreLookup(editableName, objectType, 'nshash');
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreDensity(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Density
          </p>
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreAvgTTL(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Avg TTL
          </p>
        </Menu.Item>
      </Menu>
    );
  };

  const HTMLBodySsdeepDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Menu
        style={{ backgroundColor: '#192F3B' }}
        className="ant-dropdown-menu"
      >
        <Menu.Item style={{ margin: '8px' }} className="ant-dropdown-menu-item">
          <div style={{ marginBottom: '8px' }}>
            Find websites whose HTML body ssdeep hash is similar to this hash
          </div>
          <div>
            <Input
              className={styles.explore_dropdown_inputfield}
              value={editableName}
              onChange={(e) => {
                handleChange(e);
              }}
              allowClear={true}
            />
            {/* <Link
              to={
                `/explore/query-builder?query=ea97a2de-4f6e-4673-a986-2c367f97a713&ssdeep=${editableName}&backLink=` +
                encodeURIComponent(window.location.pathname) +
                encodeURIComponent(window.location.search)
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              // onClick={() => {
              //   setType('nshash');
              //   exploreLookup(editableName, objectType, 'nshash');
              //   mixpanel.track('Explore', {
              //     location: 'explore results',
              //     query: name,
              //   });
              // }}
            >
              Find Similar
            </Button>
            {/* </Link> */}
          </div>
        </Menu.Item>
        {/* <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreDensity(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Density
          </p>
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreAvgTTL(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Avg TTL
          </p>
        </Menu.Item> */}
      </Menu>
    );
  };

  const FaviconMurmurDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Menu
        style={{ backgroundColor: '#192F3B' }}
        className="ant-dropdown-menu"
      >
        <Menu.Item style={{ margin: '8px' }} className="ant-dropdown-menu-item">
          <div style={{ marginBottom: '8px' }}>
            Find matches for a given Favicon in other domains
          </div>
          <div>
            <Input
              className={styles.explore_dropdown_inputfield}
              value={editableName}
              onChange={(e) => {
                handleChange(e);
              }}
              allowClear={true}
            />
            {/* <Link
              to={`explore-result?name=${editableName}&queryType=favicon&type=favicon&backLink=%2Fenrichment%3Fname%3Dfacebook.com%26type%3Ddomain%26backLink%3D%252Fexplore-result%253Fname%253Dssdeep%2526queryType%253Dssdeep%2526type%253Dssdeep%2526originalQueryURL%253Dscandata%25252Fsearch%25252Fssdeep%25253Fssdeep%25253D1536%25253ALmoJ1To9kD27B9BRSTZcQQ7cLINwU1OC9mWwsV2Kxvu1EHBwP%25253AXkgk77QAcknmsV2iu1B%252526limit%25253D100%252526max_wait%25253D25%252526with_metadata%25253D1&originalQueryURL=scandata%2Fipv4%2Ffavicon%3Fnetmask%3D32%26net%3Din%26mmh3%3D-802123378%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=SCAN_DATA`}
            > */}
            {/* <Link
              to={
                `/explore/query-builder?query=142ef207-aee7-493a-a1b5-a39c9e2c8953&mmh3=${editableName}&backLink=` +
                encodeURIComponent(window.location.pathname) +
                encodeURIComponent(window.location.search)
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              // onClick={() => {
              //   setType('nshash');
              //   exploreLookup(editableName, objectType, 'nshash');
              //   mixpanel.track('Explore', {
              //     location: 'explore results',
              //     query: name,
              //   });
              // }}
            >
              Find Matches
            </Button>
            {/* </Link> */}
          </div>
        </Menu.Item>
        {/* <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreDensity(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Density
          </p>
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item">
          <p
            onClick={() => {
              setType('nshash');
              exploreAvgTTL(lookupObject?.lookupObject, 'nshash');
            }}
          >
            Avg TTL
          </p>
        </Menu.Item> */}
      </Menu>
    );
  };

  const MXDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link to={`/enrichment?name=${editableName}&type=domain`}>
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    //setName(editableName);
                    //setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    //setName(editableName);
                    //setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}

            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'MX' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'answer') {
                  setType('MX');
                  exploreLookup(editableName, objectType, 'MX');
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                }
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const CNAMEDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link to={`/enrichment?name=${editableName}&type=domain`}>
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    //setName(editableName);
                    //setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    //setName(editableName);
                    //setType('domain');
                    // window.open(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    //   '_blank',
                    //   'noopener, noreferrer',
                    // );
                    // props.history.push(
                    //   `/explore-result?name=${editableName}&type=domain`,
                    // );
                    mixpanel.track('Enrich', {
                      location: 'explore landing',
                      ioc_type: 'domain',
                    });
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}

            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'any' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else {
                  setType('CNAME');
                  exploreLookup(editableName, objectType, 'any');
                  mixpanel.track('Explore', {
                    location: 'explore results',
                    query: name,
                  });
                }
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const ASNDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Menu
        style={{ backgroundColor: '#192F3B' }}
        className="ant-dropdown-menu"
      >
        <Menu.Item style={{ margin: '8px' }} className="ant-dropdown-menu-item">
          <div style={{ marginBottom: '8px' }}>Find IPs for given ASN</div>
          <div>
            <Input
              className={styles.explore_dropdown_inputfield}
              value={editableName}
              onChange={(e) => {
                handleChange(e);
              }}
              allowClear={true}
            />
            {/* <Link
              //to={`explore-result?name=${editableName}&queryType=asn&type=asn&fromQueryBuilder=true&backLink=%2Fenrichment%3Fname%3Dfacebook.com%26type%3Ddomain%26backLink%3D%252Fexplore-result%253Fname%253Dssdeep%2526queryType%253Dssdeep%2526type%253Dssdeep%2526originalQueryURL%253Dscandata%25252Fsearch%25252Fssdeep%25253Fssdeep%25253D1536%25253ALmoJ1To9kD27B9BRSTZcQQ7cLINwU1OC9mWwsV2Kxvu1EHBwP%25253AXkgk77QAcknmsV2iu1B%252526limit%25253D100%252526max_wait%25253D25%252526with_metadata%25253D1&originalQueryURL=scandata%2Fipv4%2Ffavicon%3Fnetmask%3D32%26net%3Din%26mmh3%3D-802123378%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=SCAN_DATA`}
              to={`explore-result?name=${name}&queryType=asn&type=asn&originalQueryURL=%2Fpadns%2Flookup%2Fdomain%2Fasns%2F${name}%3Fresult_format%3Drecords%26asnum%3D${editableName}%26sort%3Dquery%252Fasc%26sort%3Danswer%252Fasc%26sort%3Dlast_seen%252Fdesc%26limit%3D100%26query_type%3DPADNS%2BASNs%2Bseen%2Bfor%2Bdomain%26origin_uid%3D2da02a84-1e01-4e19-b1e5-e615ab19f73b`}
            > */}

            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                setType('asn');
                exploreLookup(editableName, 'asn', 'asn');
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Find IPs for ASN
            </Button>
            {/* </Link> */}
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const TXTDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      // lookupObject?.queryType === 'query' && (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {lookupObject?.queryType === 'query' ? (
              props?.mySubscriptionPlan?.has_access_to_enrich ? (
                <Link to={`/enrichment?name=${editableName}&type=domain`}>
                  <Button
                    disabled={
                      !editableName ||
                      selectedAdvancedQuery ||
                      selectedAdvancedAnswer ||
                      editableName?.includes('*')
                    }
                    style={{ marginRight: '8px' }}
                    type="primary"
                    onClick={() => {
                      props.resetEnrichment();
                      //setName(editableName);
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }}
                  >
                    Enrich
                  </Button>
                </Link>
              ) : (
                <Tooltip
                  title={
                    props?.mySubscriptionPlan?.has_access_to_enrich ? (
                      ''
                    ) : (
                      <>
                        This option is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    )
                  }
                >
                  <Button
                    disabled={true}
                    style={{ marginRight: '8px' }}
                    type="primary"
                    onClick={() => {
                      props.resetEnrichment();
                      //setName(editableName);
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }}
                  >
                    Enrich
                  </Button>
                </Tooltip>
              )
            ) : (
              ''
            )}

            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'TXT' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'answer') {
                  setType('TXT');
                  exploreLookup(editableName, objectType, 'TXT');
                } else {
                  setType('TXT');
                  exploreLookup(editableName, objectType, 'any');
                }

                // } else {
                //   setType('TXT');
                //   exploreLookup(editableName, objectType, 'any');
                //   mixpanel.track('Explore', {
                //     location: 'explore results',
                //     query: name,
                //   });
                // }
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
      // )
    );
  };

  const SOADropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      // lookupObject?.queryType === 'query' && (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {lookupObject?.queryType === 'query' ? (
              props?.mySubscriptionPlan?.has_access_to_enrich ? (
                <Link to={`/enrichment?name=${editableName}&type=domain`}>
                  <Button
                    disabled={
                      !editableName ||
                      selectedAdvancedQuery ||
                      selectedAdvancedAnswer ||
                      editableName?.includes('*')
                    }
                    style={{ marginRight: '8px' }}
                    type="primary"
                    onClick={() => {
                      props.resetEnrichment();
                      // setName(editableName);
                      // setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }}
                  >
                    Enrich
                  </Button>
                </Link>
              ) : (
                <Tooltip
                  title={
                    props?.mySubscriptionPlan?.has_access_to_enrich ? (
                      ''
                    ) : (
                      <>
                        This option is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    )
                  }
                >
                  <Button
                    disabled={true}
                    style={{ marginRight: '8px' }}
                    type="primary"
                    onClick={() => {
                      props.resetEnrichment();
                      // setName(editableName);
                      // setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }}
                  >
                    Enrich
                  </Button>
                </Tooltip>
              )
            ) : (
              ''
            )}

            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'answer' ? 'SOA' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else {
                  setType('SOA');
                  exploreLookup(editableName, objectType, 'any');
                  mixpanel.track('Explore', {
                    location: 'explore results',
                    query: name,
                  });
                }
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
      // )
    );
  };

  const PTR4DropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link
                to={
                  lookupObject?.queryType === 'query'
                    ? `/enrichment?name=${editableName}&type=ip`
                    : `/enrichment?name=${editableName}&type=domain`
                }
              >
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    //setName(editableName);
                    if (lookupObject?.queryType === 'query') {
                      // setType('ip');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_query_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    //setName(editableName);
                    if (lookupObject?.queryType === 'query') {
                      // setType('ip');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      //setType('domain');
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}

            {/* <Link
              to={
                selectedAdvancedQuery || selectedAdvancedAnswer
                  ? `/explore-result?name=${editableName}&queryType=${
                      selectedAdvancedQuery ? 'query' : 'answer'
                    }&type=${
                      selectedAdvancedQuery !== null
                        ? selectedAdvancedQuery
                        : selectedAdvancedAnswer !== null
                        ? selectedAdvancedAnswer
                        : ''
                    }&origin_uid=Explore`
                  : `/explore-result?name=${editableName}&queryType=${
                      lookupObject?.queryType
                    }&type=${
                      lookupObject?.queryType === 'query' ? 'ANYIPV4' : 'any'
                    }&origin_uid=Explore`
              }
            > */}
            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else if (lookupObject?.queryType === 'query') {
                  setType('ANYIPV4');
                  exploreLookup(editableName, objectType, 'ANYIPV4');
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                }
                mixpanel.track('Explore', {
                  location: 'explore results',
                  query: name,
                });
              }}
            >
              Lookup PADNS
            </Button>
            {/* </Link> */}
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const QueryDropdownMenu = (lookupObject, queryType, objectType) => {
    // eslint-disable-next-line no-unused-vars
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );

    return (
      <Menu
        style={{ backgroundColor: '#192F3B' }}
        className="ant-dropdown-menu"
      >
        <Menu.Item
          disabled={
            !editableName ||
            !props?.mySubscriptionPlan?.has_access_to_enrich ||
            editableName?.includes('*')
          }
          className="ant-dropdown-menu-item"
        >
          <p
            onClick={() => {
              props.resetEnrichment();
              setName(editableName);
              if (type === 'PTR4') {
                window.open(
                  `/enrichment?name=${editableName}&type=ip`,
                  '_blank',
                  'noopener, noreferrer',
                );
                //setType('ip');
                // props.history.push(
                //   `/explore-result?name=${editableName}&type=ip`,
                // );
                mixpanel.track('Enrich', {
                  location: 'explore landing',
                  ioc_type: 'IP',
                });
              } else {
                window.open(
                  `/enrichment?name=${editableName}&type=domain`,
                  '_blank',
                  'noopener, noreferrer',
                );
                // setType('domain');
                // props.history.push(
                //   `/explore-result?name=${editableName}&type=domain`,
                // );
                mixpanel.track('Enrich', {
                  location: 'explore landing',
                  ioc_type: 'domain',
                });
              }
            }}
          >
            Enrich
          </p>
        </Menu.Item>
        <Menu.Item className="ant-dropdown-menu-item">
          <Cascader
            style={{
              minWidth: 200,
              maxWidth: 200,
              margin: '0px 20px 0px 20px',
            }}
            className="sidebar_cascade_menu"
            options={options}
            onChange={(indicator) =>
              handleIndicatorChange(indicator, editableName)
            }
            placeholder="Select Query Params"
          />
        </Menu.Item>
      </Menu>
    );
  };

  const HostDropdownMenu = (lookupObject, queryType, objectType) => {
    const [editableName, setEditableName] = useState(
      lookupObject?.lookupObject,
    );
    function handleChange(e) {
      setEditableName(e.target.value);
    }

    return (
      <Panel bgcolor={'#1C3138'} className={styles.advancedOptionsPanel}>
        <div className={styles.inputContainer}>
          <Input
            className={styles.advancedOptionsInput}
            value={editableName}
            onChange={(e) => {
              handleChange(e);
            }}
            allowClear={true}
          />

          <div className={styles.advancedOptionsActions}>
            {props?.mySubscriptionPlan?.has_access_to_enrich ? (
              <Link
                to={
                  type === 'PTR4'
                    ? `/enrichment?name=${editableName}&type=ip`
                    : `/enrichment?name=${editableName}&type=domain`
                }
              >
                <Button
                  disabled={
                    !editableName ||
                    selectedAdvancedQuery ||
                    selectedAdvancedAnswer ||
                    editableName?.includes('*')
                  }
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    // setName(editableName);
                    if (type === 'PTR4') {
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // setType('ip');
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      //setType('domain');
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_query_enrich ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={true}
                  style={{ marginRight: '8px' }}
                  type="primary"
                  onClick={() => {
                    props.resetEnrichment();
                    // Cookies.set('breadcrumbs', JSON.stringify(breadcrumbs));
                    // setName(editableName);
                    if (type === 'PTR4') {
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      // setType('ip');
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=ip`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'IP',
                      });
                    } else {
                      // window.open(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      //   '_blank',
                      //   'noopener, noreferrer',
                      // );
                      //setType('domain');
                      // props.history.push(
                      //   `/explore-result?name=${editableName}&type=domain`,
                      // );
                      mixpanel.track('Enrich', {
                        location: 'explore landing',
                        ioc_type: 'domain',
                      });
                    }
                  }}
                >
                  Enrich
                </Button>
              </Tooltip>
            )}

            <Button
              disabled={
                !editableName ||
                !props?.mySubscriptionPlan?.has_access_to_explore
              }
              type="primary"
              onClick={() => {
                if (selectedAdvancedQuery || selectedAdvancedAnswer) {
                  const typeOfQuery =
                    selectedAdvancedQuery !== null
                      ? selectedAdvancedQuery
                      : selectedAdvancedAnswer !== null
                      ? selectedAdvancedAnswer
                      : '';
                  const answerOrQuery = selectedAdvancedQuery
                    ? 'query'
                    : 'answer';
                  const indicator = [answerOrQuery, typeOfQuery];
                  handleIndicatorChange(indicator, editableName);
                } else {
                  setType('any');
                  exploreLookup(editableName, objectType, 'any');
                  mixpanel.track('Explore', {
                    location: 'explore results',
                    query: name,
                  });
                }
              }}
            >
              Lookup PADNS
            </Button>
          </div>
        </div>

        {renderAdvancedOptions(lookupObject)}
      </Panel>
    );
  };

  const handleIndicatorChange = (indicator, editableName) => {
    setType(indicator[1]);
    exploreLookup(editableName, indicator[0], indicator[1]);
  };

  function ASNSelector(lookupObject) {
    let ASN = props?.exploreASNDetails?.[lookupObject]?.asn;
    let ASName = props?.exploreASNDetails?.[lookupObject]?.asname;

    if (ASN) {
      return (
        <Popover
          style={{ padding: '8px 8px' }}
          placement="bottom"
          content={
            <div style={{ minWidth: '160px', textAlign: 'left' }}>
              <Icon
                style={{ fontSize: '22px', marginBottom: '20px' }}
                component={SilentPushIOCLogoSVG}
                {...props}
              />{' '}
              <span
                style={{
                  marginLeft: '8px',
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                AS Name
              </span>
              <p>
                <span style={{ fontWeight: '600' }}>{ASName}</span>
              </p>
            </div>
          }
        >
          <span style={{ marginRight: '8px' }}>{ASN}</span>
          <InfoCircleFilled />
        </Popover>
      );
    } else {
      return (
        <Tooltip title="Not applicable">
          <span>-</span>
        </Tooltip>
      );
    }
  }

  function riskScoreSelector(lookupObject) {
    let riskScore = props?.exploreRiskScores?.[lookupObject]?.sp_risk_score;
    let riskScoreError = props?.exploreRiskScores?.[lookupObject]?.error;
    if (riskScoreError) {
      return (
        <Tooltip title="We don’t have data for the IP address because it is private and is not routed on the Internet.">
          <RiskScoreGrayDot />
        </Tooltip>
      );
    } else if (riskScore >= 0 && riskScore <= 25) {
      return (
        <Popover
          style={{ padding: '8px 8px' }}
          placement="bottom"
          content={
            <div style={{ minWidth: '260px', textAlign: 'left' }}>
              <Icon
                style={{ fontSize: '22px', marginBottom: '20px' }}
                component={SilentPushIOCLogoSVG}
                {...props}
              />{' '}
              <span
                style={{
                  marginLeft: '8px',
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                Silent Push Risk Score
              </span>
              <Row gutter={0}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p>Risk Score</p>
                  <p>
                    <span style={{ fontWeight: '600' }}>
                      {props?.exploreRiskScores?.[lookupObject]?.sp_risk_score}
                    </span>
                    <span style={{ fontWeight: 'normal' }}> score</span>
                  </p>
                  <p style={{ marginTop: '-12px' }}>
                    <ProgressBar
                      bgcolor={scoreColor(
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score,
                      )}
                      width={'72'}
                      completed={
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score
                      }
                    />
                  </p>
                </Col>
                <Col span={12} style={{ textAlign: 'left', marginLeft: '8px' }}>
                  <p>Risk Score Explainer</p>
                  <p style={{ fontWeight: '600' }}>
                    {
                      props?.exploreRiskScores?.[lookupObject]
                        ?.sp_risk_score_explain?.sp_risk_score_decider
                    }
                  </p>
                </Col>
              </Row>
            </div>
          }
        >
          <RiskScoreGreenDot />
        </Popover>
      );
    } else if (riskScore > 25 && riskScore <= 40) {
      return (
        <Popover
          style={{ padding: '8px 8px' }}
          placement="bottom"
          content={
            <div style={{ minWidth: '260px', textAlign: 'left' }}>
              <Icon
                style={{ fontSize: '22px', marginBottom: '20px' }}
                component={SilentPushIOCLogoSVG}
                {...props}
              />{' '}
              <span
                style={{
                  marginLeft: '8px',
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                Silent Push Risk Score
              </span>
              <Row gutter={0}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p>Risk Score</p>
                  <p>
                    <span style={{ fontWeight: '600' }}>
                      {props?.exploreRiskScores?.[lookupObject]?.sp_risk_score}
                    </span>
                    <span style={{ fontWeight: 'normal' }}> score</span>
                  </p>
                  <p style={{ marginTop: '-12px' }}>
                    <ProgressBar
                      bgcolor={scoreColor(
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score,
                      )}
                      width={'72'}
                      completed={
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score
                      }
                    />
                  </p>
                </Col>
                <Col span={12} style={{ textAlign: 'left', marginLeft: '8px' }}>
                  <p>Risk Score Explainer</p>
                  <p style={{ fontWeight: '600' }}>
                    {
                      props?.exploreRiskScores?.[lookupObject]
                        ?.sp_risk_score_explain?.sp_risk_score_decider
                    }
                  </p>
                </Col>
              </Row>
            </div>
          }
        >
          <RiskScoreOrangeDot />
        </Popover>
      );
    } else if (riskScore > 40) {
      return (
        <Popover
          style={{ padding: '8px 8px' }}
          placement="bottom"
          content={
            <div style={{ minWidth: '260px', textAlign: 'left' }}>
              <Icon
                style={{ fontSize: '22px', marginBottom: '20px' }}
                component={SilentPushIOCLogoSVG}
                {...props}
              />{' '}
              <span
                style={{
                  marginLeft: '8px',
                  fontSize: '20px',
                  fontWeight: '600',
                }}
              >
                Silent Push Risk Score
              </span>
              <Row gutter={0}>
                <Col span={8} style={{ textAlign: 'left' }}>
                  <p>Risk Score</p>
                  <p>
                    <span style={{ fontWeight: '600' }}>
                      {props?.exploreRiskScores?.[lookupObject]?.sp_risk_score}
                    </span>
                    <span style={{ fontWeight: 'normal' }}> score</span>
                  </p>
                  <p style={{ marginTop: '-12px' }}>
                    <ProgressBar
                      bgcolor={scoreColor(
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score,
                      )}
                      width={'72'}
                      completed={
                        props?.exploreRiskScores?.[lookupObject]?.sp_risk_score
                      }
                    />
                  </p>
                </Col>
                <Col span={12} style={{ textAlign: 'left', marginLeft: '8px' }}>
                  <p>Risk Score Explainer</p>
                  <p style={{ fontWeight: '600' }}>
                    {
                      props?.exploreRiskScores?.[lookupObject]
                        ?.sp_risk_score_explain?.sp_risk_score_decider
                    }
                  </p>
                </Col>
              </Row>
            </div>
          }
        >
          <RiskScoreRedDot />
        </Popover>
      );
    } else {
      return '';
    }
  }

  function ASNRender(lookupObject, queryType, type) {
    if (type === 'NS')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'CNAME')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'TXT')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'jarm')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'SOA')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'nshash') return <></>;
    else if (type === 'query')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'host')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'nssrv') return <></>;
    else if (type === 'A')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'AAAA')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'ipv4') return <></>;
    else if (type === 'ipv6') return <></>;
    else if (type === 'MX')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
    else if (type === 'mxsrv') return <></>;
    else if (type === 'PTR')
      return (
        <>
          {props?.exploreASNStatus === STATUS.LOADED ? (
            ASNSelector(lookupObject)
          ) : (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: '24px' }} />}
            />
          )}
        </>
      );
  }

  function dropdownSelector(lookupObject, queryType, type) {
    if (type === 'NS')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <NSDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'asn')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <ASNDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
                {/* {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined />}
                    style={{ marginLeft: '8px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''} */}
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'CNAME')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <CNAMEDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'TXT')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <TXTDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'SOA')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <SOADropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'nshash')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <NSHashDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 12
                    ? lookupObject.substr(0, 12) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'html_body_ssdeep')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <HTMLBodySsdeepDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                <Text className={styles.pivotText}>
                  {lookupObject?.length > 10
                    ? lookupObject.substr(0, 10) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
                {/* {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined />}
                    style={{ marginLeft: '8px' }}
                  />
                )} */}
                {/* {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''} */}
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'favicon_mmh3')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <FaviconMurmurDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                <Text className={styles.pivotText}>
                  {lookupObject?.length > 10
                    ? lookupObject.substr(0, 10) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
                {/* {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined />}
                    style={{ marginLeft: '8px' }}
                  />
                )} */}
                {/* {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''} */}
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'query')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <QueryDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'host')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <HostDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'nssrv')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <NSDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'A')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <ARecordDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'AAAA')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <AAAARecordDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 20
                    ? lookupObject.substr(0, 20) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'ipv4')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <ARecordDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'ipv6')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <AAAARecordDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'MX')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <MXDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'mxsrv')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <MXDropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 75
                    ? lookupObject.substr(0, 75) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
    else if (type === 'PTR')
      return (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(lookupObject);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Dropdown
            placement="bottomLeft"
            trigger={['click']}
            overlay={
              <PTR4DropdownMenu
                lookupObject={lookupObject}
                queryType={queryType}
                objectType={type}
              />
            }
          >
            <Tooltip title={lookupObject}>
              <div className={styles.explore_table_clickable_area}>
                {props?.riskScoreStatus === STATUS.LOADING && (
                  <Spin
                    size={'small'}
                    indicator={<LoadingOutlined style={{ fontSize: '14px' }} />}
                    style={{ marginRight: '4px' }}
                  />
                )}
                {props?.riskScoreStatus === STATUS.LOADED
                  ? riskScoreSelector(lookupObject)
                  : ''}
                <Text className={styles.pivotText}>
                  {lookupObject.length > 25
                    ? lookupObject.substr(0, 25) + '...'
                    : lookupObject
                    ? lookupObject
                    : '-'}
                </Text>
              </div>
            </Tooltip>
          </Dropdown>
        </div>
      );
  }

  const monitoringTooltipTitle = () => {
    if (
      exploreData?.response?.metadata?.query_name === 'padns/search/ipdiversity'
    ) {
      return 'Monitoring for this query is not available.';
    }
    if (type === 'dangling_dns_detection') {
      return 'Monitoring for this query is not available.';
    }
    if (type === 'hosting_infrastructure_asn') {
      return 'Monitoring for this query is not available.';
    }
    if (type === 'historyQueryResults') {
      return 'Monitoring is not supported for Query History Results';
    }
    if (type === 'historyQueryResults') {
      return 'Monitoring is not supported for Query History Results';
    }
    if (type === 'monitoringResults') {
      return 'Monitoring is not supported for Monitoring Results';
    }

    // else{
    // return '';
    // }
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
    mixpanel.track('Simple Filter', {
      location: 'explore results',
      query: name,
    });
  };

  const handleNumberSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleNumberReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    toFilterNumber = null;
    fromFilterNumber = null;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),

    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          searchInput &&
            searchInput.current &&
            searchInput.current.select() &&
            searchInput.current.focus();
        }, 100);
      }
    },
  });

  const getColumnDateFilterProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <DatePicker.RangePicker
          onChange={(e) =>
            setSelectedKeys(
              e !== null
                ? [
                    `${e[0].format('YYYY-MM-DD')} 00:00:00:000,${e[1].format(
                      'YYYY-MM-DD',
                    )} 23:59:59:999`,
                  ]
                : [],
            )
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8 }}
        />

        <div>
          <Button
            type="primary"
            role="search"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            role="reset"
            style={{
              border: 'none',
              marginLeft: '2%',
              background: '#213338',
              color: '#b1c4d0',
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),

    onFilter: (value, record) => {
      const dateArray = value.split(',');
      const dateFrom = dateArray[0];
      const dateTo = dateArray[1];

      const from = Date.parse(dateFrom);
      const to = Date.parse(dateTo);

      const check = Date.parse(record[dataIndex]);
      return record[dataIndex] ? check <= to && check >= from : '';
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          searchInput &&
            searchInput.current &&
            searchInput.current.select() &&
            searchInput.current.focus();
        }, 100);
      }
    },
  });

  const getColumnNumberSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <div style={{ marginBottom: '8px' }}>
          <InputNumber
            placeholder={`Start`}
            style={{ marginRight: '5px' }}
            value={fromFilterNumber}
            onChange={(e) => {
              fromFilterNumber = e;

              setSelectedKeys(e ? [e] : []);
            }}
          ></InputNumber>
          <InputNumber
            placeholder={`End`}
            value={toFilterNumber}
            onPressEnter={() =>
              handleNumberSearch(selectedKeys, confirm, dataIndex)
            }
            onChange={(e) => {
              toFilterNumber = e;

              setSelectedKeys(e ? [e] : []);
            }}
          ></InputNumber>
        </div>
        <div>
          <Button
            type="primary"
            role="search"
            onClick={() => handleNumberSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
          >
            Search
          </Button>
          <Button
            onClick={() => handleNumberReset(clearFilters)}
            size="small"
            role="reset"
            style={{
              border: 'none',
              marginLeft: '2%',
              background: '#213338',
              color: '#b1c4d0',
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    ),

    onFilter: (value, record) => {
      return record[dataIndex]
        ? fromFilterNumber <= record[dataIndex] &&
            record[dataIndex] <= toFilterNumber
        : '';
    },

    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => {
          searchInput &&
            searchInput.current &&
            searchInput.current.select() &&
            searchInput.current.focus();
        }, 100);
      }
    },
  });

  const defaultColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', record.type)}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    //   filterIcon: (filtered) => (
    //     <FilterFunnelIcon
    //       style={{
    //         fontSize: '24px',
    //         color: filtered ? '#1890ff' : undefined,
    //       }}
    //     />
    //   ),
    //   ...getColumnNumberSearchProps('count'),
    //   sortOrder: defaultSortOrderCount(sorting),
    //   sorter: (a, b) => a.count - b.count,
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filters: [
        {
          text: 'NS',
          value: 'NS',
        },
        {
          text: 'A',
          value: 'A',
        },
        {
          text: 'AAAA',
          value: 'AAAA',
        },
        {
          text: 'CNAME',
          value: 'CNAME',
        },
        {
          text: 'MX',
          value: 'MX',
        },
        {
          text: 'PTR',
          value: 'PTR',
        },
      ],
      sorter: (a, b) => a.type.localeCompare(b.type),
      sortOrder: defaultSortOrderType(sorting),
      onFilter: (value, record) => record.type.indexOf(value) === 0,
    },
  ];

  const anyColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <Tooltip
          title={
            exploreData?.response?.metadata?.query_name ===
            'padns/search/ipdiversity'
              ? 'Filtering Domain Search Query Builder visualization results is not available.'
              : type === 'historyQueryResults'
              ? 'Filtering is not supported for Query History results'
              : ''
          }
        >
          <span
            style={{
              cursor:
                exploreData?.response?.metadata?.query_name ===
                  'padns/search/ipdiversity' ||
                type === 'monitoringResults' ||
                type === 'historyQueryResults'
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            <FilterFunnelIcon
              filtered={!!exploreFilters?.query}
              style={{
                pointerEvents: 'none',
                fontSize: '24px',
                cursor:
                  exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity' ||
                  type === 'monitoringResults' ||
                  type === 'historyQueryResults'
                    ? 'not-allowed'
                    : 'pointer',
                color: filtered ? '#1890ff' : undefined,
              }}
            />
          </span>
        </Tooltip>
      ),
      filterDropdown: ({ confirm }) =>
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        type === 'monitoringResults' ||
        type === 'historyQueryResults' ? (
          <></>
        ) : (
          <QueryFilter
            confirm={confirm}
            filters={exploreFilters}
            onSubmit={handleQueryFilterSubmit}
            onReset={handleQueryFilterReset}
            status={status}
          />
        ),
      sorter:
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        type === 'monitoringResults' ||
        type === 'historyQueryResults'
          ? false
          : true,
      // sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Query ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Query column"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.query, 'query', record.type),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <Tooltip
          title={
            exploreData?.response?.metadata?.query_name ===
            'padns/search/ipdiversity'
              ? 'Filtering Domain Search Query Builder visualization results is not available.'
              : type === 'historyQueryResults'
              ? 'Filtering is not supported for Query History results'
              : ''
          }
        >
          <span
            style={{
              cursor:
                exploreData?.response?.metadata?.query_name ===
                  'padns/search/ipdiversity' ||
                type === 'monitoringResults' ||
                type === 'historyQueryResults'
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            <FilterFunnelIcon
              filtered={!!exploreFilters?.answer}
              style={{
                pointerEvents: 'none',
                fontSize: '24px',
                cursor:
                  exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity' ||
                  type === 'monitoringResults' ||
                  type === 'historyQueryResults'
                    ? 'not-allowed'
                    : 'pointer',
                color: filtered ? '#1890ff' : undefined,
              }}
            />
          </span>
        </Tooltip>
      ),
      filterDropdown: ({ confirm }) =>
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        type === 'monitoringResults' ||
        type === 'historyQueryResults' ? (
          <></>
        ) : (
          <AnswerFilter
            confirm={confirm}
            filters={exploreFilters}
            onSubmit={handleAnswerFilterSubmit}
            onReset={handleAnswerFilterReset}
            status={status}
          />
        ),

      // sorter: true,
      sorter:
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        type === 'monitoringResults' ||
        type === 'historyQueryResults'
          ? false
          : true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <Tooltip
          title={
            exploreData?.response?.metadata?.query_name ===
            'padns/search/ipdiversity'
              ? 'Filtering Domain Search Query Builder visualization results is not available.'
              : type === 'historyQueryResults'
              ? 'Filtering is not supported for Query History results'
              : ''
          }
        >
          <span
            style={{
              cursor:
                exploreData?.response?.metadata?.query_name ===
                  'padns/search/ipdiversity' ||
                type === 'monitoringResults' ||
                type === 'historyQueryResults'
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            <FilterFunnelIcon
              filtered={!!exploreFilters?.first_seen_from}
              style={{
                pointerEvents: 'none',
                fontSize: '24px',
                cursor:
                  exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity' ||
                  type === 'monitoringResults' ||
                  type === 'historyQueryResults'
                    ? 'not-allowed'
                    : 'pointer',
                color: filtered ? '#1890ff' : undefined,
              }}
            />
          </span>
        </Tooltip>
      ),

      filterDropdown: ({ confirm }) =>
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        type === 'monitoringResults' ||
        type === 'historyQueryResults' ? (
          <></>
        ) : (
          <FirstSeenDatePickerFilter
            confirm={confirm}
            filters={exploreFilters}
            onSubmit={handleFirstSeenDateFilterSubmit}
            onReset={handleFirstSeenDateFilterReset}
            status={status}
          />
        ),

      // sorter: true,
      sorter:
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        queryType === 'monitoringResults' ||
        queryType === 'historyQueryResults'
          ? false
          : true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <Tooltip
          title={
            exploreData?.response?.metadata?.query_name ===
            'padns/search/ipdiversity'
              ? 'Filtering Domain Search Query Builder visualization results is not available.'
              : type === 'historyQueryResults'
              ? 'Filtering is not supported for Query History results'
              : ''
          }
        >
          <span
            style={{
              cursor:
                exploreData?.response?.metadata?.query_name ===
                  'padns/search/ipdiversity' ||
                queryType === 'monitoringResults' ||
                queryType === 'historyQueryResults'
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            <FilterFunnelIcon
              filtered={!!exploreFilters?.last_seen_from}
              style={{
                pointerEvents: 'none',
                fontSize: '24px',
                cursor:
                  exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity' ||
                  queryType === 'monitoringResults' ||
                  queryType === 'historyQueryResults'
                    ? 'not-allowed'
                    : 'pointer',
                color: filtered ? '#1890ff' : undefined,
              }}
            />
          </span>
        </Tooltip>
      ),

      filterDropdown: ({ confirm }) =>
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        queryType === 'monitoringResults' ||
        queryType === 'historyQueryResults' ? (
          <></>
        ) : (
          <LastSeenDatePickerFilter
            confirm={confirm}
            filters={exploreFilters}
            onSubmit={handleLastSeenDateFilterSubmit}
            onReset={handleLastSeenDateFilterReset}
            status={status}
          />
        ),

      // sorter: true,
      sorter:
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        queryType === 'monitoringResults' ||
        queryType === 'historyQueryResults'
          ? false
          : true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <Tooltip
          title={
            exploreData?.response?.metadata?.query_name ===
            'padns/search/ipdiversity'
              ? 'Filtering Domain Search Query Builder visualization results is not available.'
              : type === 'historyQueryResults'
              ? 'Filtering is not supported for Query History results'
              : ''
          }
        >
          <span
            style={{
              cursor:
                exploreData?.response?.metadata?.query_name ===
                  'padns/search/ipdiversity' ||
                queryType === 'monitoringResults' ||
                queryType === 'historyQueryResults'
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            <FilterFunnelIcon
              filtered={!!exploreFilters?.type}
              style={{
                pointerEvents: 'none',
                fontSize: '24px',
                cursor:
                  exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity' ||
                  queryType === 'monitoringResults' ||
                  queryType === 'historyQueryResults'
                    ? 'not-allowed'
                    : 'pointer',
                color: filtered ? '#1890ff' : undefined,
              }}
            />
          </span>
        </Tooltip>
      ),

      filterDropdown: ({ confirm }) =>
        exploreData?.response?.metadata?.query_name ===
          'padns/search/ipdiversity' ||
        queryType === 'monitoringResults' ||
        queryType === 'historyQueryResults' ? (
          <></>
        ) : (
          <TypeFilter
            confirm={confirm}
            filters={exploreFilters}
            onSubmit={handleTypeFilterSubmit}
            onReset={handleTypeFilterReset}
            status={status}
          />
        ),
    },
  ];

  const mxColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Query ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Query column"
    //     />
    //   ),
    //   dataIndex: 'query',
    //   key: 'query',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.query, 'query', record.type),
    // },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'mxsrv')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Answer ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Answer column"
    //     />
    //   ),
    //   dataIndex: 'answer',
    //   key: 'answer',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.answer, 'answer', record.type),
    // },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="MX Hash" />,
      dataIndex: 'mxhash',
      key: 'mxhash',
      align: 'left',
    },
    {
      title: <ColumnTitle columnName="TTL" />,
      dataIndex: 'ttl',
      key: 'ttl',
      align: 'center',
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const NSColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Query ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Query column"
    //     />
    //   ),
    //   dataIndex: 'query',
    //   key: 'query',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.query, 'query', record.type),
    // },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'nssrv')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Answer ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Answer column"
    //     />
    //   ),
    //   dataIndex: 'answer',
    //   key: 'answer',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.answer, 'answer', record.type),
    // },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',
      render: (text, record, index) =>
        dropdownSelector(record.nshash, 'query', 'nshash'),
    },

    {
      title: <ColumnTitle columnName="TTL" />,
      dataIndex: 'ttl',
      key: 'ttl',
      align: 'center',
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const NSHashColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Query ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Query column"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) =>
        ASNRender(record.query, 'query', record.type),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'nssrv')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),

      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',

      render: (text, record, index) =>
        dropdownSelector(record.nshash, 'query', 'nshash'),
    },

    {
      title: <ColumnTitle columnName="TTL" />,
      dataIndex: 'ttl',
      key: 'ttl',
      align: 'left',
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const TXTColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Query ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Query column"
    //     />
    //   ),
    //   dataIndex: 'query',
    //   key: 'query',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.query, 'query', record.type),
    // },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'TXT')}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Answer ASN"
    //       tooltipText="Current ASN allocation for all IP addresses in the Answer column"
    //     />
    //   ),
    //   dataIndex: 'answer',
    //   key: 'answer',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.answer, 'answer', record.type),
    // },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="TXT Hash" />,
      dataIndex: 'txthash',
      key: 'txthash',
      align: 'left',
      render: (text, record, index) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(record?.txthash);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={record?.txthash}>
            <div>
              {' '}
              {record?.txthash
                ? record?.txthash?.length > 8
                  ? record?.txthash.substr(0, 8) + '...'
                  : record?.txthash
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),

      // render: (text, record, index) =>
      // dropdownSelector(record.txthash, 'txthash', 'TXT'),
    },

    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const SOAColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),

      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: (a, b) => a.query.localeCompare(b.query),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Query ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Query column"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.query, 'query', record.type),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),

      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'SOA')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="SOA Hash" />,
      dataIndex: 'soahash',
      key: 'soahash',
      align: 'left',
      // render: (text, record, index) =>
      // dropdownSelector(record.txthash, 'txthash', 'TXT'),
    },

    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const lookupColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Query ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Query column"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) =>
        ASNRender(record.query, 'query', record.type),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',
      render: (text, record, index) =>
        dropdownSelector(record.nshash, 'nshash'),
    },

    {
      title: <ColumnTitle columnName="TTL" />,
      dataIndex: 'ttl',
      key: 'ttl',
      align: 'left',
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const CNAMEColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller_cname}>
          {dropdownSelector(record.query, 'query', 'CNAME')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Query ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Query column"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) =>
        ASNRender(record.query, 'query', record.type),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller_cname}>
          {dropdownSelector(record.answer, 'answer', 'CNAME')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: <ColumnTitle columnName="TTL" />,
      dataIndex: 'ttl',
      key: 'ttl',
      align: 'left',
      width: '80px',
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const AColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'ipv4')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },

    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const AAAAColumns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', 'host')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', 'ipv6')}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer ASN"
          tooltipText="Current ASN allocation for all IP addresses in the Answer column"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'center',
      render: (text, record, index) =>
        ASNRender(record.answer, 'answer', record.type),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },

    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const PTR4Columns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', record.type)}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const PTR6Columns = [
    {
      title: (
        <ColumnTitle columnName="Query" tooltipText="DNS Query - (rrname)" />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.query}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <QueryFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleQueryFilterSubmit}
          onReset={handleQueryFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      render: (text, record, index) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(record.query, 'query', record.type)}
        </div>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Answer"
          tooltipText="Response received for DNS query - (rdata)"
        />
      ),
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.answer}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <AnswerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleAnswerFilterSubmit}
          onReset={handleAnswerFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
      render: (text, record, index) => (
        <div className={styles.answer_width_controller}>
          {dropdownSelector(record.answer, 'answer', record.type)}
        </div>
      ),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="Count"
    //       tooltipText="The number of times the query has returned this answer"
    //     />
    //   ),
    //   dataIndex: 'count',
    //   key: 'count',
    //   align: 'center',
    // },
    {
      title: (
        <ColumnTitle
          columnName="First Seen"
          tooltipText="The first time the query returned this answer"
        />
      ),
      dataIndex: 'first_seen',
      key: 'first_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.first_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <FirstSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleFirstSeenDateFilterSubmit}
          onReset={handleFirstSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderFirstSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Last Seen"
          tooltipText="The last time the query returned this answer - results are sorted by Last Seen descending by default"
        />
      ),
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.last_seen_from}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <LastSeenDatePickerFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleLastSeenDateFilterSubmit}
          onReset={handleLastSeenDateFilterReset}
          status={status}
        />
      ),
      sorter: true,
      sortOrder: defaultSortOrderLastSeen(sorting),
    },
    {
      title: (
        <ColumnTitle
          columnName="Type"
          tooltipText="DNS Record Type - (rrtype)"
        />
      ),
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      filterIcon: (filtered) => (
        <FilterFunnelIcon
          filtered={!!exploreFilters?.type}
          style={{
            fontSize: '24px',
            color: filtered ? '#1890ff' : undefined,
          }}
        />
      ),
      filterDropdown: ({ confirm }) => (
        <TypeFilter
          confirm={confirm}
          filters={exploreFilters}
          onSubmit={handleTypeFilterSubmit}
          onReset={handleTypeFilterReset}
          status={status}
        />
      ),
    },
  ];

  const densityColumns = [
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',
      render: (nshash) => (
        <>
          <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}>
            <div> {nshash} </div>
          </Dropdown>
        </>
      ),
    },
    {
      title: 'Density',
      dataIndex: 'density',
      key: 'density',
      align: 'left',
    },
  ];

  const avgTTLColumns = [
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',
      render: (nshash) => (
        <>
          <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}>
            <div> {nshash} </div>
          </Dropdown>
        </>
      ),
    },
    {
      title: 'Average TTL',
      dataIndex: 'avgttl',
      key: 'avgttl',
      align: 'left',
    },
  ];

  const translateColumns = [
    {
      title: 'NSSRV',
      dataIndex: 'nssrv',
      key: 'nssrv',
      align: 'left',
    },
    {
      title: <ColumnTitle columnName="Name Server Hash" />,
      dataIndex: 'nshash',
      key: 'nshash',
      align: 'left',
      render: (nshash) => (
        <>
          <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}>
            <div> {nshash} </div>
          </Dropdown>
        </>
      ),
    },
  ];

  const ipDiversityColumns = [
    {
      title: 'ASN Diversity',
      dataIndex: 'asn_diversity',
      key: 'asn_diversity',
      align: 'left',
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: 'Host',
      dataIndex: 'host',
      key: 'host',
      align: 'left',
      sorter: (a, b) => a.host.localeCompare(b.host),
    },
    {
      title: 'IP Diversity All',
      dataIndex: 'ip_diversity_all',
      key: 'ip_diversity_all',
      align: 'left',
      ...getColumnNumberSearchProps('ip_diversity_all'),
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: 'IP Diversity Groups',
      dataIndex: 'ip_diversity_groups',
      key: 'ip_diversity_groups',
      align: 'left',
      sorter: (a, b) => a.count - b.count,
    },
  ];

  const ssdeepColumns = [
    {
      title: <ColumnTitle columnName="Query" />,
      // dataIndex: ["certificates","domain"],
      dataIndex: 'domain',
      key: 'query',
      align: 'left',
      // sorter: (a, b) => a.query - b.query,
      render: (query) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(query, 'query', 'host')}
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="IP" />,
      dataIndex: 'ip',
      key: 'ip',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (ip) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(ip, 'answer', ip?.includes(':') ? 'ipv6' : 'ipv4')}
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="Flags" />,
      //dataIndex: 'ip',
      //key: 'ip',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (record) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <Tooltip title={record?.open_directory ? 'open directory' : ''}>
            {record?.open_directory ? (
              <FolderOpenFilled style={{ marginRight: '4px' }} />
            ) : (
              ''
            )}
          </Tooltip>
          <Tooltip title={record?.open_s3_bucket ? 'open s3 bucket' : ''}>
            {record?.open_s3_bucket ? <FolderOpenFilled /> : ''}
          </Tooltip>
          {/* <div> {favicon_md5 ? favicon_md5 : '-'} </div> */}
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Scan Date" />,
      dataIndex: 'scan_date',
      key: 'scan_date',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (scan_date) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {scan_date ? scan_date : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Response" />,
      dataIndex: ['headers', 'response'],
      key: 'response',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (response) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {response ? response : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="HTML Title" />,
      dataIndex: ['html', 'html_title'],
      key: 'html_title',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (html_title) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {html_title ? html_title : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="HTML Body ssdeep" />,
      dataIndex: ['html', 'html_body_ssdeep'],
      key: 'html_body_ssdeep',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),

      render: (text, record, index) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(record?.html?.html_body_ssdeep);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={record?.html?.html_body_ssdeep}>
            <div>
              {' '}
              {record?.html?.html_body_ssdeep
                ? record?.html?.html_body_ssdeep?.length > 8
                  ? record?.html?.html_body_ssdeep.substr(0, 8) + '...'
                  : record?.html?.html_body_ssdeep
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
      // render: (html_body_ssdeep) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //       <div> {html_body_ssdeep ? html_body_ssdeep : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: <ColumnTitle columnName="Favicon Murmur" />,
      dataIndex: ['favicon', 'favicon_mmh3'],
      key: 'favicon_mmh3',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (text, record, index) =>
        dropdownSelector(
          record?.favicon?.favicon_mmh3,
          'query',
          'favicon_mmh3',
        ),
    },
    {
      title: <ColumnTitle columnName="Header Server" />,
      dataIndex: ['headers', 'server'],
      key: 'header_server',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (favicon_md5) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {favicon_md5 ? favicon_md5 : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="SSL Issuer" />,
      dataIndex: ['certificates', 'issuer_organization'],
      key: 'ssl_issuer',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      render: (favicon_md5) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {favicon_md5 ? favicon_md5 : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
  ];

  const certificatesColumns = [
    {
      title: <ColumnTitle columnName="IP" />,
      dataIndex: 'ip',
      key: 'ip',
      align: 'left',
      render: (ip) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(ip, 'answer', ip?.includes(':') ? 'ipv6' : 'ipv4')}
        </div>
      ),
      // render: (ip) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {ip ? ip : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: (
        <ColumnTitle
          columnName="ASN"
          tooltipText="IP ASN with associated AS Name"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) => ASNRender(record.ip, 'query', 'A'),
    },
    {
      title: <ColumnTitle columnName="Domain" />,
      // dataIndex: ["certificates","domain"],
      dataIndex: 'domain',
      key: 'query',
      align: 'left',
      // sorter: (a, b) => a.query - b.query,
      render: (query) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(query, 'query', 'host')}
        </div>
      ),
      // render: (domain) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {domain ? domain : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: <ColumnTitle columnName="Scan Date" />,
      dataIndex: 'scan_date',
      key: 'scan_date',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (scan_date) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {scan_date ? scan_date : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Fingerprint SHA1" />,
      dataIndex: 'fingerprint_sha1',
      key: 'fingerprint_sha1',
      align: 'left',
      render: (fingerprint_sha1) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(fingerprint_sha1);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={fingerprint_sha1}>
            <div>
              {' '}
              {fingerprint_sha1
                ? fingerprint_sha1?.length > 8
                  ? fingerprint_sha1.substr(0, 8) + '...'
                  : fingerprint_sha1
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (html_title) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {html_title ? html_title : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: <ColumnTitle columnName="Issuer" />,
      dataIndex: 'issuer',
      key: 'html_body_ssdeep',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (issuer) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {issuer ? issuer : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Issued On" />,
      dataIndex: 'not_after',
      key: 'html_body_ssdeep',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (not_after) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {not_after ? not_after : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Expires On" />,
      dataIndex: 'not_before',
      key: 'html_body_ssdeep',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (not_before) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {not_before ? not_before : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
  ];

  const jarmColumns = [
    {
      title: <ColumnTitle columnName="IP" />,
      dataIndex: 'ip',
      key: 'ip',
      align: 'left',
      render: (ip) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(ip, 'answer', ip?.includes(':') ? 'ipv6' : 'ipv4')}
        </div>
      ),
      // render: (ip) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {ip ? ip : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: (
        <ColumnTitle
          columnName="ASN"
          tooltipText="IP ASN with associated AS Name"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) => ASNRender(record.ip, 'query', 'A'),
    },
    // {
    //   title: (
    //     <ColumnTitle
    //       columnName="ASN"
    //       tooltipText="Current ASN allocation for all IP addresses"
    //     />
    //   ),
    //   dataIndex: 'answer',
    //   key: 'answer',
    //   align: 'center',
    //   render: (text, record, index) =>
    //     ASNRender(record.ip, 'query', 'jarm'),
    // },
    {
      title: <ColumnTitle columnName="Domain" />,
      // dataIndex: ["certificates","domain"],
      dataIndex: 'domain',
      key: 'query',
      align: 'left',
      // sorter: (a, b) => a.query - b.query,
      render: (query) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(query, 'query', 'host')}
        </div>
      ),
      // render: (domain) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {domain ? domain : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },

    {
      title: <ColumnTitle columnName="Last Seen" />,
      dataIndex: 'last_seen',
      key: 'last_seen',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (last_seen) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {last_seen ? last_seen : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="JARM Hash" />,
      dataIndex: 'jarm_hash',
      key: 'jarm_hash',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (html_title) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {html_title ? html_title : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (jarm_hash) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(jarm_hash);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={jarm_hash}>
            <div>
              {' '}
              {jarm_hash
                ? jarm_hash?.length > 18
                  ? jarm_hash.substr(0, 18) + '...'
                  : jarm_hash
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="Port" />,
      dataIndex: 'port',
      key: 'port',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (issuer) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {issuer ? issuer : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Redirect to HTTPS" />,
      dataIndex: 'redirect_to_https',
      key: 'redirect_to_https',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (redirect_to_https) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {redirect_to_https ? redirect_to_https : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Server Banner" />,
      dataIndex: 'server_banner',
      key: 'server_banner',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (server_banner) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {server_banner ? server_banner : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
  ];

  const faviconColumns = [
    {
      title: <ColumnTitle columnName="IP" />,
      dataIndex: 'ip',
      key: 'ip',
      align: 'left',
      render: (ip) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(ip, 'answer', ip?.includes(':') ? 'ipv6' : 'ipv4')}
        </div>
      ),
      // render: (ip) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {ip ? ip : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: (
        <ColumnTitle
          columnName="ASN"
          tooltipText="IP ASN with associated AS Name"
        />
      ),
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) => ASNRender(record.ip, 'query', 'A'),
    },
    {
      title: <ColumnTitle columnName="Domain" />,
      // dataIndex: ["certificates","domain"],
      dataIndex: 'domain',
      key: 'query',
      align: 'left',
      // sorter: (a, b) => a.query - b.query,
      render: (query) => (
        <div className={styles.query_width_controller}>
          {dropdownSelector(query, 'query', 'host')}
        </div>
      ),
      // render: (domain) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {domain ? domain : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: <ColumnTitle columnName="Scan Date" />,
      dataIndex: 'scan_date',
      key: 'scan_date',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (scan_date) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {scan_date ? scan_date : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Favicon MD5" />,
      dataIndex: 'favicon_md5',
      key: 'favicon_md5',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (html_title) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {html_title ? html_title : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (favicon_md5) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(favicon_md5);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={favicon_md5}>
            <div>
              {' '}
              {favicon_md5
                ? favicon_md5?.length > 8
                  ? favicon_md5.substr(0, 8) + '...'
                  : favicon_md5
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="Favicon MMH3" />,
      dataIndex: 'favicon_mmh3',
      key: 'favicon_mmh3',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (favicon_mmh3) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(favicon_mmh3);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={favicon_mmh3}>
            <div>
              {' '}
              {favicon_mmh3
                ? favicon_mmh3?.length > 8
                  ? favicon_mmh3.substr(0, 8) + '...'
                  : favicon_mmh3
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="Favicon2 MD5" />,
      dataIndex: 'favicon2_md5',
      key: 'favicon2_md5',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (html_title) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {html_title ? html_title : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (favicon2_md5) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(favicon2_md5);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={favicon2_md5}>
            <div>
              {' '}
              {favicon2_md5
                ? favicon2_md5?.length > 8
                  ? favicon2_md5.substr(0, 8) + '...'
                  : favicon2_md5
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      title: <ColumnTitle columnName="Favicon2 MMH3" />,
      dataIndex: 'favicon2_mmh3',
      key: 'favicon2_mmh3',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.html?.html_body_ssdeep,
      //     'query',
      //     'html_body_ssdeep',
      //   ),
      render: (favicon2_mmh3) => (
        <div className={styles.table_row_flex}>
          <Button
            icon={<CopyIcon />}
            ghost
            onClick={() => {
              exploreCopyToClipboard(favicon2_mmh3);
              mixpanel.track('Copy Observable', {
                location: 'explore',
              });
            }}
          />
          <Tooltip title={favicon2_mmh3}>
            <div>
              {' '}
              {favicon2_mmh3
                ? favicon2_mmh3?.length > 8
                  ? favicon2_mmh3.substr(0, 8) + '...'
                  : favicon2_mmh3
                : '-'}{' '}
            </div>
          </Tooltip>
        </div>
      ),
    },
  ];

  const danglingDNSProtectionQueryDropdownSelector = (record) => {
    if (record?.type === 'CNAME') {
      return dropdownSelector(record.query, 'query', 'CNAME');
    } else if (record?.type === 'NS') {
      return dropdownSelector(record.query, 'query', 'host');
    } else if (record?.type === 'MX') {
      return dropdownSelector(record.query, 'query', 'host');
    }
  };

  const danglingDNSProtectionAnswerDropdownSelector = (record) => {
    if (record?.type === 'CNAME') {
      return dropdownSelector(record.answer, 'answer', 'CNAME');
    } else if (record?.type === 'NS') {
      return dropdownSelector(record.answer, 'answer', 'nssrv');
    } else if (record?.type === 'MX') {
      return dropdownSelector(record.answer, 'answer', 'mxsrv');
    }
  };

  const danglingDNSProtectionColumns = [
    {
      title: <ColumnTitle columnName="Query" />,
      dataIndex: 'query',
      key: 'query',
      align: 'left',
      render: (text, record, index) => (
        <div className={styles.query_width_controller_cname}>
          {danglingDNSProtectionQueryDropdownSelector(record)}
        </div>
      ),
      sorter: true,
      sortOrder: defaultSortOrderQuery(sorting),
      // sorter: (a, b) => a.query - b.query,
      // render: (query) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {query ? query : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: <ColumnTitle columnName="Answer" />,
      // dataIndex: ["certificates","domain"],
      dataIndex: 'answer',
      key: 'answer',
      align: 'left',
      render: (text, record, index) => (
        <div className={styles.answer_width_controller_cname}>
          {danglingDNSProtectionAnswerDropdownSelector(record)}
        </div>
      ),
      sorter: true,
      sortOrder: defaultSortOrderAnswer(sorting),
    },
    {
      title: <ColumnTitle columnName="Target" />,
      dataIndex: 'target',
      key: 'target',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (target) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {target ? target : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="NX Domain" />,
      dataIndex: 'target_domain_is_nxdomain',
      key: 'target_domain_is_nxdomain',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (target_domain_is_nxdomain) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div>
            {' '}
            {target_domain_is_nxdomain ? target_domain_is_nxdomain : '-'}{' '}
          </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: <ColumnTitle columnName="Type" />,
      dataIndex: 'type',
      key: 'type',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (type) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {type ? type : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
  ];

  const hostingInfrastructureASNColumns = [
    // {
    //   title: <ColumnTitle columnName="Domain" />,
    //   dataIndex: 'domain',
    //   key: 'domain',
    //   align: 'left',
    //   render: (query) => (
    //     <div className={styles.query_width_controller}>
    //       {dropdownSelector(query, 'query', 'host')}
    //     </div>
    //   ),
    //   // render: (domain) => (
    //   //   <>
    //   //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //   //     <div> {domain ? domain : '-'} </div>
    //   //     {/* </Dropdown> */}
    //   //   </>
    //   // ),
    // },
    {
      title: (
        <ColumnTitle
          columnName="ASN"
          tooltipText="List of ASN that are currently hosting this domain’s infrastructure"
        />
      ),
      // dataIndex: ["certificates","domain"],
      dataIndex: 'asn',
      key: 'asn',
      align: 'left',
      // sorter: (a, b) => a.query - b.query,
      render: (text, record, index) =>
        dropdownSelector(record?.asn, 'query', 'asn'),

      // render: (asn) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {asn ? asn : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
    },
    {
      title: (
        <ColumnTitle
          columnName="AS Name"
          tooltipText="List of AS Names that are currently hosting this domain’s infrastructure"
        />
      ),
      dataIndex: 'asname',
      key: 'asname',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (asname) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {asname ? asname : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="ASN Size"
          tooltipText="Total allocated capacity for this ASN"
        />
      ),
      dataIndex: 'asn_size',
      key: 'asn_size',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      render: (asn_size) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {asn_size ? asn_size : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },
    {
      title: (
        <ColumnTitle
          columnName="Domain Hosts in ASN"
          tooltipText="Number of IPs hosting this domain’s infrastructure that are currently on this ASN"
        />
      ),
      dataIndex: 'domain_hosts_in_asn',
      key: 'domain_hosts_in_asn',
      align: 'left',
      // sorter: (a, b) => a.ip.localeCompare(b.ip),
      // render: (scan_date) => (
      //   <>
      //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
      //     <div> {scan_date ? scan_date : '-'} </div>
      //     {/* </Dropdown> */}
      //   </>
      // ),
      // render: (text, record, index) =>
      //   dropdownSelector(
      //     record?.asn,
      //     'query',
      //     'asn',
      //   ),

      render: (domain_hosts_in_asn) => (
        <>
          {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
          <div> {domain_hosts_in_asn ? domain_hosts_in_asn : '-'} </div>
          {/* </Dropdown> */}
        </>
      ),
    },

    // {
    //   title: <ColumnTitle columnName="Favicon MD5" />,
    //   dataIndex: 'favicon_md5',
    //   key: 'favicon_md5',
    //   align: 'left',
    //   // sorter: (a, b) => a.ip.localeCompare(b.ip),
    //   // render: (html_title) => (
    //   //   <>
    //   //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //   //     <div> {html_title ? html_title : '-'} </div>
    //   //     {/* </Dropdown> */}
    //   //   </>
    //   // ),
    //   render: (favicon_md5) => (
    //     <>
    //       {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //       <div> {favicon_md5 ? favicon_md5 : '-'} </div>
    //       {/* </Dropdown> */}
    //     </>
    //   ),
    // },
    // {
    //   title: <ColumnTitle columnName="Favicon MMH3" />,
    //   dataIndex: 'favicon_mmh3',
    //   key: 'favicon_mmh3',
    //   align: 'left',
    //   // sorter: (a, b) => a.ip.localeCompare(b.ip),
    //   // render: (text, record, index) =>
    //   //   dropdownSelector(
    //   //     record?.html?.html_body_ssdeep,
    //   //     'query',
    //   //     'html_body_ssdeep',
    //   //   ),
    //   render: (favicon_mmh3) => (
    //     <>
    //       {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //       <div> {favicon_mmh3 ? favicon_mmh3 : '-'} </div>
    //       {/* </Dropdown> */}
    //     </>
    //   ),
    // },
    // {
    //   title: <ColumnTitle columnName="Favicon2 MD5" />,
    //   dataIndex: 'favicon2_md5',
    //   key: 'favicon2_md5',
    //   align: 'left',
    //   // sorter: (a, b) => a.ip.localeCompare(b.ip),
    //   // render: (html_title) => (
    //   //   <>
    //   //     {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //   //     <div> {html_title ? html_title : '-'} </div>
    //   //     {/* </Dropdown> */}
    //   //   </>
    //   // ),
    //   render: (favicon2_md5) => (
    //     <>
    //       {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //       <div> {favicon2_md5 ? favicon2_md5 : '-'} </div>
    //       {/* </Dropdown> */}
    //     </>
    //   ),
    // },
    // {
    //   title: <ColumnTitle columnName="Favicon2 MMH3" />,
    //   dataIndex: 'favicon2_mmh3',
    //   key: 'favicon2_mmh3',
    //   align: 'left',
    //   // sorter: (a, b) => a.ip.localeCompare(b.ip),
    //   // render: (text, record, index) =>
    //   //   dropdownSelector(
    //   //     record?.html?.html_body_ssdeep,
    //   //     'query',
    //   //     'html_body_ssdeep',
    //   //   ),
    //   render: (favicon2_mmh3) => (
    //     <>
    //       {/* <Dropdown overlay={<NSHashDropdownMenu lookupObject={nshash} />}> */}
    //       <div> {favicon2_mmh3 ? favicon2_mmh3 : '-'} </div>
    //       {/* </Dropdown> */}
    //     </>
    //   ),
    // },
  ];

  function exploreLookup(
    lookupObject,
    queryType,
    type,
    resultFileUUID,
    originalQuery,
    baseURLType,
    historyQueryUUID,
  ) {
    props.clearExploreDetails();
    window.scrollTo(0, 0);

    setSelectedAdvancedAnswer(null);
    setSelectedAdvancedQuery(null);

    if (type === 'any') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );
        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
        }
      }

      setColumnStructure('any');

      props.loadMergeAPIExploreDetails({
        path: originalQuery
          ? decodeURIComponent(originalQuery)
          : 'padns/lookup/query/any/' +
            lookupObject +
            '?limit=100' +
            '&origin_uid=' +
            q?.get('origin_uid') +
            '&is_visualizable=1',
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        originalQuery
          ? originalQuery
          : 'padns/lookup/query/any/' +
              lookupObject +
              '?limit=100' +
              '&origin_uid=' +
              q?.get('origin_uid') +
              '&is_visualizable=1',
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=query' +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (type === 'anyIP' || type === 'ANYIPV4') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };
      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('ANYIPV4');
      props.loadMergeAPIExploreDetails({
        path: originalQuery
          ? decodeURIComponent(originalQuery)
          : 'padns/lookup/query/ANYIPV4/' + lookupObject + '?limit=100',
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        originalQuery
          ? originalQuery
          : 'padns/lookup/query/ANYIPV4/' + lookupObject + '?limit=100',
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=query' +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (type === 'ANYIPV6') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('ANYIPV6');
      props.loadMergeAPIExploreDetails({
        path: originalQuery
          ? decodeURIComponent(originalQuery)
          : 'padns/lookup/query/ANYIPV6/' + lookupObject + '?limit=100',
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        originalQuery
          ? originalQuery
          : 'padns/lookup/query/ANYIPV6/' + lookupObject + '?limit=100',
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=query' +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (
      type === 'NS' &&
      exploreData?.response?.metadata?.query_name?.includes('answer')
    ) {
      props.loadMergeAPIExploreDensity(
        'padns/lookup/density/nssrv/' + lookupObject + '?is_voluntary=0',
      );

      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);

          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('NS');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        //   window.history.replaceState(
        //     null,
        //     '',
        //     '/explore-result?name=' +
        //       lookupObject +
        //       '&queryType=' +
        //       queryType +
        //       '&type=' +
        //       type +
        //       (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //       (originalQuery
        //         ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //         : ''),
        //   );
      }
      if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (
      type === 'NS' &&
      exploreData?.response?.metadata?.query_name?.includes('query')
    ) {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('NS');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
      if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (type === 'nshash') {
      props.loadMergeAPIExploreDensity(
        'padns/lookup/density/nssrv/' + lookupObject + '?is_voluntary=0',
      );

      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('nshash');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (queryType === 'dangling_dns_detection') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('dangling_dns_detection');

      props.loadMergeAPIExploreDetails({
        path: decodeURIComponent(originalQuery),
        // exploreFilters: { ...exploreFilters },
        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'hosting_infrastructure_asn') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('hosting_infrastructure_asn');

      // originalQuery =
      //   originalQuery +
      //   '&origin_uid=' +
      //   q?.get('origin_uid') +
      //   '&is_visualizable=1';

      // props.loadMergeAPIExploreDetails({
      //   path: decodeURIComponent(originalQuery),
      //   // exploreFilters: { ...exploreFilters },
      //   exploreFilters: {
      //     query: null,
      //     answer: null,
      //     count_from: null,
      //     count_to: null,
      //     feed: null,
      //     type: null,
      //     last_seen_from: null,
      //     last_seen_to: null,
      //     first_seen_from: null,
      //     first_seen_to: null,
      //   },
      // });

      // setCurrentQuery(originalQuery);
      // setCurrentSkipAmount(0);

      props.loadHostingInfrastructureASNsRecipeResults({
        //props.loadMergeAPIExploreDetails({
        path: originalQuery,
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        'explore-recipes/hosting-infra-asns-recipes/query/' + originalQuery,
      );
      setCurrentSkipAmount(0);
    } else if (queryType === 'jarm') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('jarm');

      props.loadMergeAPIExploreDetails({
        path: decodeURIComponent(originalQuery),
        // exploreFilters: { ...exploreFilters },
        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'favicon') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('favicon');

      props.loadMergeAPIExploreDetails({
        path: decodeURIComponent(originalQuery),
        // exploreFilters: { ...exploreFilters },
        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'certificates') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('certificates');

      props.loadMergeAPIExploreDetails({
        path: decodeURIComponent(originalQuery),
        // exploreFilters: { ...exploreFilters },
        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'asn') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('asn');

      originalQuery =
        originalQuery +
        '&origin_uid=' +
        q?.get('origin_uid') +
        '&is_visualizable=1';

      props.loadMergeAPIExploreDetails({
        // path: decodeURIComponent(originalQuery),
        path: `/padns/lookup/domain/asns/${name}?result_format=records&asnum=${lookupObject}&sort=query%2Fasc&sort=answer%2Fasc&sort=last_seen%2Fdesc&limit=100&query_type=PADNS+ASNs+seen+for+domain&origin_uid=2da02a84-1e01-4e19-b1e5-e615ab19f73b`,
        // exploreFilters: { ...exploreFilters },
        exploreFilters: {
          query: null,
          answer: null,
          count_from: null,
          count_to: null,
          feed: null,
          type: null,
          last_seen_from: null,
          last_seen_to: null,
          first_seen_from: null,
          first_seen_to: null,
        },
      });

      // setCurrentQuery(originalQuery);
      setCurrentQuery(
        `/padns/lookup/domain/asns/${name}?result_format=records&asnum=${lookupObject}&sort=query%2Fasc&sort=answer%2Fasc&sort=last_seen%2Fdesc&limit=100&query_type=PADNS+ASNs+seen+for+domain&origin_uid=2da02a84-1e01-4e19-b1e5-e615ab19f73b`,
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'typosquat') {
      props.loadBrandImpersonationRecipeResults({
        //props.loadMergeAPIExploreDetails({
        path: originalQuery,
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        'explore-recipes/spoofing-recipes/query/' + originalQuery,
      );
      setCurrentSkipAmount(0);
    } else if (queryType == 'nameintxt') {
      props.loadMergeAPIExploreDetails({
        path: originalQuery,
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
    } else if (type === 'TXT') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('TXT');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
      }
    } else if (type === 'SOA') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('SOA');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
      }
    } else if (type === 'A') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);
        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('A');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        //setCurrentQuery('padns/lookup/query/' + type + '/' + lookupObject);
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        //setCurrentQuery('padns/lookup/answer/' + type + '/' + lookupObject);
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (type === 'AAAA') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('AAAA');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=answer' +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
      if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=query' +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=answer' +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (type === 'MX') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('MX');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
      if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (type === 'CNAME') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('CNAME');
      if (queryType === 'answer') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/answer/' +
                type +
                '/' +
                lookupObject +
                '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
      if (queryType === 'query') {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : '/padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      } else {
        props.loadMergeAPIExploreDetails({
          path: originalQuery
            ? decodeURIComponent(originalQuery)
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
          exploreFilters: { ...exploreFilters },
          exploreSorting,
        });
        setCurrentQuery(
          originalQuery
            ? originalQuery
            : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        );
        setCurrentSkipAmount(0);
        // window.history.replaceState(
        //   null,
        //   '',
        //   '/explore-result?name=' +
        //     lookupObject +
        //     '&queryType=' +
        //     queryType +
        //     '&type=' +
        //     type +
        //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
        //     (originalQuery
        //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
        //       : ''),
        // );
      }
    } else if (queryType === 'query') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('lookup');
      props.loadMergeAPIExploreDetails({
        path: originalQuery
          ? decodeURIComponent(originalQuery)
          : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        originalQuery
          ? originalQuery
          : 'padns/lookup/query/' + type + '/' + lookupObject + '?limit=100',
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    } else if (queryType === 'monitoringResults') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('monitoringResults');
      props.loadResultFile(resultFileUUID);
      setCurrentQuery('domain/monitoringResults/' + lookupObject);
      setCurrentSkipAmount(0);
    } else if (queryType === 'historyQueryResults') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
        }
      }

      setColumnStructure('historyQueryResults');
      props.loadHistoryQueryResult(historyQueryUUID);
      setCurrentQuery('domain/historyQueryResults/' + lookupObject);
      setCurrentSkipAmount(0);
    } else if (queryType === 'queryBuilderVisualization') {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('any');
      props.loadMergeAPIExploreDetails({
        path: decodeURIComponent(originalQuery),
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });

      setCurrentQuery(originalQuery);
      setCurrentSkipAmount(0);
    } else {
      const obj = {
        label: lookupObject,
        value: { lookupObject: lookupObject, queryType: queryType, type: type },
      };

      if (hasClickedOnBreadcrumb) {
        let breadCrumbs = Object.assign([], breadcrumbs);

        const index = breadCrumbs.findIndex(
          (o) => o?.obj?.label === previousLookup,
        );

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          if (index >= 0) {
            breadCrumbs = breadCrumbs.slice(0, index + 1);
          }
        }

        if (
          !breadCrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadCrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs, { obj }]));
        } else {
          props.saveBreadCrumbs([...breadCrumbs]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadCrumbs]));
        }

        setHasClickedOnBreadcrumb(false);
      } else {
        if (
          !breadcrumbs.find(
            (o) =>
              o?.obj?.label === obj.label &&
              o?.obj?.value?.type === obj?.value?.type,
          )
        ) {
          props.saveBreadCrumbs([...breadcrumbs, { obj }]);
          // sessionStorage.setItem('breadcrumbs', JSON.stringify([...breadcrumbs, { obj }]));
        }
      }

      setColumnStructure('lookup');
      props.loadMergeAPIExploreDetails({
        path: originalQuery
          ? decodeURIComponent(originalQuery)
          : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
        exploreFilters: { ...exploreFilters },
        exploreSorting,
      });
      setCurrentQuery(
        originalQuery
          ? originalQuery
          : 'padns/lookup/answer/' + type + '/' + lookupObject + '?limit=100',
      );
      setCurrentSkipAmount(0);
      // window.history.replaceState(
      //   null,
      //   '',
      //   '/explore-result?name=' +
      //     lookupObject +
      //     '&queryType=' +
      //     queryType +
      //     '&type=' +
      //     type +
      //     (baseURLType ? '&baseURLType=' + baseURLType : '') +
      //     (originalQuery
      //       ? '&originalQueryURL=' + encodeURIComponent(originalQuery)
      //       : ''),
      // );
    }
    setHasClickedOnBreadcrumb(false);
    setPreviousLookup(lookupObject);
    incrementUIRequestsCounter();
  }

  function exploreDensity(lookupObject, type) {
    setColumnStructure('density');
    props.loadMergeAPIExploreDetails({
      path: 'padns/lookup/density/' + type + '/' + lookupObject,
    });
  }

  function exploreAvgTTL(lookupObject, type) {
    setColumnStructure('avgttl');
    props.loadMergeAPIExploreDetails({
      path: 'padns/lookup/avgttl/' + type + '/' + lookupObject,
    });
  }

  const columns = renderColumns();

  const onSelectChange = (selectedRowKeys, record) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRowData(record);
  };

  function renderNSChangeFromTags(index) {
    const nsChanges = exploreData?.response?.nschanges?.nschanges?.[index];

    const changesFlags = [
      {
        title: 'Domain was on NS that hosts expired domains',
        condition: nsChanges?.from_expired,
      },
      {
        title: 'Domain was on self-hosted (self-named) NS',
        condition: nsChanges?.from_ns_in_domain,
      },
      {
        title: 'Domain was on NS that only hosts a small number of domains',
        condition: nsChanges?.from_ns_srv_domain_density_low,
      },
      {
        title: 'Domain was on NS that hosts parked domains',
        condition: nsChanges?.from_parked,
      },
      {
        title: 'Domain was on NS that hosts sinkholed domains',
        condition: nsChanges?.from_sinkhole,
      },
    ];
    const renderSection = (title, value, showValue, style = {}) => {
      let titleStyle = {
        fontWeight: 600,
        display: 'inline-block',
        marginRight: 8,
      };
      if (!showValue) {
        titleStyle = {
          display: 'inline-block',
        };
      }
      return (
        <div style={style}>
          <span style={titleStyle}>{title}</span>
          {showValue && (
            <span
              style={{
                display: 'inline-block',
              }}
            >
              {value}
            </span>
          )}
        </div>
      );
    };
    return (
      <div style={{}}>
        {nsChanges?.from_expired === true ||
        nsChanges?.from_ns_in_domain === true ||
        nsChanges?.from_ns_srv_domain_density_low === true ||
        nsChanges?.from_parked === true ||
        nsChanges?.from_sinkhole === true ? (
          <span style={{ fontWeight: 600 }}>From Tags</span>
        ) : (
          ''
        )}

        {changesFlags
          .filter((c) => c['condition'])
          .map((c) => renderSection(c['title'], null, false, { marginTop: 8 }))}
      </div>
    );
  }

  function renderNSChangeToTags(index) {
    const nsChanges = exploreData?.response?.nschanges?.nschanges?.[index];
    const changesFlags = [
      {
        title: 'Domain moved to a NS previously used',
        condition: nsChanges?.circular_change_to,
      },
      {
        title: 'Domain moved to NS that hosts expired domains',
        condition: nsChanges?.to_expired,
      },
      {
        title: 'Domain moved to self-hosted (self-named) NS',
        condition: nsChanges?.to_ns_in_domain,
      },
      {
        title: 'Domain moved to NS that only hosts a small number of domains',
        condition: nsChanges?.to_ns_srv_domain_density_low,
      },
      {
        title: 'Domain moved to NS that hosts parked domains',
        condition: nsChanges?.to_parked,
      },
      {
        title: 'Domain moved to NS that hosts sinkholed domains',
        condition: nsChanges?.to_sinkhole,
      },
    ];
    const renderSection = (title, value, showValue, style = {}) => {
      let titleStyle = {
        fontWeight: 400,
        fontSize: 14,
        color: 'rgba(255, 255, 255, 0.95)',
        display: 'inline-block',
        marginRight: 8,
      };
      if (!showValue) {
        titleStyle = {
          fontWeight: 500,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.95)',
          display: 'inline-block',
        };
      }
      return (
        <div style={style}>
          <span style={titleStyle}>{title}</span>
          {showValue && (
            <span
              style={{
                fontWeight: 500,
                fontSize: 14,
                color: 'rgba(255, 255, 255, 0.95)',
                display: 'inline-block',
              }}
            >
              {value}
            </span>
          )}
        </div>
      );
    };
    return (
      <div style={{}}>
        {nsChanges?.circular_change_to === true ||
        nsChanges?.to_expired === true ||
        nsChanges?.to_ns_in_domain === true ||
        nsChanges?.to_ns_srv_domain_density_low === true ||
        nsChanges?.to_parked === true ||
        nsChanges?.to_sinkhole === true ? (
          <span style={{ fontWeight: 600 }}>To Tags</span>
        ) : (
          ''
        )}

        {changesFlags
          .filter((c) => c['condition'])
          .map((c) => renderSection(c['title'], null, false, { marginTop: 8 }))}
      </div>
    );
  }

  const normalizeSelectedCertificateRows = (rows) => {
    const newKeys = { ip: 'query', domain: 'answer' };
    return rows.map((r) => {
      const keyValues = Object.keys(r).map((key) => {
        const newKey = newKeys[key] || key;
        let newKeyPairValue = { [newKey]: r[key] };
        return newKeyPairValue;
      });
      return Object.assign({}, ...keyValues);
    });
  };

  const normalizeCertificateRows = (rows) => {
    const skipFields = [
      'is_expired',
      'domains',
      'port',
      'redirect_to_https',
      'serial_number',
    ];
    let normalizedRows = [];
    new Map(Object.entries(rows[0])).forEach((v, k, m) => {
      v.forEach((_v, _k, _m) => {
        let _row = {};
        _row['query'] = k;
        new Map(Object.entries(_v)).forEach((__v, __k, __m) => {
          if (!skipFields.includes(__k)) {
            if (__k === 'domain') __k = 'answer';
            _row[__k] = __v;
          }
        });
        normalizedRows.push(_row);
      });
    });
    return normalizedRows;
  };

  const getRows = () => {
    if (type === 'anyIP') return exploreAnyIPData;
    else if (type === 'certificates')
      return normalizeCertificateRows(exploreData?.response?.certificates);
    else return exploreData?.response?.records;
  };

  function renderTableData() {
    const rowSelection = {
      selectedRowKeys,
      onChange: (selectedRowKeys, record) => {
        onSelectChange(selectedRowKeys, record);
      },
    };

    // if (type === 'domain') {
    //   return <></>;
    // } else if (type === 'ip') {
    //   return <></>;
    // } else
    if (
      type === 'URL' ||
      type === 'host' ||
      type === 'nshash' ||
      type === 'NS' ||
      type === 'any' ||
      type === 'TXT' ||
      type === 'TXTHASH' ||
      type === 'MXHASH' ||
      type === 'NSHASH' ||
      type === 'SOAHASH' ||
      type === 'SOA' ||
      type === 'A' ||
      type === 'AAAA' ||
      type === 'MX' ||
      type === 'CNAME' ||
      type === 'PTR4' ||
      type === 'PTR6' ||
      type === 'monitoringResults' ||
      type === 'queryBuilderVisualization' ||
      type == 'historyQueryResults' ||
      type === 'certificates' ||
      type === 'jarm' ||
      type === 'favicon' ||
      type === 'hosting_infrastructure_asn' ||
      type === 'asn' ||
      type === 'dangling_dns_detection' ||
      type === 'ssdeep'
    ) {
      return (
        <div>
          <div
            style={{
              position: 'relative',
              height: '48px',

              borderTop: '1px solid #606F74',
              background: '#1C3138',
            }}
          >
            {type !== 'certificates' &&
              type !== 'jarm' &&
              type !== 'favicon' &&
              type !== 'ssdeep' && (
                <span>
                  {props?.riskScoreStatus === STATUS.LOADING ||
                  props?.exploreASNStatus === STATUS.LOADING ? (
                    <LoadingOutlined
                      style={{
                        position: 'absolute',
                        top: '14px',
                        left: '8px',
                        fontSize: '16px',
                        zIndex: 9,
                      }}
                    />
                  ) : (
                    <Tooltip
                      title={
                        !mySubscriptionPlan?.has_access_to_explore ? (
                          <>
                            Explore is not part of this subscription plan. To
                            upgrade your subscription contact us at{' '}
                            <a
                              target="_blank"
                              href="mailto:sales@silentpush.com"
                            >
                              sales@silentpush.com
                            </a>
                            .
                          </>
                        ) : (
                          'Copy all visible or selected results raw data'
                        )
                      }
                    >
                      <CopyIcon
                        data-cy="hostingInfrastructureASNsRecipeResultsCopyButton"
                        aria-label="copyIcon"
                        onClick={() => copyExploreTableClipboard(getRows())}
                        style={{
                          position: 'absolute',
                          top: '14px',
                          left: '8px',
                          fontSize: '16px',
                          zIndex: 9,
                        }}
                      />
                    </Tooltip>
                  )}
                </span>
              )}
            {type !== 'certificates' &&
              type !== 'jarm' &&
              type !== 'favicon' &&
              type !== 'ssdeep' && (
                <Tooltip
                  title={
                    !mySubscriptionPlan?.has_access_to_explore ? (
                      <>
                        Explore is not part of this subscription plan. To
                        upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    ) : (
                      'Export all or selected results raw data'
                    )
                  }
                >
                  {props?.riskScoreStatus === STATUS.LOADING ||
                  props?.exploreASNStatus === STATUS.LOADING ? (
                    <LoadingOutlined
                      style={{
                        position: 'absolute',
                        top: '14px',
                        left: '38px',
                        fontSize: '16px',
                        zIndex: 9,
                      }}
                    />
                  ) : (
                    <DownloadIcon
                      data-cy="hostingInfrastructureASNsRecipeResultsDownloadButton"
                      style={{
                        position: 'absolute',
                        top: '14px',
                        left: '38px',
                        fontSize: '16px',
                        zIndex: 9,
                      }}
                      onClick={showExportModal}
                    ></DownloadIcon>
                  )}
                </Tooltip>
              )}

            {type !== 'monitoringResults' && type !== 'historyQueryResults' && (
              <Button
                onClick={handleResetFilters}
                style={{
                  position: 'absolute',
                  left: '55px',
                  top: '8px',
                  borderRadius: '4px',
                  border: 'none',
                }}
              >
                Clear Filters
              </Button>
            )}

            <Divider
              style={{
                position: 'absolute',
                height: '32px',
                zIndex: '9',
                left: '500px',
                margin: 0,
                borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
                top: '8px',
              }}
              type="vertical"
            />
            {type !== 'hosting_infrastructure_asn' &&
            type !== 'dangling_dns_detection' &&
            type !== 'certificates' &&
            type !== 'jarm' &&
            type !== 'favicon' ? (
              <div
                style={{
                  position: 'absolute',
                  left: '512px',
                  top: '10px',
                  fontSize: '14px',
                }}
              >
                Total Results:{' '}
                <span
                  style={{
                    position: 'relative',
                    top: '1px',
                    fontWeight: '700',
                    fontSize: '16px',
                  }}
                >
                  {resultsTotal}
                </span>
              </div>
            ) : (
              <div></div>
            )}
            {type !== 'hosting_infrastructure_asn' &&
            type !== 'dangling_dns_detection' &&
            type !== 'certificates' &&
            type !== 'jarm' &&
            type !== 'favicon' ? (
              <div
                style={{
                  position: 'absolute',
                  left: '700px',
                  top: '10px',
                  fontSize: '14px',
                }}
              >
                Results on current page:{' '}
                <span
                  style={{
                    position: 'relative',
                    top: '1px',
                    fontWeight: '700',
                    fontSize: '16px',
                  }}
                >
                  {pageResultsTotal}
                </span>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <Table
            locale={{
              emptyText: exploreData?.response?.job_status?.job_id ? (
                <span>
                  <NoDataIcon style={{ fontSize: 32, marginTop: '8px' }} />
                  <p
                    style={{
                      marginTop: '8px',
                      color: 'rgba(255, 255, 255, 0.95)',
                      fontFamily: 'TT Hoves',
                      fontWeight: 600,
                      fontSize: '16px',
                      lineHeight: '19px',
                      fontStyle: 'normal',
                    }}
                  >
                    This Explore query needs more time to show results.
                  </p>
                  <p
                    style={{
                      color: 'rgba(255, 255, 255, 0.95)',
                      fontFamily: 'TT Hoves',
                      lineHeight: '19px',
                      fontStyle: 'normal',
                    }}
                  >
                    Click{' '}
                    <p
                      style={{
                        color: '#3C9AE8',
                        display: 'inline',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        //props.history.push(
                        props.loadMergeAPIExploreDetails({
                          path: decodeURIComponent('/job/' + jobID),
                        })
                      }
                      // onClick={() =>
                      //   props.history.push(
                      //     `/explore/query-builder?query=2684f12f-585a-496f-af45-a148db181c74&jobid=${jobID}&state=simple&exploreQuery=` +
                      //       encodeURIComponent(window.location.pathname) +
                      //       encodeURIComponent(window.location.search),
                      //   )
                      // }
                    >
                      here
                    </p>{' '}
                    or on the Retry Job ID button below to continue the query
                    and wait for the results. You can also monitor the query for
                    changes. Click{' '}
                    <p
                      style={{
                        color: '#3C9AE8',
                        display: 'inline',
                      }}
                      onClick={() => setMonitorModalVisible(true)}
                    >
                      here
                    </p>{' '}
                    to save your monitor, or click on Monitor button in top
                    right corner.
                  </p>
                  <Button
                    type="primary"
                    style={{ marginBottom: '8px' }}
                    onClick={() => {
                      // window.scrollTo(0, 0);
                      //props.history.push(
                      props.loadMergeAPIExploreDetails({
                        path: decodeURIComponent('/job/' + jobID),
                      });
                      //`/explore/query-builder?query=2684f12f-585a-496f-af45-a148db181c74&jobid=${jobID}&state=simple&exploreQuery=` +
                      // encodeURIComponent(window.location.pathname) +
                      // encodeURIComponent(window.location.search),
                      // )
                    }}
                  >
                    Retry Job ID
                  </Button>
                  {/* <Tooltip title="Queries automatically every 25 seconds until there are results or stopped.">
                    <Button
                      type="primary"
                      style={{ marginBottom: '8px', marginLeft: '8px' }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        isJobIDPollingRunning.current = !isJobIDPollingRunning.current;

                        if (isJobIDPollingRunning.current === true) {
                          props.loadMergeAPIExploreDetails({
                            path: decodeURIComponent('/job/' + jobID),
                          });
                        }
                      }}
                    >
                      {isJobIDPollingRunning.current === false
                        ? 'Run Auto-Retry Job ID'
                        : 'Stop Auto-Retry Job ID'}{' '}
                    </Button>
                  </Tooltip> */}
                </span>
              ) : (
                status == STATUS.LOADED && (
                  <div className={styles.empty_state}>
                    <NoDataIcon style={{ fontSize: 32, marginTop: '8px' }} />
                    <Title level={4}>
                      This Explore query didn't yield any results.
                    </Title>
                    {name.startsWith('http://') ||
                    name.startsWith('https://') ||
                    name.startsWith('www.') ||
                    name.includes('/') ? (
                      <Text>
                        Try removing "http://" or "www." from the search, along
                        with directories/parameters of the URL, or click{' '}
                        <a onClick={() => retryURL()}>here</a>
                      </Text>
                    ) : (
                      ''
                    )}
                    <Text>
                      To change your query{' '}
                      <a onClick={gotoLastBreadCrumb}>go back</a> or to search
                      for something else click{' '}
                      <a onClick={() => props.history.push('/explore')}>here</a>
                      .{' '}
                    </Text>
                  </div>
                )
              ),
            }}
            rowSelection={rowSelection}
            pagination={false}
            onChange={updateFilterAndSorting}
            dataSource={dataSource}
            //dataSource={dummyData?.response.records}
            columns={columns}
            loading={status != STATUS.LOADED}
            rowKey={(record) => {
              if (type === 'certificates')
                return `${record.ip}-${record.scan_date}`;
              return `${record?.answer ? record?.answer : record?.ip}-${
                record?.type
              } - ${record?.first_seen} - ${record?.count} - ${
                record?.query ? record?.query : record?.domain
              } - ${record?.asn}`;
            }}
          />
          <div>
            {queryType !== 'ipdiversity' && queryType !== 'nschanges' ? (
              <div className={styles.bottom_pagination_buttons}>
                <Button
                  data-cy="hostingInfrastructureRecipeResultsPreviousButton"
                  disabled={
                    currentSkipAmount === 0 ||
                    (exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity'
                      ? true
                      : false) ||
                    type === 'historyQueryResults' ||
                    type === 'monitoringResults'
                  }
                  onClick={requestPrevResults}
                  icon={
                    <LeftArrow
                      style={{
                        fill:
                          currentSkipAmount === 0
                            ? 'rgba(89, 89, 89, 1)'
                            : 'rgba(60, 154, 232, 1)',
                      }}
                    />
                  }
                  className={styles.pagination_button}
                  style={{
                    border: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '5px',
                  }}
                >
                  Previous
                </Button>

                <Button
                  data-cy="hostingInfrastructureRecipeResultsNextButton"
                  disabled={
                    (exploreData?.response?.metadata?.query_name ===
                    'padns/search/ipdiversity'
                      ? true
                      : false) ||
                    type === 'historyQueryResults' ||
                    type === 'monitoringResults' ||
                    (exploreData?.response?.metadata?.results_returned
                      ? exploreData?.response?.metadata?.results_returned ===
                        exploreData?.response?.metadata?.results_total_at_least
                      : false)
                  }
                  onClick={requestNextResults}
                  className={styles.pagination_button}
                  style={{
                    border: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '5px',
                  }}
                >
                  Next
                  <LeftArrow
                    style={{
                      transform: 'rotate(180deg)',
                      fill:
                        exploreData?.response?.metadata?.query_name ===
                          'padns/search/ipdiversity' ||
                        type == 'historyQueryResults' ||
                        (exploreData?.response?.metadata?.results_returned &&
                          exploreData?.response?.metadata?.results_returned ===
                            exploreData?.response?.metadata
                              ?.results_total_at_least)
                          ? 'rgba(89, 89, 89, 1)'
                          : 'rgba(60, 154, 232, 1)',
                    }}
                  />
                </Button>
              </div>
            ) : (
              ''
            )}
          </div>
          <VersionCheck parentComponentStatus={props.riskScoreStatus} />
        </div>
      );
    } else if (type === 'anyIP' || type === 'ANYIPV4' || type === 'ANYIPV6') {
      return (
        <div>
          <div
            style={{
              position: 'relative',
              height: '48px',

              borderTop: '1px solid #606F74',
              background: '#1C3138',
            }}
          >
            <Tooltip
              title={
                !mySubscriptionPlan?.has_access_to_explore ? (
                  <>
                    Explore is not part of this subscription plan. To upgrade
                    your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                ) : (
                  'Copy all visible or selected results raw data'
                )
              }
            >
              <CopyIcon
                data-cy="hostingInfrastructureASNsRecipeResultsCopyButton"
                onClick={() => copyExploreTableClipboard(getRows())}
                style={{
                  position: 'absolute',
                  top: '14px',
                  left: '8px',
                  fontSize: '16px',
                  zIndex: 9,
                }}
              />
            </Tooltip>
            <Tooltip
              title={
                !mySubscriptionPlan?.has_access_to_explore ? (
                  <>
                    Explore is not part of this subscription plan. To upgrade
                    your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                ) : (
                  'Export all or selected results raw data'
                )
              }
            >
              {props?.riskScoreStatus === STATUS.LOADING ||
              props?.exploreASNStatus === STATUS.LOADING ? (
                <LoadingOutlined
                  style={{
                    position: 'absolute',
                    top: '14px',
                    left: '38px',
                    fontSize: '16px',
                    zIndex: 9,
                  }}
                />
              ) : (
                <DownloadIcon
                  data-cy="hostingInfrastructureASNsRecipeResultsDownloadButton"
                  style={{
                    position: 'absolute',
                    top: '14px',
                    left: '38px',
                    fontSize: '16px',
                    zIndex: 9,
                  }}
                  onClick={showExportModal}
                ></DownloadIcon>
              )}
            </Tooltip>

            <Button
              disabled={
                type === 'monitoringResults' || type === 'historyQueryResults'
                  ? true
                  : false
              }
              onClick={handleResetFilters}
              style={{
                position: 'absolute',
                left: '55px',
                top: '8px',
                borderRadius: '4px',
                border: 'none',
              }}
            >
              Clear Filters
            </Button>
            <Divider
              style={{
                position: 'absolute',
                height: '32px',
                zIndex: '9',
                left: '500px',
                margin: 0,
                borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
                top: '8px',
              }}
              type="vertical"
            />
            {type !== 'hosting_infrastructure_asn' &&
            type !== 'dangling_dns_detection' &&
            type !== 'certificates' &&
            type !== 'jarm' &&
            type !== 'favicon' ? (
              <div
                style={{
                  position: 'absolute',
                  left: '512px',
                  top: '10px',
                  fontSize: '14px',
                }}
              >
                Total Results:{' '}
                <span
                  style={{
                    position: 'relative',
                    top: '1px',
                    fontWeight: '700',
                    fontSize: '16px',
                  }}
                >
                  {resultsTotal}
                </span>
              </div>
            ) : (
              <div></div>
            )}
            {type !== 'hosting_infrastructure_asn' &&
            type !== 'dangling_dns_detection' &&
            type !== 'certificates' &&
            type !== 'jarm' &&
            type !== 'favicon' ? (
              <div
                style={{
                  position: 'absolute',
                  left: '700px',
                  top: '10px',
                  fontSize: '14px',
                }}
              >
                Results on current page:{' '}
                <span
                  style={{
                    position: 'relative',
                    top: '1px',
                    fontWeight: '700',
                    fontSize: '16px',
                  }}
                >
                  {pageResultsTotal}
                </span>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <Table
            locale={{
              emptyText: (
                <span>
                  <NoDataIcon style={{ fontSize: 32 }} />
                  <p
                    style={{
                      color: 'rgba(255, 255, 255, 0.95)',
                      fontFamily: 'TT Hoves',
                      fontWeight: 600,
                      fontSize: '16px',
                      lineHeight: '19px',
                      fontStyle: 'normal',
                    }}
                  >
                    To change your query{' '}
                    <p
                      style={{
                        color: '#3C9AE8',
                        display: 'inline',
                        cursor: 'pointer',
                      }}
                      onClick={gotoLastBreadCrumb}
                    >
                      go back
                    </p>{' '}
                    or to search for something else click{' '}
                    <p
                      style={{
                        color: '#3C9AE8',
                        display: 'inline',
                        cursor: 'pointer',
                      }}
                      onClick={() => props.history.push('/explore')}
                    >
                      here
                    </p>
                    .{' '}
                  </p>
                </span>
              ),
            }}
            rowSelection={rowSelection}
            pagination={false}
            onChange={updateFilterAndSorting}
            dataSource={dataSource}
            columns={columns}
            loading={status != STATUS.LOADED}
            rowKey={(record) =>
              `${record?.answer}-${record?.type} - ${record?.first_seen} - ${record?.count} - ${record?.query} - ${record?.asn}`
            }
          />
          <div>
            {queryType !== 'ipdiversity' && queryType !== 'nschanges' ? (
              <div>
                <div
                  data-cy="hostingInfrastructureRecipeResultsPreviousButton"
                  onClick={requestPrevResults}
                >
                  <Button
                    disabled={currentSkipAmount === 0 ? true : false}
                    icon={
                      <LeftArrow
                        style={{
                          fill:
                            currentSkipAmount === 0
                              ? 'rgba(89, 89, 89, 1)'
                              : 'rgba(60, 154, 232, 1)',
                        }}
                      />
                    }
                    className={styles.pagination_button}
                    style={{
                      position: 'absolute',
                      right: '320px',
                      bottom: '-38px',
                      border: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '5px',
                    }}
                  >
                    Previous
                  </Button>
                </div>
                <div
                  data-cy="hostingInfrastructureRecipeResultsNextButton"
                  onClick={requestNextResults}
                >
                  <Button
                    disabled={
                      (exploreData?.response?.metadata?.query_name ===
                        'padns/search/ipdiversity' ||
                      type === 'historyQueryResults' ||
                      type === 'monitoringResults'
                        ? true
                        : false) ||
                      (exploreData?.response?.metadata?.results_returned
                        ? exploreData?.response?.metadata?.results_returned ===
                          exploreData?.response?.metadata
                            ?.results_total_at_least
                        : false)
                    }
                    className={styles.pagination_button}
                    style={{
                      position: 'absolute',
                      right: '220px',
                      bottom: '-38px',
                      border: 'none',
                      display: 'inline-flex',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '5px',
                    }}
                  >
                    Next
                    <LeftArrow
                      style={{
                        transform: 'rotate(180deg)',
                        fill:
                          exploreData?.response?.metadata?.query_name ===
                            'padns/search/ipdiversity' ||
                          type === 'historyQueryResults' ||
                          type === 'monitoringResults' ||
                          (exploreData?.response?.metadata?.results_returned &&
                            exploreData?.response?.metadata
                              ?.results_returned ===
                              exploreData?.response?.metadata
                                ?.results_total_at_least)
                            ? 'rgba(89, 89, 89, 1)'
                            : 'rgba(60, 154, 232, 1)',
                      }}
                    />
                  </Button>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <VersionCheck parentComponentStatus={props.riskScoreStatus} />
        </div>
      );
    }
  }

  const PrettyPrintJson = React.memo(({ data }) => (
    <div style={{ textAlign: 'left' }}>
      <JSONViewer data={data} />
    </div>
  ));

  const isLoading = status === STATUS.LOADING;
  const whoisLoading = whoisStatus === STATUS.LOADING;
  const hasSelected = selectedRowKeys.length > 0;

  const getOriginUID = () => {
    if (currentQuery.includes('explore-recipes/hosting-infra-asns-recipes'))
      return 'HOSTING_INFRA_ASNS';
    return 'Explore';
  };

  const getTotalResults = () => {
    const has_no_metadata =
      exploreData?.response?.metadata?.query_name ===
        'padns/search/ipdiversity' ||
      currentQuery.startsWith('/padns/snapshot/domain/') ||
      type === 'certificates' ||
      type === 'hosting_infrastructure_asn' ||
      queryType === 'dangling_dns_detection';
    return has_no_metadata
      ? dataSource?.length
      : exploreData?.response?.metadata?.results_returned;
  };

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan.has_access_to_explore ? (
      <div className="explore_container">
        {isLoading && <LoadingSilentPush size={80} positionCenter />}
        {!isLoading && (
          <>
            <BackButton />

            <span
              style={{
                position: 'absolute',
                top: '20px',
                left: '45%',
                transform: 'translateX(-50%)',
                color: 'white',
              }}
            >
              {pageTitle}
            </span>

            <Tabs
              className={enrichStyles['tabs-padding']}
              defaultActiveKey="1"
              type="card"
              onTabClick={(key, e) => {
                if (
                  (key === 'raw-data') &
                  (['ip', 'domain', 'url'].indexOf(type) > -1)
                ) {
                  mixpanel.track('Raw Data', {
                    location: 'enrich',
                    query: name,
                  });
                } else {
                  mixpanel.track('Raw Data', {
                    location: 'explore results',
                    query: name,
                  });
                }
              }}
            >
              {((type === 'nshash' ||
                type === 'host' ||
                type === 'any' ||
                type === 'anyIP' ||
                type === 'ANYIPV4' ||
                type === 'ANYIPV6' ||
                type === 'A' ||
                type === 'TXT' ||
                type === 'TXTHASH' ||
                type === 'NSHASH' ||
                type === 'MXHASH' ||
                type === 'SOAHASH' ||
                type === 'SOA' ||
                type === 'AAAA' ||
                type === 'MX' ||
                type === 'CNAME' ||
                type === 'PTR4' ||
                type === 'PTR6' ||
                type === 'monitoringResults' ||
                type === 'queryBuilderVisualization' ||
                type === 'historyQueryResults' ||
                type === 'certificates' ||
                type === 'jarm' ||
                type === 'favicon' ||
                type === 'hosting_infrastructure_asn' ||
                type === 'asn' ||
                type === 'dangling_dns_detection' ||
                type === 'ssdeep') && (
                <Tabs.TabPane
                  className={styles.tab_pane}
                  tab="Explore"
                  key={`explore-${type}`}
                >
                  <Monitor
                    monitorModalVisible={monitorModalVisible}
                    handleModalCancel={handleModalCancel}
                    currentQuery={currentQuery}
                    origin_uid={getOriginUID()}
                    type={type}
                    websocketConnection={props?.websocketConnection}
                  />
                  <Modal
                    footer={null}
                    title="Export records"
                    visible={exportModalVisible}
                    onCancel={handleModalCancel}
                  >
                    {selectedRowKeys?.length > 0 ? (
                      <span>
                        Export selected {selectedRowKeys?.length} row
                        {selectedRowKeys?.length > 1 ? 's' : ''}
                      </span>
                    ) : (
                      <span>
                        {!currentQuery?.includes('/monitoringResults/')
                          ? 'Export number of rows (between 1 and 10.000): '
                          : 'Export all rows'}
                      </span>
                    )}
                    {selectedRowKeys?.length === 0 &&
                    !currentQuery?.includes('/monitoringResults/') &&
                    !currentQuery?.includes('/historyQueryResults/') ? (
                      <Input
                        min="1"
                        max="10000"
                        maxLength={5}
                        value={exportLimit}
                        //defaultValue={100}
                        placeholder={'Enter a number'}
                        style={{ minWidth: '120px', maxWidth: '120px' }}
                        //onChange={(value) => setExportLimit(value)}
                        onChange={(e) => changeExportLimit(e.target.value)}
                      />
                    ) : (
                      ''
                    )}
                    <Alert
                      style={{ marginTop: '10px' }}
                      description={
                        <span>
                          Sort by Type is not supported
                          <br />
                          Filter by Query, Answer and Type are not supported
                        </span>
                      }
                      type="info"
                      showIcon
                      banner
                    />
                    <div className="export_button_container">
                      <Button
                        onClick={() => handleModalCancel()}
                        className="tab_cancel"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          (pageResultsTotal !== undefined &&
                            pageResultsTotal === resultsTotal) ||
                          exportLimit <= getTotalResults() ||
                          selectedRowKeys?.length > 0 ||
                          currentQuery?.includes('/monitoringResults/')
                            ? saveToCSVFile(getRows())
                            : CSVBackendExport();
                        }}
                        className="tab_save"
                      >
                        CSV
                      </Button>
                      <Button
                        onClick={() => {
                          (pageResultsTotal !== undefined &&
                            pageResultsTotal === resultsTotal) ||
                          exportLimit <= getTotalResults() ||
                          selectedRowKeys?.length > 0 ||
                          currentQuery?.includes('/monitoringResults/')
                            ? saveToFile(
                                type === 'anyIP'
                                  ? exploreAnyIPData
                                  : exploreData?.response?.records,
                              )
                            : JsonBackendExport();
                        }}
                        className="tab_save"
                      >
                        JSON
                      </Button>
                    </div>
                  </Modal>
                  {showExploreSaveCollectionModal && (
                    <ExistingFeedCollectionSaveModal
                      selectedRows={selectedRowData}
                      queryType={type}
                      isExploreSaveFeedCollectionModalVisible={
                        showExploreSaveCollectionModal
                      }
                      typeOfContainer={'collection'}
                      setIsExploreSaveFeedCollectionModalVisible={
                        setShowExploreSaveCollectionModal
                      }
                      feeds={props?.collections}
                      user={props?.user}
                      handleSave={({
                        uuidOfDomainContainer,
                        uuidOfIPContainer,
                      }) => {
                        saveToFeed({
                          allExploreData:
                            type === 'anyIP'
                              ? exploreAnyIPData
                              : exploreData?.response?.records,
                          createOrSelected: 'SELECTED',
                          containerState: 'COLLECTION',
                          uuidOfDomainContainer,
                          uuidOfIPContainer,
                        });
                        incrementUIRequestsCounter();
                      }}
                      props={props}
                    />
                  )}
                  <NewFeedCollectionExploreModal
                    selectedRows={selectedRowData}
                    isNewExploreSaveFeedCollectionModalVisible={
                      isNewExploreSaveCollectionModalVisible
                    }
                    setIsNewExploreSaveFeedCollectionModalVisible={
                      setIsNewExploreSaveCollectionModalVisible
                    }
                    typeOfContainer={'collection'}
                    queryType={type}
                    handleSave={({
                      nameOfDomainContainer,
                      nameOfIPContainer,
                    }) => {
                      createFeed({
                        allExploreData:
                          type === 'anyIP'
                            ? exploreAnyIPData
                            : exploreData?.response?.records,
                        createOrSelected: 'CREATE',
                        containerState: 'COLLECTION',
                        nameOfDomainContainer,
                        nameOfIPContainer,
                      });
                      incrementUIRequestsCounter();
                    }}
                  />
                  {showExploreSaveFeedModal && (
                    <ExistingFeedCollectionSaveModal
                      selectedRows={selectedRowData}
                      queryType={type}
                      isExploreSaveFeedCollectionModalVisible={
                        showExploreSaveFeedModal
                      }
                      typeOfContainer={'feed'}
                      setIsExploreSaveFeedCollectionModalVisible={
                        setShowExploreSaveFeedModal
                      }
                      feeds={feeds}
                      user={props?.user}
                      handleSave={({
                        uuidOfDomainContainer,
                        uuidOfIPContainer,
                      }) => {
                        saveToFeed({
                          allExploreData:
                            type === 'anyIP'
                              ? exploreAnyIPData
                              : exploreData?.response?.records,
                          createOrSelected: 'SELECTED',
                          containerState: 'FEED',
                          uuidOfDomainContainer,
                          uuidOfIPContainer,
                        });
                        incrementUIRequestsCounter();
                      }}
                      props={props}
                    />
                  )}
                  <NewFeedCollectionExploreModal
                    selectedRows={selectedRowData}
                    isNewExploreSaveFeedCollectionModalVisible={
                      isNewExploreSaveFeedModalVisible
                    }
                    setIsNewExploreSaveFeedCollectionModalVisible={
                      setIsNewExploreSaveFeedModalVisible
                    }
                    typeOfContainer={'feed'}
                    queryType={type}
                    handleSave={({
                      nameOfDomainContainer,
                      nameOfIPContainer,
                    }) => {
                      createFeed({
                        allExploreData:
                          type === 'anyIP'
                            ? exploreAnyIPData
                            : exploreData?.response?.records,
                        createOrSelected: 'CREATE',
                        containerState: 'FEED',
                        nameOfDomainContainer,
                        nameOfIPContainer,
                      });
                      incrementUIRequestsCounter();
                    }}
                  />
                  {queryType !== 'ipdiversity' && queryType !== 'nschanges'
                    ? breadCrumbs()
                    : ''}
                  {queryType !== 'ipdiversity' && queryType !== 'nschanges' ? (
                    <>
                      <div
                        data-cy="hostingInfrastructureRecipeResultsPreviousButton"
                        onClick={requestPrevResults}
                      >
                        <Button
                          icon={
                            <LeftArrow
                              style={{
                                fill:
                                  currentSkipAmount === 0
                                    ? 'rgba(89, 89, 89, 1)'
                                    : 'rgba(60, 154, 232, 1)',
                              }}
                            />
                          }
                          disabled={
                            currentSkipAmount === 0 ||
                            exploreData?.response?.metadata?.query_name ===
                              'padns/search/ipdiversity' ||
                            type === 'historyQueryResults' ||
                            type === 'monitoringResults'
                              ? true
                              : false
                          }
                          className={styles.pagination_button}
                          style={{
                            position: 'absolute',
                            right: '100px',
                            top: '-40px',
                            border: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '5px',
                          }}
                        >
                          Previous
                        </Button>
                      </div>
                      <div
                        data-cy="hostingInfrastructureRecipeResultsNextButton"
                        onClick={requestNextResults}
                      >
                        <Button
                          disabled={
                            (exploreData?.response?.metadata?.query_name ===
                              'padns/search/ipdiversity' ||
                            type === 'historyQueryResults' ||
                            type === 'monitoringResults'
                              ? true
                              : false) ||
                            (exploreData?.response?.metadata?.results_returned
                              ? exploreData?.response?.metadata
                                  ?.results_returned ===
                                exploreData?.response?.metadata
                                  ?.results_total_at_least
                              : false)
                          }
                          className={styles.pagination_button}
                          style={{
                            position: 'absolute',
                            right: '13px',
                            top: '-40px',
                            border: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '5px',
                          }}
                        >
                          Next
                          <LeftArrow
                            style={{
                              transform: 'rotate(180deg)',
                              fill:
                                exploreData?.response?.metadata?.query_name ===
                                  'padns/search/ipdiversity' ||
                                type === 'historyQueryResults' ||
                                type === 'monitoringResults' ||
                                (exploreData?.response?.metadata
                                  ?.results_returned &&
                                  exploreData?.response?.metadata
                                    ?.results_returned ===
                                    exploreData?.response?.metadata
                                      ?.results_total_at_least)
                                  ? 'rgba(89, 89, 89, 1)'
                                  : 'rgba(60, 154, 232, 1)',
                            }}
                          />
                        </Button>
                      </div>

                      {queryType &&
                      !(
                        queryType === 'ipdiversity' || queryType === 'nschanges'
                      ) ? (
                        <Tooltip
                          title={
                            mySubscriptionPlan?.has_access_to_monitoring ? (
                              monitoringTooltipTitle()
                            ) : (
                              <>
                                Monitoring is not part of this subscription
                                plan. To upgrade your subscription contact us at{' '}
                                <a
                                  target="_blank"
                                  href="mailto:sales@silentpush.com"
                                >
                                  sales@silentpush.com
                                </a>
                                .
                              </>
                            )
                          }
                        >
                          <Button
                            type="primary"
                            style={{
                              position: 'absolute',
                              right: '140px',
                              top: '12px',
                              border: 'none',
                              zIndex: 9,
                            }}
                            disabled={
                              !mySubscriptionPlan?.has_access_to_monitoring
                                ? true
                                : exploreData?.response?.metadata
                                    ?.query_name ===
                                    'padns/search/ipdiversity' ||
                                  type == 'historyQueryResults' ||
                                  type == 'hosting_infrastructure_asn' ||
                                  type == 'dangling_dns_detection' ||
                                  queryType === 'monitoringResults' ||
                                  exploreData?.response?.records?.[0]
                                    ?.domain_asns ||
                                  exploreData?.response?.records?.[0]
                                    ?.dangling ||
                                  exploreData?.response?.certificates ||
                                  exploreData?.response?.jarm ||
                                  exploreData?.response?.favicon ||
                                  exploreData?.response?.ssdeep
                                ? true
                                : false
                            }
                            onClick={() => setMonitorModalVisible(true)}
                          >
                            Monitor
                          </Button>
                        </Tooltip>
                      ) : (
                        ''
                      )}
                      <div
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '12px',
                        }}
                      >
                        <Tooltip
                          title={
                            mySubscriptionPlan?.has_access_to_explore &&
                            mySubscriptionPlan?.has_access_to_sources ? (
                              !hasSelected ? (
                                'Please select an observable to enable saving.'
                              ) : (
                                ''
                              )
                            ) : (
                              <>
                                Saving observables in the feed or collection is
                                not part of this subscription plan. To upgrade
                                your subscription contact us at{' '}
                                <a
                                  target="_blank"
                                  href="mailto:sales@silentpush.com"
                                >
                                  sales@silentpush.com
                                </a>
                                .
                              </>
                            )
                          }
                        >
                          <div>
                            <Cascader
                              disabled={
                                (!hasSelected &&
                                  !mySubscriptionPlan?.has_access_to_explore) ||
                                !mySubscriptionPlan?.has_access_to_sources
                              }
                              onChange={handleSaveFromExploreToFeedOrCollection}
                              options={saveToDropdownOptions}
                            >
                              <Button
                                role="img"
                                aria-label="saveTo"
                                color="rgb(60, 154, 232)"
                                style={{
                                  color: '#3C9AE8',
                                  border: '1px solid rgb(60, 154, 232)',
                                  borderRadius: 4,
                                  width: 104,
                                }}
                                disabled={
                                  !hasSelected ||
                                  !mySubscriptionPlan?.has_access_to_explore ||
                                  !mySubscriptionPlan?.has_access_to_sources ||
                                  type === 'hosting_infrastructure_asn'
                                }
                              >
                                Save to <DownOutlined />
                              </Button>
                            </Cascader>
                          </div>
                        </Tooltip>
                      </div>
                    </>
                  ) : (
                    ''
                  )}

                  {queryType !== 'ipdiversity' && queryType !== 'nschanges'
                    ? renderTableData()
                    : ''}

                  {queryType === 'nschanges' &&
                  exploreData?.response?.nschanges?.nschanges &&
                  exploreData?.response?.nschanges?.nschanges?.length > 0 ? (
                    <>
                      <div style={{ position: 'relative' }}>
                        <span
                          style={{
                            textAlign: 'left',
                            position: 'absolute',
                            top: '16px',
                            left: '16px',
                            fontWeight: 'bold',
                            fontSize: '18px',
                          }}
                        >
                          Summary results -{' '}
                          {name?.length >= 80
                            ? name?.substring(0, 77) + '...'
                            : name}
                        </span>

                        <span
                          style={{
                            position: 'absolute',
                            left: '16px',
                            top: '53px',
                          }}
                        >
                          NS Entropy{' '}
                          <Tooltip
                            title={
                              'Formulated score incorporating recency, frequency, and number of NS changes. Any entropy is noteworthy.'
                            }
                          >
                            <TooltipIcon />
                          </Tooltip>
                          <p
                            style={{
                              marginBottom: '4px',
                              fontSize: '16px',
                              textAlign: 'left',
                              fontWeight: 'bold',
                            }}
                          >
                            {
                              exploreData?.response?.nschanges?.results_summary
                                ?.ns_entropy
                            }{' '}
                            <span style={{ fontWeight: 'normal' }}>
                              (score)
                            </span>
                          </p>
                          <p>
                            <ProgressBar
                              bgcolor={scoreColor(
                                exploreData?.response?.nschanges
                                  ?.results_summary?.ns_entropy_score,
                              )}
                              width={'72'}
                              completed={
                                exploreData?.response?.nschanges
                                  ?.results_summary?.ns_entropy_score
                              }
                            />
                          </p>
                        </span>
                        <span
                          style={{
                            position: 'absolute',
                            left: '140px',
                            top: '53px',
                          }}
                        >
                          Number of Changes
                          <p
                            style={{
                              fontSize: '16px',
                              textAlign: 'left',
                              fontWeight: 'bold',
                            }}
                          >
                            {exploreData?.response?.nschanges?.results_summary?.num_changes_all?.toString() ??
                              0}
                          </p>
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'left',
                            position: 'absolute',
                            left: '300px',
                            top: '53px',
                          }}
                        >
                          <p style={{ marginTop: '0px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes from 0 to 7 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_0_7_days
                              }
                            </span>
                          </p>
                          <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes from 7 to 30 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_7_30_days
                              }
                            </span>
                          </p>
                          <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes from 30 to 90 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_30_90_days
                              }
                            </span>
                          </p>
                          <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes in last 7 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_last_7_days
                              }
                            </span>
                          </p>
                          <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes in last 30 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_last_30_days
                              }
                            </span>
                          </p>
                          <p style={{ marginTop: '8px', marginBottom: '0px' }}>
                            <span
                              style={{
                                fontWeight: 'normal',
                                textAlign: 'left',
                              }}
                            >
                              Changes in last 90 days:{' '}
                            </span>
                            <span>
                              {
                                exploreData?.response?.nschanges
                                  ?.results_summary?.changes_last_90_days
                              }
                            </span>
                          </p>
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'left',
                            position: 'absolute',
                            left: '500px',
                            top: '53px',
                          }}
                        >
                          <NSHasChanges
                            nsChanges={exploreData?.response?.nschanges}
                          />
                        </span>
                        <span
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'left',
                            position: 'absolute',
                            left: '950px',
                            top: '53px',
                          }}
                        >
                          <NSLastChanges
                            nsChanges={exploreData?.response?.nschanges}
                          />
                        </span>
                      </div>
                      <span
                        style={{
                          textAlign: 'left',
                          position: 'absolute',
                          left: '16px',
                          top: '380px',
                          fontWeight: 'bold',
                          fontSize: '18px',
                        }}
                      >
                        Detailed results -{' '}
                        {name?.length >= 80
                          ? name?.substring(0, 77) + '...'
                          : name}
                      </span>
                      <div style={{ marginTop: '290px' }}>
                        <Timeline mode="alternate">
                          {exploreData?.response?.nschanges?.nschanges?.map(
                            (timelineElement, index) => {
                              return (
                                <Timeline.Item style={{ minHeight: '200px' }}>
                                  Date:{' '}
                                  <span style={{ fontWeight: '600' }}>
                                    {convertDateString(
                                      timelineElement?.date,
                                      'YYYYMMDD',
                                    )}
                                  </span>
                                  <br />
                                  Days ago:{' '}
                                  <span style={{ fontWeight: '600' }}>
                                    {timelineElement?.days_ago}
                                  </span>
                                  <br />
                                  <br />
                                  <span style={{ fontWeight: '600' }}>
                                    From Name Server
                                  </span>
                                  <br />
                                  {Object.entries(
                                    timelineElement?.from_ns_srv_domain_density,
                                  )?.map((fromNameServer) => {
                                    return (
                                      <span
                                        className={
                                          styles.ns_change_table_column
                                        }
                                      >
                                        <p style={{ marginBottom: '4px' }}>
                                          NS: {fromNameServer[0]}{' '}
                                          <span>
                                            <Link
                                              to={
                                                `/explore-result?name=${fromNameServer[0]}&type=NS&queryType=answer&backLink=` +
                                                encodeURIComponent(
                                                  window.location.pathname,
                                                ) +
                                                encodeURIComponent(
                                                  window.location.search,
                                                ) +
                                                '&origin_uid=Explore'
                                              }
                                            >
                                              <Tooltip title={'Perform lookup'}>
                                                <Button
                                                  onClick={() => {
                                                    //   props.history.push(
                                                    //     `/explore-result?name=${fromNameServer[0]}&type=NS&queryType=answer&backLink=` +
                                                    //       encodeURIComponent(
                                                    //         window.location
                                                    //           .pathname,
                                                    //       ) +
                                                    //       encodeURIComponent(
                                                    //         window.location.search,
                                                    //       ),
                                                    //   );
                                                    mixpanel.track('Explore', {
                                                      location: 'explore',
                                                      ioc_type: 'nschanges',
                                                      explored_type: 'NS',
                                                    });
                                                  }}
                                                  style={{
                                                    border: 0,
                                                    marginLeft: 3,
                                                  }}
                                                  type={'primary'}
                                                  size={'small'}
                                                  icon={<ExploreIcon />}
                                                >
                                                  Lookup PADNS
                                                </Button>
                                              </Tooltip>
                                            </Link>
                                          </span>
                                        </p>
                                        <p style={{ marginBottom: '16px' }}>
                                          NS domain density: {fromNameServer[1]}
                                        </p>
                                      </span>
                                    );
                                  })}
                                  {renderNSChangeFromTags(index)}
                                  <br />
                                  <span style={{ fontWeight: '600' }}>
                                    To Name Server
                                  </span>
                                  <br />
                                  {Object.entries(
                                    timelineElement?.to_ns_srv_domain_density,
                                  )?.map((toNameServer) => {
                                    return (
                                      <span
                                        className={
                                          styles.ns_change_table_column
                                        }
                                      >
                                        <p style={{ marginBottom: '4px' }}>
                                          NS:{' '}
                                          {toNameServer[0]?.length >= 50
                                            ? toNameServer[0]?.substring(
                                                0,
                                                47,
                                              ) + '...'
                                            : toNameServer[0]}{' '}
                                          <span>
                                            <Link
                                              to={
                                                `/explore-result?name=${toNameServer[0]}&type=NS&queryType=answer&backLink=` +
                                                encodeURIComponent(
                                                  window.location.pathname,
                                                ) +
                                                encodeURIComponent(
                                                  window.location.search,
                                                ) +
                                                '&origin_uid=Explore'
                                              }
                                            >
                                              <Tooltip title={'Perform lookup'}>
                                                <Button
                                                  onClick={() => {
                                                    //   props.history.push(
                                                    //     `/explore-result?name=${toNameServer[0]}&type=NS&queryType=answer&backLink=` +
                                                    //       encodeURIComponent(
                                                    //         window.location
                                                    //           .pathname,
                                                    //       ) +
                                                    //       encodeURIComponent(
                                                    //         window.location.search,
                                                    //       ),
                                                    //   );
                                                    mixpanel.track('Explore', {
                                                      location: 'explore',
                                                      ioc_type: 'nschanges',
                                                      explored_type: 'NS',
                                                    });
                                                  }}
                                                  style={{
                                                    border: 0,
                                                    marginLeft: 3,
                                                  }}
                                                  type={'primary'}
                                                  size={'small'}
                                                  icon={<ExploreIcon />}
                                                >
                                                  Lookup PADNS
                                                </Button>
                                              </Tooltip>
                                            </Link>
                                          </span>
                                        </p>
                                        <p style={{ marginBottom: '16px' }}>
                                          NS domain density: {toNameServer[1]}
                                        </p>
                                      </span>
                                      // </div>
                                    );
                                  })}
                                  {renderNSChangeToTags(index)}
                                  <br />
                                </Timeline.Item>
                              );
                            },
                          )}
                        </Timeline>
                      </div>
                    </>
                  ) : queryType === 'nschanges' &&
                    exploreData?.response?.nschanges?.nschanges &&
                    exploreData?.response?.nschanges?.nschanges?.length ===
                      0 ? (
                    <>
                      <NoDataIcon style={{ marginTop: '16px', fontSize: 40 }} />
                      <p style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Given domain didn't yield any results
                      </p>
                      <p style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        Click{' '}
                        <p
                          style={{
                            cursor: 'pointer',
                            color: '#3C9AE8',
                            display: 'inline',
                          }}
                          onClick={() =>
                            props.history.push(
                              `/explore-result?name=${name}&type=NS&queryType=query`,
                            )
                          }
                        >
                          {' '}
                          here
                        </p>{' '}
                        to get basic explore - Name Server lookup for given
                        domain, or{' '}
                        <p
                          style={{
                            cursor: 'pointer',
                            color: '#3C9AE8',
                            display: 'inline',
                          }}
                          onClick={gotoLastBreadCrumb}
                        >
                          go back
                        </p>{' '}
                        to start with another domain.
                      </p>
                    </>
                  ) : queryType === 'nschanges' &&
                    !exploreData?.response?.nschanges?.nschanges ? (
                    <>
                      <NoDataIcon style={{ marginTop: '16px', fontSize: 40 }} />
                      <p style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Given domain didn't yield any results
                      </p>
                      {name.startsWith('http://') ||
                      name.startsWith('https://') ||
                      name.startsWith('www.') ||
                      name.includes('/') ? (
                        <p style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
                          Try removing "http://" or "www." from the search,
                          along with directories/parameters of the URL, or click{' '}
                          <p
                            style={{
                              cursor: 'pointer',
                              color: '#3C9AE8',
                              display: 'inline',
                            }}
                            onClick={() => retryURL()}
                          >
                            here
                          </p>
                        </p>
                      ) : (
                        ''
                      )}
                      <p style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        Click{' '}
                        <p
                          style={{
                            cursor: 'pointer',
                            color: '#3C9AE8',
                            display: 'inline',
                          }}
                          onClick={() =>
                            props.history.push(
                              `/explore-result?name=${name}&type=NS&queryType=query`,
                            )
                          }
                        >
                          {' '}
                          here
                        </p>{' '}
                        to get basic explore - Name Server lookup for given
                        domain, or{' '}
                        <p
                          style={{
                            cursor: 'pointer',
                            color: '#3C9AE8',
                            display: 'inline',
                          }}
                          onClick={gotoLastBreadCrumb}
                        >
                          go back
                        </p>{' '}
                        to start with another domain.
                      </p>
                    </>
                  ) : (
                    ''
                  )}
                </Tabs.TabPane>
              )) ||
                (type === 'NS' && (
                  <Tabs.TabPane
                    className={styles.tab_pane}
                    tab="Explore"
                    key="explore-ns"
                  >
                    <Monitor
                      monitorModalVisible={monitorModalVisible}
                      handleModalCancel={handleModalCancel}
                      currentQuery={currentQuery}
                      origin_uid={getOriginUID()}
                      type={type}
                      websocketConnection={props?.websocketConnection}
                    />
                    <Modal
                      footer={null}
                      title="Export"
                      visible={exportModalVisible}
                      onCancel={handleModalCancel}
                    >
                      {selectedRowKeys?.length > 0 ? (
                        <span>
                          Export selected {selectedRowKeys?.length} row
                          {selectedRowKeys?.length > 1 ? 's' : ''}
                        </span>
                      ) : (
                        <span>
                          {!currentQuery?.includes('/monitoringResults/')
                            ? 'Export number of rows (between 1 and 10.000): '
                            : 'Export all rows'}
                        </span>
                      )}
                      {selectedRowKeys?.length === 0 &&
                      !currentQuery?.includes('/monitoringResults/') ? (
                        <Input
                          min="1"
                          max="10000"
                          maxLength={5}
                          value={exportLimit}
                          //defaultValue={100}
                          placeholder={'Enter a number'}
                          style={{ minWidth: '120px', maxWidth: '120px' }}
                          // onChange={(value) => setExportLimit(value)}
                          onChange={(e) => changeExportLimit(e.target.value)}
                        />
                      ) : (
                        ''
                      )}
                      <Alert
                        style={{ marginTop: '10px' }}
                        description={
                          <span>
                            Sort by Type is not supported
                            <br />
                            Filter by Query, Answer and Type are not supported
                          </span>
                        }
                        type="info"
                        showIcon
                        banner
                      />
                      <div className="export_button_container">
                        <Button
                          onClick={() => handleModalCancel()}
                          className="tab_cancel"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={() => {
                            (pageResultsTotal !== undefined &&
                              pageResultsTotal === resultsTotal) ||
                            exportLimit <= getTotalResults() ||
                            selectedRowKeys?.length > 0 ||
                            currentQuery?.includes('/monitoringResults/')
                              ? saveToCSVFile(getRows())
                              : CSVBackendExport();
                          }}
                          className="tab_save"
                        >
                          CSV
                        </Button>
                        <Button
                          onClick={() => {
                            (pageResultsTotal !== undefined &&
                              pageResultsTotal === resultsTotal) ||
                            exportLimit <= getTotalResults() ||
                            selectedRowKeys?.length > 0 ||
                            currentQuery?.includes('/monitoringResults/')
                              ? saveToFile(
                                  type === 'anyIP'
                                    ? exploreAnyIPData
                                    : exploreData?.response?.records,
                                )
                              : JsonBackendExport();
                          }}
                          className="tab_save"
                        >
                          JSON
                        </Button>
                      </div>
                    </Modal>
                    {showExploreSaveCollectionModal && (
                      <ExistingFeedCollectionSaveModal
                        selectedRows={selectedRowData}
                        queryType={type}
                        isExploreSaveFeedCollectionModalVisible={
                          showExploreSaveCollectionModal
                        }
                        typeOfContainer={'collection'}
                        setIsExploreSaveFeedCollectionModalVisible={
                          setShowExploreSaveCollectionModal
                        }
                        feeds={props?.collections}
                        user={props?.user}
                        handleSave={({
                          uuidOfDomainContainer,
                          uuidOfIPContainer,
                        }) => {
                          saveToFeed({
                            allExploreData:
                              type === 'anyIP'
                                ? exploreAnyIPData
                                : exploreData?.response?.records,
                            createOrSelected: 'SELECTED',
                            containerState: 'COLLECTION',
                            uuidOfDomainContainer,
                            uuidOfIPContainer,
                          });
                          incrementUIRequestsCounter();
                        }}
                        props={props}
                      />
                    )}
                    <NewFeedCollectionExploreModal
                      selectedRows={selectedRowData}
                      isNewExploreSaveFeedCollectionModalVisible={
                        isNewExploreSaveCollectionModalVisible
                      }
                      setIsNewExploreSaveFeedCollectionModalVisible={
                        setIsNewExploreSaveCollectionModalVisible
                      }
                      typeOfContainer={'collection'}
                      queryType={type}
                      handleSave={({
                        nameOfDomainContainer,
                        nameOfIPContainer,
                      }) => {
                        createFeed({
                          allExploreData:
                            type === 'anyIP'
                              ? exploreAnyIPData
                              : exploreData?.response?.records,
                          createOrSelected: 'CREATE',
                          containerState: 'COLLECTION',
                          nameOfDomainContainer,
                          nameOfIPContainer,
                        });
                        incrementUIRequestsCounter();
                      }}
                    />
                    {showExploreSaveFeedModal && (
                      <ExistingFeedCollectionSaveModal
                        selectedRows={selectedRowData}
                        queryType={type}
                        isExploreSaveFeedCollectionModalVisible={
                          showExploreSaveFeedModal
                        }
                        typeOfContainer={'feed'}
                        setIsExploreSaveFeedCollectionModalVisible={
                          setShowExploreSaveFeedModal
                        }
                        feeds={feeds}
                        user={props?.user}
                        handleSave={({
                          uuidOfDomainContainer,
                          uuidOfIPContainer,
                        }) => {
                          saveToFeed({
                            allExploreData:
                              type === 'anyIP'
                                ? exploreAnyIPData
                                : exploreData?.response?.records,
                            createOrSelected: 'SELECTED',
                            containerState: 'FEED',
                            uuidOfDomainContainer,
                            uuidOfIPContainer,
                          });
                          incrementUIRequestsCounter();
                        }}
                        props={props}
                      />
                    )}
                    <NewFeedCollectionExploreModal
                      selectedRows={selectedRowData}
                      isNewExploreSaveFeedCollectionModalVisible={
                        isNewExploreSaveFeedModalVisible
                      }
                      setIsNewExploreSaveFeedCollectionModalVisible={
                        setIsNewExploreSaveFeedModalVisible
                      }
                      typeOfContainer={'feed'}
                      queryType={type}
                      handleSave={({
                        nameOfDomainContainer,
                        nameOfIPContainer,
                      }) => {
                        createFeed({
                          allExploreData:
                            type === 'anyIP'
                              ? exploreAnyIPData
                              : exploreData?.response?.records,
                          createOrSelected: 'CREATE',
                          containerState: 'FEED',
                          nameOfDomainContainer,
                          nameOfIPContainer,
                        });
                        incrementUIRequestsCounter();
                      }}
                    />
                    {breadCrumbs()}

                    {exploreData?.response?.metadata?.query_name?.includes(
                      'answer',
                    ) ? (
                      <span>
                        Density:{' '}
                        {densityStatus === STATUS.LOADED ? (
                          densityData?.response?.records?.[0]?.density
                        ) : (
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ fontSize: '24px' }} />
                            }
                          />
                        )}
                      </span>
                    ) : (
                      ''
                    )}
                    {queryType !== 'ipdiversity' &&
                    queryType !== 'nschanges' ? (
                      <>
                        <div
                          data-cy="hostingInfrastructureRecipeResultsPreviousButton"
                          onClick={requestPrevResults}
                        >
                          <Button
                            disabled={
                              // !mySubscriptionPlan?.has_access_to_explore &&
                              currentSkipAmount === 0 ? true : false
                            }
                            className={styles.pagination_button}
                            icon={
                              <LeftArrow
                                style={{
                                  fill:
                                    currentSkipAmount === 0
                                      ? 'rgba(89, 89, 89, 1)'
                                      : 'rgba(60, 154, 232, 1)',
                                }}
                              />
                            }
                            style={{
                              position: 'absolute',
                              right: '260px',
                              top: '-40px',
                              border: 'none',
                              display: 'inline-flex',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              gap: '5px',
                            }}
                          >
                            Previous
                          </Button>
                        </div>
                        <div
                          data-cy="hostingInfrastructureRecipeResultsNextButton"
                          onClick={requestNextResults}
                        >
                          <Button
                            disabled={
                              // !mySubscriptionPlan?.has_access_to_explore &&
                              (exploreData?.response?.metadata?.query_name ===
                                'padns/search/ipdiversity' ||
                              type === 'historyQueryResults' ||
                              type === 'monitoringResults'
                                ? true
                                : false) ||
                              (exploreData?.response?.metadata?.results_returned
                                ? exploreData?.response?.metadata
                                    ?.results_returned ===
                                  exploreData?.response?.metadata
                                    ?.results_total_at_least
                                : false)
                            }
                            className={styles.pagination_button}
                            style={{
                              position: 'absolute',
                              right: '160px',
                              top: '-40px',
                              border: 'none',
                              display: 'inline-flex',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              gap: '5px',
                            }}
                          >
                            Next
                            <LeftArrow
                              style={{
                                transform: 'rotate(180deg)',
                                fill:
                                  exploreData?.response?.metadata
                                    ?.query_name ===
                                    'padns/search/ipdiversity' ||
                                  type === 'historyQueryResults' ||
                                  type === 'monioringResults' ||
                                  exploreData?.response?.metadata
                                    ?.results_returned ===
                                    exploreData?.response?.metadata
                                      ?.results_total_at_least
                                    ? 'rgba(89, 89, 89, 1)'
                                    : 'rgba(60, 154, 232, 1)',
                              }}
                            />
                          </Button>
                        </div>
                        {queryType &&
                        !(
                          queryType === 'ipdiversity' ||
                          queryType === 'nschanges'
                        ) ? (
                          <Tooltip
                            title={
                              mySubscriptionPlan?.has_access_to_monitoring ? (
                                exploreData?.response?.metadata?.query_name ===
                                'padns/search/ipdiversity' ? (
                                  'Monitoring for this query is not available.'
                                ) : (
                                  ''
                                )
                              ) : (
                                <>
                                  Monitoring is not part of this subscription
                                  plan. To upgrade your subscription contact us
                                  at{' '}
                                  <a
                                    target="_blank"
                                    href="mailto:sales@silentpush.com"
                                  >
                                    sales@silentpush.com
                                  </a>
                                  .
                                </>
                              )
                            }
                          >
                            <Button
                              type="primary"
                              style={{
                                position: 'absolute',
                                right: '140px',
                                top: '12px',
                                border: 'none',
                                zIndex: 9,
                              }}
                              disabled={
                                !mySubscriptionPlan?.has_access_to_monitoring
                                  ? true
                                  : exploreData?.response?.metadata
                                      ?.query_name ===
                                      'padns/search/ipdiversity' ||
                                    type == 'historyQueryResults' ||
                                    type == 'hosting_infrastructure_asn' ||
                                    type == 'dangling_dns_detection' ||
                                    queryType === 'monitoringResults' ||
                                    exploreData?.response?.records?.[0]
                                      ?.domain_asns ||
                                    exploreData?.response?.records?.[0]
                                      ?.dangling ||
                                    exploreData?.response?.certificates ||
                                    exploreData?.response?.jarm ||
                                    exploreData?.response?.favicon ||
                                    exploreData?.response?.ssdeep
                                  ? true
                                  : false
                              }
                              onClick={() => setMonitorModalVisible(true)}
                            >
                              Monitor
                            </Button>
                          </Tooltip>
                        ) : (
                          ''
                        )}
                        <div
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '12px',
                          }}
                        >
                          <Tooltip
                            title={
                              mySubscriptionPlan?.has_access_to_sources ? (
                                ''
                              ) : (
                                <>
                                  Saving observables in the feed or collection
                                  is not part of this subscription plan. To
                                  upgrade your subscription contact us at{' '}
                                  <a
                                    target="_blank"
                                    href="mailto:sales@silentpush.com"
                                  >
                                    sales@silentpush.com
                                  </a>
                                  .
                                </>
                              )
                            }
                          >
                            <div>
                              <Cascader
                                disabled={
                                  (!hasSelected &&
                                    !mySubscriptionPlan?.has_access_to_explore) ||
                                  !mySubscriptionPlan?.has_access_to_sources
                                }
                                onChange={
                                  handleSaveFromExploreToFeedOrCollection
                                }
                                options={saveToDropdownOptions}
                              >
                                <Button
                                  role="img"
                                  aria-label="saveTo"
                                  style={{
                                    color: '#3C9AE8',
                                    border: '1px solid rgb(60, 154, 232)',
                                    borderRadius: 4,
                                    width: 104,
                                  }}
                                  disabled={
                                    !hasSelected ||
                                    !mySubscriptionPlan?.has_access_to_explore ||
                                    !mySubscriptionPlan?.has_access_to_sources ||
                                    type === 'hosting_infrastructure_asn'
                                  }
                                >
                                  Save to <DownOutlined />
                                </Button>
                              </Cascader>
                            </div>
                          </Tooltip>
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                    {renderTableData()}
                  </Tabs.TabPane>
                ))}

              {((type === 'nshash' ||
                type === 'host' ||
                type === 'NS' ||
                type === 'any' ||
                type === 'A' ||
                type === 'TXT' ||
                type === 'TXTHASH' ||
                type === 'MXHASH' ||
                type === 'NSHASH' ||
                type === 'SOAHASH' ||
                type === 'SOA' ||
                type === 'AAAA' ||
                type === 'MX' ||
                type === 'CNAME' ||
                type === 'PTR4' ||
                type === 'PTR6' ||
                type === 'historyQueryResults' ||
                type === 'dangling_dns_detection' ||
                type === 'hosting_infrastructure_asn' ||
                type === 'asn' ||
                type === 'jarm' ||
                type === 'favicon' ||
                type === 'certificates' ||
                type === 'monitoringResults' ||
                type === 'ssdeep') && (
                <Tabs.TabPane
                  className={styles.tab_pane}
                  tab="Basic Raw Data"
                  key="raw-data"
                >
                  <div>
                    <div style={{ textAlign: 'left' }}>
                      <Tooltip title="Copy Raw Data">
                        <Button
                          icon={<CopyIcon />}
                          ghost
                          style={{
                            border: 0,
                            display: 'inline',
                            color: 'white',
                          }}
                          onClick={() => {
                            copyRawData(exploreData);
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div>
                      <PrettyPrintJson data={exploreData} />
                    </div>
                  </div>
                </Tabs.TabPane>
              )) ||
                (type === 'queryBuilder' && (
                  <Tabs.TabPane
                    className={styles.tab_pane}
                    tab="Basic Raw Data"
                    key="raw-data"
                  >
                    <div>
                      <div style={{ textAlign: 'left' }}>
                        Copy Raw Data:{' '}
                        <Tooltip title="Copy Raw Data">
                          <Button
                            icon={<CopyIcon />}
                            ghost
                            style={{
                              border: 0,
                              display: 'inline',
                              color: 'white',
                            }}
                            onClick={() => {
                              copyRawData(
                                q.get('baseURLType') === 'merge'
                                  ? mergeData
                                  : exploreData,
                              );
                            }}
                          />
                        </Tooltip>
                        Copy API URL:{' '}
                        <Tooltip title="Copy API URL">
                          <Button
                            icon={<CopyIcon />}
                            ghost
                            style={{
                              border: 0,
                              display: 'inline',
                              color: 'white',
                            }}
                            onClick={() => {
                              copyAPIURL(
                                q.get('baseURLType') === 'merge'
                                  ? 'https://api.silentpush.com/api/v1/merge-api/' +
                                      'merge' +
                                      decodeURIComponent(
                                        q.get('queryBuilderURL'),
                                      )
                                  : 'https://api.silentpush.com/api/v1/merge-api/' +
                                      'explore' +
                                      decodeURIComponent(
                                        q.get('queryBuilderURL'),
                                      ),
                              );
                            }}
                          />
                        </Tooltip>
                      </div>
                      <div>
                        <PrettyPrintJson
                          data={
                            q.get('baseURLType') === 'merge'
                              ? mergeData
                              : exploreData
                          }
                        />
                      </div>
                    </div>
                  </Tabs.TabPane>
                )) ||
                ((type === 'anyIP' ||
                  type === 'ANYIPV4' ||
                  type === 'ANYIPV6') && (
                  <Tabs.TabPane
                    className={styles.tab_pane}
                    tab="Basic Raw Data"
                    key="raw-data"
                  >
                    <div>
                      <div style={{ textAlign: 'left' }}>
                        <Tooltip title="Copy Raw Data">
                          <Button
                            icon={<CopyIcon />}
                            ghost
                            style={{
                              border: 0,
                              display: 'inline',
                              color: 'white',
                            }}
                            onClick={() => {
                              copyRawData(
                                type === 'anyIP'
                                  ? exploreAnyIPData
                                  : exploreData?.response?.records,
                              );
                            }}
                          />
                        </Tooltip>
                      </div>
                      <div>
                        <PrettyPrintJson
                          data={
                            type === 'anyIP'
                              ? exploreAnyIPData
                              : exploreData?.response?.records
                          }
                        />
                      </div>
                    </div>
                    {/* ))} */}
                  </Tabs.TabPane>
                ))}
            </Tabs>
          </>
        )}
      </div>
    ) : (
      <PermissionDeniedPage
        message={
          <>
            Enrichment is not part of this subscription plan. To upgrade your
            subscription contact us at{' '}
            <a target="_blank" href="mailto:sales@silentpush.com">
              sales@silentpush.com
            </a>
            .
          </>
        }
      />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

const NSLastChanges = ({ nsChanges, ...props }) => {
  function convertDateString(text, format) {
    let datetime = 'n/a';

    if (!!text && text !== 'UNKNOWN') {
      datetime = moment.utc(text, format).format('YYYY-MM-DD').toString();
    }

    return datetime;
  }
  const changesFlags = [
    {
      title: 'Domain moved to a NS previously used',
      condition: nsChanges?.results_summary?.last_change_circular,
    },
    {
      title: 'Domain was on NS that hosts expired domains',
      condition: nsChanges?.results_summary?.last_change_expire_from,
    },
    {
      title: 'Domain moved to NS that hosts expired domains',
      condition: nsChanges?.results_summary?.last_change_expire_to,
    },
    {
      title: 'Domain was on self-hosted (self-named) NS',
      condition: nsChanges?.results_summary?.last_change_ns_in_domain_from,
    },
    {
      title: 'Domain moved to self-hosted (self-named) NS',
      condition: nsChanges?.results_summary?.last_change_ns_in_domain_to,
    },
    {
      title: 'Domain was on NS that only hosts a small number of domains',
      condition:
        nsChanges?.results_summary?.last_change_ns_srv_domain_density_low_from,
    },
    {
      title: 'Domain moved to NS that only hosts a small number of domains',
      condition:
        nsChanges?.results_summary?.last_change_ns_srv_domain_density_low_to,
    },
    {
      title: 'Domain was on NS that hosts parked domains',
      condition: nsChanges?.results_summary?.last_change_parked_from,
    },
    {
      title: 'Domain moved to NS that hosts parked domains',
      condition: nsChanges?.results_summary?.last_change_parked_to,
    },
    {
      title: 'Domain was on NS that hosts sinkholed domains',
      condition: nsChanges?.results_summary?.last_change_sinkhole_from,
    },
    {
      title: 'Domain moved to NS that hosts sinkholed domains',
      condition: nsChanges?.results_summary?.last_change_sinkhole_to,
    },
  ];
  const renderSection = (title, value, showValue, style = {}) => {
    let titleStyle = {
      fontWeight: 400,
      fontSize: 14,
      color: 'rgba(255, 255, 255, 0.95)',
      display: 'inline-block',
      marginRight: 8,
    };
    if (!showValue) {
      titleStyle = {
        fontWeight: 600,
        fontSize: 14,
        color: 'rgba(255, 255, 255, 0.95)',
        display: 'inline-block',
      };
    }
    return (
      <div style={style}>
        <span style={titleStyle}>{title}</span>
        {showValue && (
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: 'rgba(255, 255, 255, 0.95)',
              display: 'inline-block',
            }}
          >
            {value}
          </span>
        )}
      </div>
    );
  };
  return (
    <div style={{ marginLeft: 24 }}>
      <SectionTitle title={'Last Change'} />
      {renderSection(
        'Last change: ',
        convertDateString(
          nsChanges?.results_summary?.last_change?.toString(),
          'YYYYMMDD',
        ),
        true,
        { marginTop: 8 },
      )}
      {renderSection(
        'Ago (days): ',
        nsChanges?.results_summary?.last_change_days_ago ?? 'n/a',
        true,
        { marginTop: 8 },
      )}
      {changesFlags
        .filter((c) => c['condition'])
        .map((c) => renderSection(c['title'], null, false, { marginTop: 8 }))}
    </div>
  );
};

const NSHasChanges = ({ nsChanges, ...props }) => {
  const changesFlags = [
    {
      title: 'Domain moved to a NS previously used',
      condition: nsChanges?.results_summary?.has_change_circular,
    },
    {
      title: 'Domain was on NS that hosts expired domains',
      condition: nsChanges?.results_summary?.has_change_expire_from,
    },
    {
      title: 'Domain moved to NS that hosts expired domains',
      condition: nsChanges?.results_summary?.has_change_expire_to,
    },
    {
      title: 'Domain was on self-hosted (self-named) NS',
      condition: nsChanges?.results_summary?.has_change_ns_in_domain_from,
    },
    {
      title: 'Domain moved to self-hosted (self-named) NS',
      condition: nsChanges?.results_summary?.has_change_ns_in_domain_to,
    },
    {
      title: 'Domain was on NS that only hosts a small number of domains',
      condition:
        nsChanges?.results_summary?.has_change_ns_srv_domain_density_low_from,
    },
    {
      title: 'Domain moved to NS that only hosts a small number of domains',
      condition:
        nsChanges?.results_summary?.has_change_ns_srv_domain_density_low_to,
    },
    {
      title: 'Domain was on NS that hosts parked domains',
      condition: nsChanges?.results_summary?.has_change_parked_from,
    },
    {
      title: 'Domain moved to NS that hosts parked domains',
      condition: nsChanges?.results_summary?.has_change_parked_to,
    },
    {
      title: 'Domain was on NS that hosts sinkholed domains',
      condition: nsChanges?.results_summary?.has_change_sinkhole_from,
    },
    {
      title: 'Domain moved to NS that hosts sinkholed domains',
      condition: nsChanges?.results_summary?.has_change_sinkhole_to,
    },
  ];
  const renderSection = (title, value, style = {}) => {
    return (
      <div style={style}>
        <span
          style={{
            fontWeight: 500,
            fontSize: 14,
            color: 'rgba(255, 255, 255, 0.95)',
            display: 'inline-block',
          }}
        >
          {title}
        </span>
      </div>
    );
  };
  return (
    <div style={{ marginLeft: 24 }}>
      <SectionTitle title={'Changes'} />
      {changesFlags
        .filter((c) => c.condition)
        .map((c) => renderSection(c['title'], null, { marginTop: 8 }))}
    </div>
  );
};

const NSReputationEntry = ({ nsReputationEntry, history, ...props }) => {
  const ExploreIcon = (props) => (
    <Icon
      component={() => (
        <ExploreSVG fill={'#3C9AE8'} style={{ width: 12, height: 12 }} />
      )}
    />
  );
  const renderSection = (title, value, action, style = {}, lookupPath) => {
    return (
      <div style={style}>
        <span
          style={{
            fontWeight: 400,
            fontSize: 14,
            color: 'rgba(255, 255, 255, 0.95)',
            display: 'inline-block',
            marginRight: 8,
          }}
        >
          {title}
        </span>
        <span
          style={{
            fontWeight: 600,
            fontSize: 14,
            color: 'rgba(255, 255, 255, 0.95)',
            display: 'inline-block',
          }}
        >
          {value}
        </span>
        {action && (
          <Link to={lookupPath}>
            <Tooltip title={'Perform lookup'}>
              <Button
                //onClick={() => action()}
                style={{ border: 0, marginLeft: 3 }}
                type={'primary'}
                size={'small'}
                icon={<ExploreIcon />}
              >
                Lookup PADNS
              </Button>
            </Tooltip>
          </Link>
        )}
      </div>
    );
  };

  return (
    <div style={{ display: 'inline-block', marginRight: 24 }}>
      {renderSection(
        'NS:',
        nsReputationEntry?.ns_server,
        () =>
          history.push(
            `/explore-result?name=${nsReputationEntry?.ns_server}&queryType=answer&type=NS&enrichQuery=` +
              encodeURIComponent(window.location.pathname) +
              encodeURIComponent(window.location.search),
          ),
        null,
        `/explore-result?name=${nsReputationEntry?.ns_server}&queryType=answer&type=NS&enrichQuery=` +
          encodeURIComponent(window.location.pathname) +
          encodeURIComponent(window.location.search),
      )}
      {renderSection(
        'NS domain density:',
        nsReputationEntry?.ns_server_domain_density,
        null,
        { marginTop: 12 },
        null,
      )}
      {renderSection(
        'NS domain listed:',
        nsReputationEntry?.ns_server_domains_listed,
        null,
        { marginTop: 8 },
        null,
      )}
      {renderSection(
        'NS reputation:',
        nsReputationEntry?.ns_server_reputation,
        null,
        {
          marginTop: 8,
        },
        null,
      )}
    </div>
  );
};

const SectionTitle = ({ title, style, ...props }) => {
  return (
    <span style={style} className={enrichStyles['section-title']}>
      {title}
    </span>
  );
};

const ExistingFeedCollectionSaveModal = ({
  isExploreSaveFeedCollectionModalVisible,
  typeOfContainer,
  setIsExploreSaveFeedCollectionModalVisible,
  feeds,
  user,
  handleSave,
  selectedRows,
  queryType,
  props,
}) => {
  const [hasIP, setHasIP] = useState(false);
  const [hasDomain, setHasDomain] = useState(false);

  const [
    selectedDomainFeedCollection,
    setSelectedDomainFeedCollection,
  ] = useState('');
  const [selectedIPFeedCollection, setSelectedIPFeedCollection] = useState('');

  const capitalize = (s) => s[0].toUpperCase() + s.substring(1);

  useEffect(() => {
    if (!selectedRows) return () => {};
    const IPs = extractIPIoCsFromExploreData({
      exploreData: selectedRows,
      typeOfIoC: 'IP',
      queryType,
    });
    const ipsExist = !!IPs && IPs.length > 0;
    setHasIP(ipsExist);

    if (ipsExist) {
      props.loadIPEditableFeeds({
        state: typeOfContainer.toUpperCase(),
      });
    }

    const domains = extractDomainIoCsFromExploreData({
      exploreData: selectedRows,
      typeOfIoC: 'domain',
      queryType,
    });
    const domainsExist = !!domains && domains.length > 0;
    setHasDomain(domainsExist);

    if (domainsExist) {
      props.loadDomainEditableFeeds({
        state: typeOfContainer.toUpperCase(),
      });
    }
  }, [selectedRows]);

  return (
    <Modal
      bodyStyle={{ minHeight: 236, padding: 24 }}
      title={`Save to existing ${typeOfContainer}`}
      visible={isExploreSaveFeedCollectionModalVisible}
      okText="Save"
      okButtonProps={{
        disabled: !(
          !!selectedIPFeedCollection || !!selectedDomainFeedCollection
        ),
      }}
      onOk={() => {
        setIsExploreSaveFeedCollectionModalVisible(false);
        handleSave({
          uuidOfDomainContainer: selectedDomainFeedCollection,
          uuidOfIPContainer: selectedIPFeedCollection,
        });
        incrementUIRequestsCounter();
      }}
      onCancel={() => setIsExploreSaveFeedCollectionModalVisible(false)}
    >
      <h3
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        Add selection to existing {typeOfContainer}.{' '}
        {hasIP && hasDomain && 'At least one field is required.'}
      </h3>
      {hasDomain && (
        <div style={{ marginTop: 24 }}>
          <span
            style={{
              fontWeight: 400,
              fontSize: 14,
              marginBottom: 4,
              display: 'block',
              color: 'rgba(255, 255, 255, 0.95)',
              marginLeft: 8,
            }}
          >
            {capitalize(typeOfContainer)} for domain(s) {!hasIP && '(required)'}
          </span>
          <Select
            showSearch
            placeholder={`Select`}
            style={{ minWidth: '100%' }}
            loading={props.DomainEditableFeedsStatus != STATUS.LOADED}
            options={props?.DomainEditableFeeds?.map((filteredItem) => ({
              value: filteredItem.uuid,
              label: filteredItem.name,
            }))}
            onChange={(selectedDomainContainerUUID) =>
              setSelectedDomainFeedCollection(selectedDomainContainerUUID)
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            allowClear
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
            }
          ></Select>
        </div>
      )}
      {hasIP && (
        <div style={{ marginTop: 24 }}>
          <span
            style={{
              fontWeight: 400,
              fontSize: 14,
              marginBottom: 4,
              display: 'block',
              color: 'rgba(255, 255, 255, 0.95)',
              marginLeft: 8,
            }}
          >
            {capitalize(typeOfContainer)} for IP(s) {!hasDomain && '(required)'}
          </span>
          <Select
            showSearch
            placeholder={`Select`}
            style={{ minWidth: '100%' }}
            loading={props.IPEditableFeedsStatus != STATUS.LOADED}
            options={props?.IPEditableFeeds?.map((filteredItem) => ({
              value: filteredItem.uuid,
              label: filteredItem.name,
            }))}
            onChange={(selectedIPContainerUUID) =>
              setSelectedIPFeedCollection(selectedIPContainerUUID)
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            allowClear
            filterOption={(inputValue, option) =>
              option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
            }
          ></Select>
        </div>
      )}
    </Modal>
  );
};

const NewFeedCollectionExploreModal = ({
  isNewExploreSaveFeedCollectionModalVisible,
  setIsNewExploreSaveFeedCollectionModalVisible,
  typeOfContainer,
  handleSave,
  selectedRows,
  queryType,
}) => {
  const [hasIP, setHasIP] = useState(false);
  const [hasDomain, setHasDomain] = useState(false);

  const [nameOfDomainFeedCollection, setNameOfDomainFeedCollection] = useState(
    '',
  );
  const [nameOfIPFeedCollection, setNameOfIPFeedCollection] = useState('');
  const [containerName, setContainerName] = useState(typeOfContainer);
  const [canSave, setCanSave] = useState(false);

  useEffect(() => {
    if (!selectedRows) return () => {};
    const IPs = extractIPIoCsFromExploreData({
      exploreData: selectedRows,
      typeOfIoC: 'IP',
      queryType,
    });
    const ipExists = !!IPs && IPs.length > 0;

    setHasIP(ipExists);

    const domains = extractDomainIoCsFromExploreData({
      exploreData: selectedRows,
      typeOfIoC: 'domain',
      queryType,
    });
    const domainExists = !!domains && domains.length > 0;
    setHasDomain(domainExists);

    const shouldPluralizeContainerTitle = ipExists && domainExists;
    if (shouldPluralizeContainerTitle) {
      setContainerName(`${typeOfContainer}s`);
    } else {
      setContainerName(typeOfContainer);
    }
  }, [selectedRows]);

  useEffect(() => {
    const ipFieldSaveable = !!nameOfIPFeedCollection;
    const domainFieldSaveable = !!nameOfDomainFeedCollection;
    if (hasIP && hasDomain) {
      if (ipFieldSaveable && domainFieldSaveable) {
        if (nameOfIPFeedCollection === nameOfDomainFeedCollection) {
          setCanSave(false);
        } else {
          setCanSave(true);
        }
      } else {
        setCanSave(true);
      }
    } else if (hasIP) {
      setCanSave(ipFieldSaveable);
    } else if (hasDomain) {
      setCanSave(domainFieldSaveable);
    }
  }, [nameOfDomainFeedCollection, nameOfIPFeedCollection]);

  const distinctContainerNameValidator = (
    iocTypeOfOpposingInput,
    getFieldValue,
  ) => {
    return {
      validator(_, value) {
        if (
          getFieldValue(`${iocTypeOfOpposingInput}_${typeOfContainer}`) ===
          value
        ) {
          return Promise.reject(
            new Error(`The two ${typeOfContainer}s cannot share the same name`),
          );
        }
        return Promise.resolve();
      },
    };
  };

  return (
    <Modal
      bodyStyle={{ minHeight: 236, padding: 24 }}
      title={'Save to new ' + containerName}
      visible={isNewExploreSaveFeedCollectionModalVisible}
      okText="Save"
      okButtonProps={{
        disabled: !canSave,
      }}
      onOk={() => {
        setIsNewExploreSaveFeedCollectionModalVisible(false);
        handleSave({
          nameOfIPContainer: nameOfIPFeedCollection,
          nameOfDomainContainer: nameOfDomainFeedCollection,
        });
        incrementUIRequestsCounter();
      }}
      onCancel={() => setIsNewExploreSaveFeedCollectionModalVisible(false)}
    >
      <h3
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        Create new {containerName} for your selection.{' '}
        {hasIP && hasDomain && 'At least one field is required.'}
      </h3>
      <Form>
        {hasDomain && (
          <div style={{ marginTop: 24 }}>
            <span
              style={{
                fontWeight: 400,
                fontSize: 14,
                marginBottom: 4,
                display: 'block',
                color: 'rgba(255, 255, 255, 0.95)',
                marginLeft: 8,
              }}
            >
              Domain {typeOfContainer} name {!hasIP && '(required)'}:
            </span>
            <Form.Item
              name={`domain_${typeOfContainer}`}
              rules={
                hasIP && [
                  {
                    required: true,
                    message: `Enter domain ${typeOfContainer} name`,
                  },
                  ({ getFieldValue }) =>
                    distinctContainerNameValidator('ip', getFieldValue),
                ]
              }
            >
              <Input
                style={{ width: '100%' }}
                placeholder={`Enter ${typeOfContainer} name`}
                onChange={(event) =>
                  setNameOfDomainFeedCollection(event.target.value.trim())
                }
              />
            </Form.Item>
          </div>
        )}
        {hasIP && (
          <div style={{ marginTop: 24 }}>
            <span
              style={{
                fontWeight: 400,
                fontSize: 14,
                marginBottom: 4,
                display: 'block',
                color: 'rgba(255, 255, 255, 0.95)',
                marginLeft: 8,
              }}
            >
              IP {typeOfContainer} name {!hasDomain && '(required)'}:
            </span>
            <Form.Item
              name={`ip_${typeOfContainer}`}
              rules={
                hasDomain && [
                  {
                    required: true,
                    message: `Enter ip ${typeOfContainer} name`,
                  },
                  ({ getFieldValue }) =>
                    distinctContainerNameValidator('domain', getFieldValue),
                ]
              }
            >
              <Input
                style={{ width: '100%' }}
                placeholder={`Enter ${typeOfContainer} name`}
                onChange={(event) =>
                  setNameOfIPFeedCollection(event.target.value.trim())
                }
              />
            </Form.Item>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default HostingInfrastructureASNsResult;
